webpackJsonp([0],{

/***/ "+0R2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sb-lessons-show',
  components: {},
  data: function data() {
    return {
      item: {}
    };
  },
  created: function created() {
    this.getLesson(this.$route.params.id);
  },

  methods: {
    getLesson: function getLesson(id) {
      var _this = this;

      this.stbyLessonRepo.show(id).then(function (response) {
        _this.item = response.data.data;
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "+0Vw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table__ = __webpack_require__("WGvK");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'premade-categories-view',
    components: { PremadeCategoriesTable: __WEBPACK_IMPORTED_MODULE_1__Table__["a" /* default */] },
    data: function data() {
        return {
            premadeCategories: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1
        };
    },
    created: function created() {
        this.getPremadeCategories();
    },

    methods: {
        onSearch: function onSearch(q) {
            this.page = 1;
            this.q = q;
            this.getPremadeCategories();
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getPremadeCategories();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getPremadeCategories();
        },
        getPremadeCategories: function getPremadeCategories() {
            var _this = this;

            var data = {
                page: this.page,
                q: this.q,
                orderBy: this.orderBy
            };
            this.premadeCategoryRepo.paginate(data).then(function (response) {
                _this.premadeCategories = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "+FBS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("YNWR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_537ffafa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("U1zr");
function injectStyle (ssrContext) {
  __webpack_require__("5llc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-537ffafa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_537ffafa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+GBL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+OdD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+" \n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.created_at.date.split('.')[0]))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(item.ip_address))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(item.browser))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(item.city))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(item.country))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(item.country_code))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(item.zip_code))])])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+TdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("hTq+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d7b7968_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("VZOn");
function injectStyle (ssrContext) {
  __webpack_require__("HE7X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d7b7968"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d7b7968_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+f4n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_TicketRepo__ = __webpack_require__("407P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tickets-show',
  components: {},
  data: function data() {
    return {
      repo: new __WEBPACK_IMPORTED_MODULE_0__repos_TicketRepo__["a" /* default */](this.$auth),
      item: {}
    };
  },
  created: function created() {
    this.getUser(this.$route.params.id);
  },

  methods: {
    getUser: function getUser(id) {
      var _this = this;

      this.repo.show(id).then(function (response) {
        _this.item = response.data.data;
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "/BmC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'magic-words-add',
    components: {},
    props: {},
    data: function data() {
        return {
            loading: false,
            schools: [],
            magicWord: { schools: [] }
        };
    },
    created: function created() {
        this.loadSchools();
    },

    methods: {
        loadSchools: function loadSchools() {
            var _this = this;

            this.loading = true;
            this.schoolRepo.all().then(function (response) {
                _this.schools = response.data.data;
                _this.loading = false;
            }).catch(function (response) {
                _this.loading = false;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        },
        save: function save() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this2;
                    _this2.loading = true;
                    _this2.magicWordRepo.store(_this2.magicWord).then(function (response) {
                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/magic-words');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "/UuR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/lxc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v("Provider ID (Short format - e.g. 1-1-1, 3-4-5 )")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"provider_id","hasError":!_vm.meLessonFormat(_vm.lesson.additionalInfo.provider_id, false),"rules":"required","placeholder":"Provider id"},model:{value:(_vm.lesson.additionalInfo.provider_id),callback:function ($$v) {_vm.$set(_vm.lesson.additionalInfo, "provider_id", $$v)},expression:"lesson.additionalInfo.provider_id"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade-fast"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.meLessonFormat(_vm.lesson.additionalInfo.provider_id, false)),expression:"!meLessonFormat(lesson.additionalInfo.provider_id, false)"}],staticClass:"help is-danger"},[_vm._v("Wrong format")])]),_vm._v(" "),_c('span',[_vm._v("Example: 1-1-1, 2-3-11, 5-2-4, etc.")])],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v("Provider full ID (e.g. L1-U1-L1, L2-U3-L11)")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"provider_full_id","hasError":!_vm.meLessonFormat(_vm.lesson.additionalInfo.provider_full_id),"rules":"required","placeholder":"Provider full id"},model:{value:(_vm.lesson.additionalInfo.provider_full_id),callback:function ($$v) {_vm.$set(_vm.lesson.additionalInfo, "provider_full_id", $$v)},expression:"lesson.additionalInfo.provider_full_id"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade-fast"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.meLessonFormat(_vm.lesson.additionalInfo.provider_full_id)),expression:"!meLessonFormat(lesson.additionalInfo.provider_full_id)"}],staticClass:"help is-danger"},[_vm._v("Wrong format")])]),_vm._v(" "),_c('span',[_vm._v("Example: L1-U1-L1, L2-U3-L11, L5-U2-L4, etc.")])],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v("Lesson Name")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.lesson.additionalInfo.name),callback:function ($$v) {_vm.$set(_vm.lesson.additionalInfo, "name", $$v)},expression:"lesson.additionalInfo.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v("Words (Vocabulary)")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"words","rules":"required","placeholder":"Words"},model:{value:(_vm.lesson.additionalInfo.words),callback:function ($$v) {_vm.$set(_vm.lesson.additionalInfo, "words", $$v)},expression:"lesson.additionalInfo.words"}})],1)]),_vm._v(" "),_vm._l((_vm.lesson.additionalInfo),function(property,index){return (!_vm.excludeProperties.includes(index))?_c('div',{staticClass:"column is-6"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v(_vm._s(_vm.snakeToCamelCase(index)))]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":index,"rules":"","placeholder":_vm.snakeToCamelCase(index)},model:{value:(_vm.lesson.additionalInfo[index]),callback:function ($$v) {_vm.$set(_vm.lesson.additionalInfo, index, $$v)},expression:"lesson.additionalInfo[index]"}})],1)]):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n        Back\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/x+4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicy__ = __webpack_require__("vtOW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TermsOfUse__ = __webpack_require__("ejOc");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'register',
    components: { PrivacyPolicy: __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicy__["a" /* default */], TermsOfUse: __WEBPACK_IMPORTED_MODULE_2__TermsOfUse__["a" /* default */] },
    data: function data() {
        return {
            user: { privacy_and_terms: false },
            loading: false,
            showPrivacy: false,
            showTerms: false
        };
    },
    created: function created() {},

    methods: {
        register: function register() {
            var _this = this;

            var component = this;
            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this;
                    _this.loading = true;
                    _this.$auth.register(_this.user).then(function (response) {
                        self.loading = false;
                        self.$toast.success(response.data.message);
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response.response);
                    });
                }
            });
        }
    }

});

/***/ }),

/***/ "/x0O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0WZG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+" \n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{on:{"click":function($event){_vm.show(item.id)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),(item.profile)?_c('td',[_c('figure',{staticClass:"image is-32x32"},[_c('img',{staticClass:"round",attrs:{"src":_vm.axios.defaults.storageURL + item.profile.avatar}})])]):_vm._e(),_vm._v(" "),_c('th',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.profile && item.profile.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.profile && item.profile.nick))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.last_login))]),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'user', params: { id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])]),_vm._v(" "),_c('router-link',{staticClass:"button is-warning tooltip",attrs:{"to":{ name: 'user-edit', params: { id: item.id }},"data-tooltip":"Edit"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-edit"})])]),_vm._v(" "),_c('button',{staticClass:"button is-danger tooltip",attrs:{"data-tooltip":"Delete"},on:{"click":function($event){_vm.showDeleteModal($event, item.id, index)}}},[_vm._m(1,true)])],1):_vm._e()])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "14l0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'magic-words-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false },
        pivot: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Alias',
                key: 'alias'
            }, {
                name: 'Title',
                key: 'title'
            }, {
                name: 'Placeholder',
                key: 'placeholder'
            }, {
                name: 'Description',
                key: 'description'
            }, {
                name: 'Schools',
                key: 'universal'
            }],
            reverse: true
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        show: function show(id) {
            this.$router.push('/dashboard/magic-words/' + id);
        },
        showDeleteModal: function showDeleteModal(event, id, index) {
            event.stopPropagation();
            var self = this;
            this.$swal({
                title: 'Are you sure?',
                text: "This will delete this magic word permanently!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3273dc',
                cancelButtonColor: '#ff3860',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    self.deleteMagicWord(id, index);
                }
            }).catch(function (result) {});
        },
        deleteMagicWord: function deleteMagicWord(id, index) {
            var _this = this;

            this.magicWordRepo.delete(id).then(function (response) {
                _this.items.splice(index, 1);
                _this.$swal('Deleted!', 'Magic word has been deleted.', 'success');
            });
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "1EZa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1UrL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1eIv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-t-b-y-lesson',{attrs:{"lesson":_vm.lesson,"update":true,"disableSchool":true}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1j+s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("Z/x1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ffb1f8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("Z6AU");
function injectStyle (ssrContext) {
  __webpack_require__("bG5l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ffb1f8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ffb1f8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1zQf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("t/se");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_796d5547_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("NfQZ");
function injectStyle (ssrContext) {
  __webpack_require__("YY9u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-796d5547"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_796d5547_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "20uu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "26yX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('router-link',{staticClass:"button is-info is-pulled-right",attrs:{"to":{name: 'sb-add-lesson' }}},[_vm._v("Add new")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('lessons-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.lessons,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged,"schoolChanged":_vm.onSchoolChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" StandBy Lessons")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Jb/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.category.name),callback:function ($$v) {_vm.$set(_vm.category, "name", $$v)},expression:"category.name"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v(" Categories")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2eNb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_UserRepo__ = __webpack_require__("lyrB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_AffiliateRepo__ = __webpack_require__("ihfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Table__ = __webpack_require__("p1FB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'affiliates-view',
    components: { AffiliatesTable: __WEBPACK_IMPORTED_MODULE_3__Table__["a" /* default */] },
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_UserRepo__["a" /* default */](this.$auth),
            affiliateRepo: new __WEBPACK_IMPORTED_MODULE_1__repos_AffiliateRepo__["a" /* default */](this.$auth),
            affiliates: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
            stats: {
                referrals: 0,
                earned: 0.00,
                current: 0.00
            }
        };
    },
    created: function created() {
        this.getAffiliate();
        this.getStats();
    },

    methods: {
        onSearch: function onSearch(q) {
            this.page = 1;
            this.q = q;
            this.getAffiliate();
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getAffiliate();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getAffiliate();
        },
        getAffiliate: function getAffiliate() {
            var _this = this;

            this.repo.myAffiliatePaginate(this.page, this.q, this.orderBy).then(function (response) {
                _this.affiliates = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        },
        getStats: function getStats() {
            var _this2 = this;

            this.affiliateRepo.myStats().then(function (response) {
                _this2.stats = response.data.data;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "2nGI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_AffiliateRepo__ = __webpack_require__("ihfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'affiliate-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false },
        pivot: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: ''
            }, {
                name: 'Teacher',
                key: 'teacher'
            }, {
                name: 'Earned',
                key: 'fee'
            }, {
                name: 'Status',
                key: 'status'
            }, {
                name: 'Payout date',
                key: 'payout_date'
            }],
            reverse: true,
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_AffiliateRepo__["a" /* default */](this.$auth)
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "2vfZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3/g/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("y4kg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d865e5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("Vj6b");
function injectStyle (ssrContext) {
  __webpack_require__("QqJJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d865e5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d865e5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "33Ry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdditionalInfo_vue__ = __webpack_require__("vb1P");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'me-lesson',
  components: { AdditionalInfo: __WEBPACK_IMPORTED_MODULE_1__AdditionalInfo_vue__["a" /* default */] },
  props: {
    lessonForUpdate: { required: true },
    loading: { required: true, default: false }
  },
  data: function data() {
    return {
      lesson: {},
      excludeProperties: ['id', 'name', 'words', 'provider_full_id', 'provider_id']
    };
  },
  created: function created() {
    this.lesson = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.lessonForUpdate);
    if (!this.lesson.id) {
      this.lesson.additionalInfo = this.meDefaultAdditionalInfo();
    }
  },

  methods: {
    save: function save() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          if (!_this.meLessonFormat(_this.lesson.additionalInfo.provider_full_id) || !_this.meLessonFormat(_this.lesson.additionalInfo.provider_id, false)) {
            return;
          }
          _this.$emit('save', _this.lesson);
        }
      });
    },
    onChange: function onChange(additionalInfo) {}
  },
  watch: {

    lessonForUpdate: function lessonForUpdate(lesson) {
      this.lesson = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, lesson);
    }

  }

});

/***/ }),

/***/ "3MKM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryList_vue__ = __webpack_require__("U32u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17cdf17f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryList_vue__ = __webpack_require__("z/A4");
function injectStyle (ssrContext) {
  __webpack_require__("LstL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17cdf17f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17cdf17f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3a6P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_swatches__ = __webpack_require__("gQ/s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_swatches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_swatches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'premade-categories-add',
    components: { Swatches: __WEBPACK_IMPORTED_MODULE_1_vue_swatches___default.a },
    props: {},
    data: function data() {
        return {
            loading: false,
            schools: [],
            premadeCategory: { schools: [], color: '#3D4351', text_color: '#00d1b2' }
        };
    },
    created: function created() {
        this.loadSchools();
    },

    methods: {
        loadSchools: function loadSchools() {
            var _this = this;

            this.loading = true;
            this.schoolRepo.all().then(function (response) {
                _this.schools = response.data.data;
                _this.loading = false;
            }).catch(function (response) {
                _this.loading = false;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        },
        save: function save() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this2;
                    _this2.loading = true;
                    _this2.premadeCategoryRepo.store(_this2.premadeCategory).then(function (response) {
                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/premade-categories');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "3h0n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3yEL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_SchoolRepo__ = __webpack_require__("gh8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'schools-edit',
    components: {},
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_SchoolRepo__["a" /* default */](this.$auth),
            loading: false,
            schools: [],
            school: {}
        };
    },
    created: function created() {
        this.getSchool(this.$route.params.id);
    },

    methods: {
        getSchool: function getSchool(id) {
            var _this = this;

            this.repo.show(id).then(function (response) {
                _this.school = response.data.data;
            });
        },
        save: function save() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this2;
                    _this2.loading = true;

                    _this2.repo.update(_this2.school.id, _this2.school).then(function (response) {

                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/schools');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "407P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Http__ = __webpack_require__("OK7G");



/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES


// private sector
var $http = void 0;

//public sector

var TicketRepo = function () {
    function TicketRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TicketRepo);

        $http = new __WEBPACK_IMPORTED_MODULE_3__services_Http__["a" /* default */]($auth);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TicketRepo, [{
        key: 'show',
        value: function show(id) {
            return $http.get(TicketRepo.$resource + "/" + id + "?include=user").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'store',
        value: function store(data) {
            return $http.post(TicketRepo.$resource, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'all',
        value: function all() {
            return $http.get(TicketRepo.$resource + "?include=user").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'paginate',
        value: function paginate(page, q, orderBy) {
            var query = "page=" + page + "&include=user";
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(TicketRepo.$resource + "/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'update',
        value: function update(id, data) {
            return $http.put(TicketRepo.$resource + "/" + id, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            return $http.delete(TicketRepo.$resource + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }]);

    return TicketRepo;
}();

TicketRepo.$resource = 'support-tickets';
TicketRepo.$me = '/me';
/* harmony default export */ __webpack_exports__["a"] = (TicketRepo);

/***/ }),

/***/ "44hd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Cux":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "55ej":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5KOb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Kc/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table__ = __webpack_require__("+FBS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'premade-sentences-view',
    components: { PremadeSentencesTable: __WEBPACK_IMPORTED_MODULE_1__Table__["a" /* default */] },
    data: function data() {
        return {
            premadeSentences: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1
        };
    },
    created: function created() {
        this.getPremadeSentences();
    },

    methods: {
        onSearch: function onSearch(q) {
            this.page = 1;
            this.q = q;
            this.getPremadeSentences();
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getPremadeSentences();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getPremadeSentences();
        },
        getPremadeSentences: function getPremadeSentences() {
            var _this = this;

            var data = {
                page: this.page,
                q: this.q,
                orderBy: this.orderBy
            };
            this.premadeSentenceRepo.paginate(data).then(function (response) {
                _this.premadeSentences = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "5ObJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'premade-sentences-show',
  components: {},
  data: function data() {
    return {
      item: {}
    };
  },
  created: function created() {
    this.getPremadeSentence(this.$route.params.id);
  },

  methods: {
    getPremadeSentence: function getPremadeSentence(id) {
      var _this = this;

      this.premadeSentenceRepo.get(id).then(function (response) {
        _this.item = response.data.data;
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "5Q78":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingButton_vue__ = __webpack_require__("gSOa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a91146c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingButton_vue__ = __webpack_require__("muyx");
function injectStyle (ssrContext) {
  __webpack_require__("zBwC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a91146c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a91146c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-t-b-y-lesson',{attrs:{"lesson":_vm.lesson}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5jPT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('router-link',{staticClass:"button is-info is-pulled-right",attrs:{"to":{name: 'add-magic-word' }}},[_vm._v("Add new")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('magic-words-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.magicWords,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v("Magic Words")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5llc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5o/F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.item),function(property,index){return (!['original', 'id', 'status'].includes(index))?_c('div',{staticClass:"column is-6 card"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.snakeToCamelCase(index))+":")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('b',{staticClass:"aquamarine"},[_vm._v("NEW: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(property))]),_vm._v(" "),_c('br'),_c('b',{staticClass:"deeppink"},[_vm._v("OLD: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.item.original[index]))])])])]):_vm._e()}),0),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_vm._m(1),_vm._v(" "),(_vm.item.status == 'requested')?_c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-primary tooltip is-fullwidth",attrs:{"data-tooltip":"Approve"},on:{"click":function($event){_vm.approve(_vm.item)}}},[_c('span',[_vm._v("Approve")]),_vm._v(" "),_vm._m(2)])]):_vm._e(),_vm._v(" "),(_vm.item.status == 'requested')?_c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-danger tooltip is-fullwidth",attrs:{"data-tooltip":"Decline"},on:{"click":function($event){_vm.decline(_vm.item)}}},[_c('span',[_vm._v("Decline")]),_vm._v(" "),_vm._m(3)])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" StandBy Lessons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",attrs:{"data-tooltip":"Approve"}},[_c('i',{staticClass:"fa fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",attrs:{"data-tooltip":"Decline"}},[_c('i',{staticClass:"fa fa-times"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5qyO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5sB1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Http__ = __webpack_require__("OK7G");



/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES


// private sector
var $http = void 0;

//public sector

var SentenceRepo = function () {
    function SentenceRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SentenceRepo);

        $http = new __WEBPACK_IMPORTED_MODULE_3__services_Http__["a" /* default */]($auth);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SentenceRepo, [{
        key: 'show',
        value: function show(id) {
            return $http.get(SentenceRepo.$resource + "/" + id + "?include=user.profile,categories").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'store',
        value: function store(data) {
            return $http.post(SentenceRepo.$resource, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'all',
        value: function all() {
            return $http.get(SentenceRepo.$resource + "?include=user.profile,categories").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'paginate',
        value: function paginate(page, q, orderBy) {
            var query = "page=" + page + "&include=user.profile,categories";
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(SentenceRepo.$resource + "/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'update',
        value: function update(id, data) {
            return $http.put(SentenceRepo.$resource + "/" + id, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            return $http.delete(SentenceRepo.$resource + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }]);

    return SentenceRepo;
}();

SentenceRepo.$resource = 'sentences';
/* harmony default export */ __webpack_exports__["a"] = (SentenceRepo);

/***/ }),

/***/ "5sHQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicInput__ = __webpack_require__("f8TI");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BasicInput__["a" /* default */]],

  props: {
    alignment: String
  }
});

/***/ }),

/***/ "5umN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "66zg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("haNX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a71ac2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("heRp");
function injectStyle (ssrContext) {
  __webpack_require__("mIBR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09a71ac2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a71ac2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Snt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sb-lessons-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false }
        //schools: {required: false, default: []}
    },
    components: {},
    data: function data() {
        return {
            search: '',
            school: {},
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Provider id',
                key: 'provider_id'
            }, {
                name: 'Name',
                key: 'name'
            }, {
                name: 'Words',
                key: 'words'
            }, {
                name: 'School',
                key: 'school.name'
            }],
            reverse: true
        };
    },
    created: function created() {
        if (this.schools.length == 0) {
            this.loadSchools();
        }
    },

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        onSchoolChanged: function onSchoolChanged(page) {
            this.$emit("schoolChanged", page);
        },
        show: function show(id) {
            this.$router.push('/dashboard/' + 'sb-lessons/' + id);
        },
        showDeleteModal: function showDeleteModal(event, id, index) {
            event.stopPropagation();
            var self = this;
            this.$swal({
                title: 'Are you sure?',
                text: "This will delete this lesson permanently!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3273dc',
                cancelButtonColor: '#ff3860',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    self.deleteLesson(id, index);
                }
            }).catch(function (result) {});
        },
        deleteLesson: function deleteLesson(id, index) {
            var _this = this;

            this.stbyLessonRepo.delete(id).then(function (response) {
                _this.items.splice(index, 1);
                _this.$swal('Deleted!', 'Lesson has been deleted.', 'success');
            });
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800),

        'schools': function schools(_schools) {
            if (_schools.length > 0) {
                this.school = _schools[0];
            }
            //this.stbySchools(this.schools);
        },

        'school': function school(_school) {
            this.onSchoolChanged(_school.id);
        }
    },
    computed: {}
});

/***/ }),

/***/ "6ZQ/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7FxH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7IV6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('router-link',{staticClass:"button is-info is-pulled-right",attrs:{"to":{name: 'add-student' }}},[_vm._v("Add new")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('students-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.students,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-user-circle"}),_vm._v(" Students")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7YfP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7ZMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("rHEA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47133206_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("eJRy");
function injectStyle (ssrContext) {
  __webpack_require__("ynAE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47133206"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47133206_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7uSr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+" \n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{on:{"click":function($event){_vm.show(item.id)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.provider_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.words))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.school && item.school.name))]),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'lesson', params: { id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])]),_vm._v(" "),_c('router-link',{staticClass:"button is-warning tooltip",attrs:{"to":{ name: 'lesson-edit', params: { id: item.id }},"data-tooltip":"Edit"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-edit"})])]),_vm._v(" "),_c('button',{staticClass:"button is-danger tooltip",attrs:{"data-tooltip":"Delete"},on:{"click":function($event){_vm.showDeleteModal($event, item.id, index)}}},[_vm._m(1,true)])],1):_vm._e()])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7vHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Http__ = __webpack_require__("OK7G");



/**
 * Created by Dinkic on 3/7/2018.
 */
// SERVICES


//public sector

var Repo = function () {
    function Repo($auth, resource) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Repo);

        this.http = new __WEBPACK_IMPORTED_MODULE_3__services_Http__["a" /* default */]($auth);
        this.resource = resource;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Repo, [{
        key: "store",
        value: function store(data) {
            var include = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            return this.http.post(this.resource + "?include=" + include, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: "update",
        value: function update(id, data) {
            var include = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

            return this.http.put(this.resource + "/" + id + "?include=" + include, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: "get",
        value: function get(id) {
            var include = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            return this.http.get(this.resource + "/" + id + "?include=").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: "all",
        value: function all() {
            var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var include = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            var url = this.resource + "?include=" + include;

            if (q !== undefined) {
                url = url + "&q=" + q;
            }
            return this.http.get(url).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: "delete",
        value: function _delete(id) {
            return this.http.delete(this.resource + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: "search",
        value: function search(data) {
            var include = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            return this.http.post(this.resource + "/search" + "?include=" + include, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: "paginate",
        value: function paginate(data) {
            return this.http.post(this.resource + "/paginate", data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }]);

    return Repo;
}();

/* harmony default export */ __webpack_exports__["a"] = (Repo);

/***/ }),

/***/ "8EU+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Title:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.Title))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Description:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.description))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Type:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.type))])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"columns box is-multiline"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.item.text)}})])])]),_vm._v(" "),_c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('router-link',{staticClass:"button is-block is-warning",attrs:{"to":{ name: 'news-edit', params: { id: _vm.item.id }}}},[_vm._v("\n                Edit\n            ")])],1),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" News")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-12"},[_c('hr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                Back\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8UkF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8lGO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('router-link',{staticClass:"button is-info is-pulled-right",attrs:{"to":{name: 'add-premade-comment' }}},[_vm._v("Add new")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('premade-comments-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.premadeComments,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Premade Comments")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8m/A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('router-link',{staticClass:"button is-info is-pulled-right",attrs:{"to":{name: 'add-premade-category' }}},[_vm._v("Add new")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('premade-categories-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.premadeCategories,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v("Premade Categories")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8rVm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("a/qe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc461b5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("8EU+");
function injectStyle (ssrContext) {
  __webpack_require__("gcbH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc461b5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc461b5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "94/9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Http__ = __webpack_require__("OK7G");



/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES


// private sector
var $http = void 0;

//public sector

var CategoryRepo = function () {
    function CategoryRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CategoryRepo);

        $http = new __WEBPACK_IMPORTED_MODULE_3__services_Http__["a" /* default */]($auth);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CategoryRepo, [{
        key: 'show',
        value: function show(id) {
            return $http.get(CategoryRepo.$resource + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'store',
        value: function store(data) {
            return $http.post(CategoryRepo.$resource, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'all',
        value: function all() {
            return $http.get(CategoryRepo.$resource).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'paginate',
        value: function paginate(page, q, orderBy) {
            var query = "page=" + page;
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(CategoryRepo.$resource + "/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'update',
        value: function update(id, data) {
            return $http.put(CategoryRepo.$resource + "/" + id, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            return $http.delete(CategoryRepo.$resource + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }]);

    return CategoryRepo;
}();

CategoryRepo.$resource = 'categories';
/* harmony default export */ __webpack_exports__["a"] = (CategoryRepo);

/***/ }),

/***/ "9fRL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_TicketRepo__ = __webpack_require__("407P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'tickets-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Email',
                key: ''
            }, {
                name: 'Title',
                key: 'title'
            }, {
                name: 'Category',
                key: 'category'
            }, {
                name: 'Content',
                key: 'content'
            }, {
                name: 'Is Teacher?',
                key: ''
            }],
            reverse: true,
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_TicketRepo__["a" /* default */](this.$auth)
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        show: function show(id) {
            this.$router.push('/dashboard/tickets/' + id);
        },
        showDeleteModal: function showDeleteModal(event, id, index) {
            event.stopPropagation();
            var self = this;
            this.$swal({
                title: 'Are you sure?',
                text: "This will delete this ticket permanently!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3273dc',
                cancelButtonColor: '#ff3860',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    self.deleteTicket(id, index);
                }
            }).catch(function (result) {});
        },
        deleteTicket: function deleteTicket(id, index) {
            var _this = this;

            this.repo.delete(id).then(function (response) {
                _this.items.splice(index, 1);
                _this.$swal('Deleted!', 'Ticket has been deleted.', 'success');
            });
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "9jgr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('router-link',{staticClass:"button is-info is-pulled-right",attrs:{"to":{name: 'add-premade-sentence' }}},[_vm._v("Add new")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('premade-sentences-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.premadeSentences,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Premade Sentences")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A3xT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_LessonRepo__ = __webpack_require__("VMRg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lessons-show',
  components: {},
  data: function data() {
    return {
      repo: new __WEBPACK_IMPORTED_MODULE_0__repos_LessonRepo__["a" /* default */](this.$auth),
      item: {}
    };
  },
  created: function created() {
    this.getLesson(this.$route.params.id);
  },

  methods: {
    getLesson: function getLesson(id) {
      var _this = this;

      this.repo.show(id).then(function (response) {
        _this.item = response.data.data;
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "A64A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ARc3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AfLX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table__ = __webpack_require__("DB0I");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'premade-comments-view',
    components: { PremadeCommentsTable: __WEBPACK_IMPORTED_MODULE_1__Table__["a" /* default */] },
    data: function data() {
        return {
            premadeComments: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1
        };
    },
    created: function created() {
        this.getPremadeComments();
    },

    methods: {
        onSearch: function onSearch(q) {
            this.page = 1;
            this.q = q;
            this.getPremadeComments();
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getPremadeComments();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getPremadeComments();
        },
        getPremadeComments: function getPremadeComments() {
            var _this = this;

            var data = {
                page: this.page,
                q: this.q,
                orderBy: this.orderBy
            };
            this.premadeCommentRepo.paginate(data).then(function (response) {
                _this.premadeComments = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "AkO4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'bulma-pagination',
    props: {
        last: { required: true },
        current: { required: true }
    },
    data: function data() {
        return {};
    },

    methods: {
        next: function next() {
            this.page(this.current + 1);
        },
        prev: function prev() {
            this.page(this.current - 1);
        },
        page: function page(_page) {
            if (_page > 0 && _page <= this.last) {
                //this.current = page;
                this.$emit("change", _page);
            }
        }
    },
    mounted: function mounted() {},

    watch: {
        last: function last(value) {
            this.current = 1;
        }
    },
    computed: {}
});

/***/ }),

/***/ "Alf+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AzH8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_STBYLesson__ = __webpack_require__("tiiL");
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stby-lessons-add',
  components: { STBYLesson: __WEBPACK_IMPORTED_MODULE_0__components_STBYLesson__["a" /* default */] },
  data: function data() {
    return {
      lesson: { additionalInfo: { name: '', provider_id: '', provider_full_id: '', words: '' } }
    };
  },
  created: function created() {},

  methods: {},
  watch: {}

});

/***/ }),

/***/ "B8jK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BBYK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BRyG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("9fRL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77a8f408_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("iojL");
function injectStyle (ssrContext) {
  __webpack_require__("Z8zg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77a8f408"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77a8f408_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BSY3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CategoryItem',
    components: {},
    props: ['category', 'selected'],
    data: function data() {
        return {
            normalStyle: { 'color': this.category.color, 'border-color': this.category.color },
            selectedStyle: { 'background-color': this.category.color, 'color': this.category.text_color },
            style: {}
        };
    },
    created: function created() {
        if (!this.selected) {
            this.setNormalStyle();
        } else {
            this.setSelectedStyle();
        }
    },
    mounted: function mounted() {},

    methods: {
        toggleClick: function toggleClick() {
            this.$emit('click', this.category);
        },
        setSelectedStyle: function setSelectedStyle() {
            this.style = this.selectedStyle;
        },
        setNormalStyle: function setNormalStyle() {
            if (!this.selected) {
                this.style = this.normalStyle;
            }
        }
    },
    watch: {
        'selected': function selected(val) {
            if (!val) {
                this.setNormalStyle();
            } else {
                this.setSelectedStyle();
            }
        }
    }

});

/***/ }),

/***/ "BSq8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('router-link',{staticClass:"button is-info is-pulled-right",attrs:{"to":{name: 'add-news' }}},[_vm._v("Add new")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('news-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.news,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" News")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bhag":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"register"}},[_c('section',{staticClass:"hero is-success is-fullheight"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('div',{staticClass:"column is-4 is-offset-4"},[_c('h3',{staticClass:"title has-text-grey"},[_vm._v("Hey tutor!")]),_vm._v(" "),_c('p',{staticClass:"subtitle has-text-grey"},[_vm._v("Ready to improve the way you write comments?")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('figure',{staticClass:"avatar"},[_c('img',{attrs:{"src":'/static/img/logo.png'}})]),_vm._v(" "),_c('form',[_c('div',{staticClass:"title is-5 has-text-left has-text-grey-dark"},[_vm._v(" Enter your details below ")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"email","rules":"required|email","placeholder":"Your email"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Your name"},model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"nick","rules":"required","placeholder":"Your nickname"},model:{value:(_vm.user.nick),callback:function ($$v) {_vm.$set(_vm.user, "nick", $$v)},expression:"user.nick"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"type":"password","name":"password","rules":"required|min:6","placeholder":"Your password"},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"type":"password","name":"password_confirmation","rules":"required","placeholder":"Confirm your password"},model:{value:(_vm.user.password_confirmation),callback:function ($$v) {_vm.$set(_vm.user, "password_confirmation", $$v)},expression:"user.password_confirmation"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.privacy_and_terms),expression:"user.privacy_and_terms"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.user.privacy_and_terms)?_vm._i(_vm.user.privacy_and_terms,null)>-1:(_vm.user.privacy_and_terms)},on:{"change":function($event){var $$a=_vm.user.privacy_and_terms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user, "privacy_and_terms", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user, "privacy_and_terms", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user, "privacy_and_terms", $$c)}}}}),_vm._v("\n                          I agree to "),_c('a',{staticClass:"has-text-primary",attrs:{"href":"#"},on:{"click":function($event){_vm.showPrivacy = true}}},[_c('b',[_vm._v("Privacy Policy")])]),_vm._v(" and "),_c('a',{staticClass:"has-text-primary",attrs:{"href":"#"},on:{"click":function($event){_vm.showTerms = true}}},[_c('b',[_vm._v("Terms of Use")])])])]),_vm._v(" "),_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-danger"},on:{"click":function($event){_vm.register()}}},[_vm._v("Sign up")])],1)]),_vm._v(" "),_c('p',{staticClass:"has-text-grey"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("\n                  Login\n              ")]),_vm._v("  · \n              "),_c('router-link',{attrs:{"to":"/forgot/password"}},[_vm._v("\n                  Forgot password?\n              ")])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"modal",class:{'is-active': (_vm.showPrivacy || _vm.showTerms)}},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('section',{staticClass:"modal-card-body"},[(_vm.showPrivacy)?_c('privacy-policy'):_vm._e(),_vm._v(" "),(_vm.showTerms)?_c('terms-of-use'):_vm._e()],1),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot has-text-right"},[_c('button',{staticClass:"button is-danger is-pulled-right",on:{"click":function($event){_vm.showPrivacy = _vm.showTerms = false}}},[_vm._v("Cancel")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bw0s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"input",class:_vm.inputClass,attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C83k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("sh1o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8db341_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("qd0V");
function injectStyle (ssrContext) {
  __webpack_require__("rc42")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d8db341"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8db341_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CB5X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table__ = __webpack_require__("GolO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'magic-words-view',
    components: { MagicWordsTable: __WEBPACK_IMPORTED_MODULE_1__Table__["a" /* default */] },
    data: function data() {
        return {
            magicWords: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1
        };
    },
    created: function created() {
        this.getMagicWords();
    },

    methods: {
        onSearch: function onSearch(q) {
            this.page = 1;
            this.q = q;
            this.getMagicWords();
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getMagicWords();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getMagicWords();
        },
        getMagicWords: function getMagicWords() {
            var _this = this;

            var data = {
                page: this.page,
                q: this.q,
                orderBy: this.orderBy
            };
            this.magicWordRepo.paginate(data).then(function (response) {
                _this.magicWords = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "CJfM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_SchoolRepo__ = __webpack_require__("gh8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table__ = __webpack_require__("KqJy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'schools-view',
    components: { SchoolsTable: __WEBPACK_IMPORTED_MODULE_2__Table__["a" /* default */] },
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_SchoolRepo__["a" /* default */](this.$auth),
            schools: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1
        };
    },
    created: function created() {
        this.getSchools();
    },

    methods: {
        onSearch: function onSearch(q) {
            this.page = 1;
            this.q = q;
            this.getSchools();
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getSchools();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getSchools();
        },
        getSchools: function getSchools() {
            var _this = this;

            this.repo.paginate(this.page, this.q, this.orderBy).then(function (response) {
                _this.schools = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "CSv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Http__ = __webpack_require__("OK7G");




/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES


// private sector
var $http = void 0;

//public sector

var StudentRepo = function () {
    function StudentRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, StudentRepo);

        $http = new __WEBPACK_IMPORTED_MODULE_3__services_Http__["a" /* default */]($auth);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(StudentRepo, [{
        key: 'show',
        value: function show(id) {
            return $http.get(StudentRepo.$resource + "/" + id + "?include=school").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'store',
        value: function store(data) {
            return $http.post(StudentRepo.$resource, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'all',
        value: function all() {
            return $http.get(StudentRepo.$resource + "?include=school").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'paginate',
        value: function paginate(page, q, orderBy) {
            var query = "page=" + page + "&include=school";
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(StudentRepo.$resource + "/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'update',
        value: function update(id, data) {
            return $http.put(StudentRepo.$resource + "/" + id, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            return $http.delete(StudentRepo.$resource + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }]);

    return StudentRepo;
}();

StudentRepo.$resource = 'students';
/* harmony default export */ __webpack_exports__["a"] = (StudentRepo);

/***/ }),

/***/ "CXuH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'magic-word-show',
  components: {},
  data: function data() {
    return {
      item: {}
    };
  },
  created: function created() {
    this.getMagicWord(this.$route.params.id);
  },

  methods: {
    getMagicWord: function getMagicWord(id) {
      var _this = this;

      this.magicWordRepo.get(id).then(function (response) {
        _this.item = response.data.data;
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "CZxE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("FiTM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67205af3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("vlJ2");
function injectStyle (ssrContext) {
  __webpack_require__("5qyO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67205af3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67205af3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CjfJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("k12i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a9ceb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("2Jb/");
function injectStyle (ssrContext) {
  __webpack_require__("NCNF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57a9ceb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a9ceb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CqXx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cu96":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Z8QD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2bf04ef4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("WImk");
function injectStyle (ssrContext) {
  __webpack_require__("1EZa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2bf04ef4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D7Mm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DB0I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("rPOL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb58f88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("yk8T");
function injectStyle (ssrContext) {
  __webpack_require__("B8jK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cb58f88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb58f88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DHWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("PAWM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e1fc33e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("mEtE");
function injectStyle (ssrContext) {
  __webpack_require__("gjd/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e1fc33e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e1fc33e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DsCb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("CJfM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2de8d62e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("jlxw");
function injectStyle (ssrContext) {
  __webpack_require__("qOY+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2de8d62e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2de8d62e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DtX9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("AzH8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ce8035d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("5aTV");
function injectStyle (ssrContext) {
  __webpack_require__("xwSX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ce8035d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ce8035d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E0hG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Email:")]),_vm._v(" "),_c('div',{staticClass:"control"},[(_vm.item.user)?_c('span',[_vm._v(_vm._s(_vm.item.user.email))]):_c('span',[_vm._v(_vm._s(_vm.item.email))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Title:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.title))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Category:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.category))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Content:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.content))])])])]),_vm._v(" "),(_vm.item.user && _vm.item.user.profile)?_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Is teacher?")]),_vm._v(" "),_c('div',{staticClass:"control"},[(_vm.item.user)?_c('i',{staticClass:"fa fa-check has-text-success"}):_c('i',{staticClass:"fa fa-times has-text-danger"})])])]):_vm._e(),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-envelope"}),_vm._v(" Tickets")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                Back\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EsnJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("5Kc/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf50982_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("9jgr");
function injectStyle (ssrContext) {
  __webpack_require__("rD+/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bf50982"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf50982_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EuV6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Provider id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.provider_id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Name:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.name))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Words:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.words))])])])]),_vm._v(" "),(_vm.item.school)?_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("School:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.school.name))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('router-link',{staticClass:"button is-block is-warning",attrs:{"to":{ name: 'lesson-edit', params: { id: _vm.item.id }}}},[_vm._v("\n                Edit\n            ")])],1),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" Lessons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                Back\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F5Ud":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FJx8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.last > 1)?_c('nav',{staticClass:"pagination is-centered",attrs:{"role":"navigation","aria-label":"pagination"}},[_c('a',{staticClass:"pagination-previous",attrs:{"href":"javascript:{}","disabled":_vm.current <= 1},on:{"click":function($event){_vm.prev()}}},[_c('i',{staticClass:"fa fa-chevron-left"})]),_vm._v(" "),_c('a',{staticClass:"pagination-next",attrs:{"href":"javascript:{}","disabled":_vm.current >= _vm.last},on:{"click":function($event){_vm.next()}}},[_c('i',{staticClass:"fa fa-chevron-right"})]),_vm._v(" "),_c('ul',{staticClass:"pagination-list"},[_c('li',{on:{"click":function($event){_vm.page(1)}}},[(_vm.current > 2)?_c('a',{staticClass:"pagination-link",attrs:{"aria-label":"Goto page 1"}},[_vm._v("1")]):_vm._e()]),_vm._v(" "),_c('li',[(_vm.current > 2 && _vm.last > 4)?_c('span',{staticClass:"pagination-ellipsis"},[_vm._v("…")]):_vm._e()]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.prev()}}},[(_vm.current > 1)?_c('a',{staticClass:"pagination-link"},[_vm._v(_vm._s(_vm.current - 1))]):_vm._e()]),_vm._v(" "),_c('li',[_c('a',{staticClass:"pagination-link is-current",attrs:{"aria-current":"page"}},[_vm._v(_vm._s(_vm.current))])]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.next()}}},[(_vm.current < _vm.last - 1)?_c('a',{staticClass:"pagination-link"},[_vm._v(_vm._s(_vm.current + 1))]):_vm._e()]),_vm._v(" "),_c('li',[(_vm.current < _vm.last  && _vm.last > 4)?_c('span',{staticClass:"pagination-ellipsis"},[_vm._v("…")]):_vm._e()]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.page(_vm.last)}}},[(_vm.current < _vm.last)?_c('a',{staticClass:"pagination-link"},[_vm._v(_vm._s(_vm.last))]):_vm._e()])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FMUe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FS6n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_LessonRepo__ = __webpack_require__("VMRg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table__ = __webpack_require__("zq20");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lessons-view',
  components: { LessonsTable: __WEBPACK_IMPORTED_MODULE_2__Table__["a" /* default */] },
  data: function data() {
    return {
      repo: new __WEBPACK_IMPORTED_MODULE_0__repos_LessonRepo__["a" /* default */](this.$auth),
      lessons: [],
      total: 0,
      q: '',
      orderBy: 'id,asc',
      page: 1
    };
  },
  created: function created() {
    this.getLessons();
  },

  methods: {
    onSearch: function onSearch(q) {
      this.page = 1;
      this.q = q;
      this.getLessons();
    },
    onOrderBy: function onOrderBy(orderBy) {
      this.page = 1;
      this.orderBy = orderBy;
      this.getLessons();
    },
    onPageChanged: function onPageChanged(page) {
      this.page = page;
      this.getLessons();
    },
    getLessons: function getLessons() {
      var _this = this;

      var data = {
        page: this.page,
        query: this.q,
        orderBy: this.orderBy
        //school_id: this.school_id
      };
      this.repo.paginate(data).then(function (response) {
        _this.lessons = response.data.data;
        _this.total = response.data.meta.pagination.total_pages;
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "FfLQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("X9zB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_064e42ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("HSFr");
function injectStyle (ssrContext) {
  __webpack_require__("t6hQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-064e42ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_064e42ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FhEh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("tQP6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a156d30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("nsFj");
function injectStyle (ssrContext) {
  __webpack_require__("keUM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a156d30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a156d30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FiTM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_StudentRepo__ = __webpack_require__("CSv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repos_SchoolRepo__ = __webpack_require__("gh8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'students-add',
    components: {},
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_StudentRepo__["a" /* default */](this.$auth),
            schoolRepo: new __WEBPACK_IMPORTED_MODULE_2__repos_SchoolRepo__["a" /* default */](this.$auth),
            loading: false,
            schools: [],
            student: { gender: "male" }
        };
    },
    created: function created() {
        this.getSchools();
    },

    methods: {
        getSchools: function getSchools() {
            var _this = this;

            this.schoolRepo.all().then(function (response) {
                _this.schools = response.data.data;
                if (_this.schools && _this.schools.length > 0) {
                    _this.student.school_id = _this.schools[0].id;
                }
            });
        },
        save: function save() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this2;
                    _this2.loading = true;
                    _this2.repo.store(_this2.student).then(function (response) {
                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/students');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "FzJF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GDBq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__("yEsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__repos_Repo__ = __webpack_require__("7vHs");






/**
 * Created by ndzak on 4/23/2016.
 */



var MagicWordRepo = function (_Repo) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(MagicWordRepo, _Repo);

    function MagicWordRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MagicWordRepo);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MagicWordRepo.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MagicWordRepo)).call(this, $auth, 'magic-words'));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MagicWordRepo, [{
        key: 'all',
        value: function all(q) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(MagicWordRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MagicWordRepo.prototype), 'all', this).call(this, q, "");
        }
    }, {
        key: 'store',
        value: function store(data) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(MagicWordRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MagicWordRepo.prototype), 'store', this).call(this, data, "");
        }
    }, {
        key: 'update',
        value: function update(id, data) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(MagicWordRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MagicWordRepo.prototype), 'update', this).call(this, id, data, "");
        }
    }, {
        key: 'get',
        value: function get(id) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(MagicWordRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MagicWordRepo.prototype), 'get', this).call(this, id, "");
        }
    }]);

    return MagicWordRepo;
}(__WEBPACK_IMPORTED_MODULE_6__repos_Repo__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MagicWordRepo);

/***/ }),

/***/ "GWl8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_CategoryRepo__ = __webpack_require__("94/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table__ = __webpack_require__("1j+s");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'categories-view',
    components: { CategoriesTable: __WEBPACK_IMPORTED_MODULE_2__Table__["a" /* default */] },
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_CategoryRepo__["a" /* default */](this.$auth),
            categories: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1
        };
    },
    created: function created() {
        this.getCategories();
    },

    methods: {
        onSearch: function onSearch(q) {
            this.page = 1;
            this.q = q;
            this.getCategories();
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getCategories();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getCategories();
        },
        getCategories: function getCategories() {
            var _this = this;

            this.repo.paginate(this.page, this.q, this.orderBy).then(function (response) {
                _this.categories = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "Gb8L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("daTW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57089e46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("hObb");
function injectStyle (ssrContext) {
  __webpack_require__("iyH7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57089e46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57089e46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GnK6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"control"},[(_vm.type == 'text')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.rules),expression:"rules"}],class:{'input': true, 'is-danger': _vm.errors.has(_vm.name) || _vm.hasError },attrs:{"name":_vm.name,"id":_vm.name,"type":"text","placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.updateData}}):_vm._e(),_vm._v(" "),(_vm.type == 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"},{name:"validate",rawName:"v-validate",value:(_vm.rules),expression:"rules"}],class:{'input': true, 'is-danger': _vm.errors.has(_vm.name) },attrs:{"name":_vm.name,"id":_vm.name,"type":"password","placeholder":_vm.placeholder},domProps:{"value":(_vm.model)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.model=$event.target.value},_vm.updateData]}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade-fast"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.errorName)),expression:"errors.has(errorName)"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errorMsg(_vm.errors.first(_vm.errorName))))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GolO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("14l0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a36c6dbc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("HXoX");
function injectStyle (ssrContext) {
  __webpack_require__("FzJF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a36c6dbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a36c6dbc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gom6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('section',{staticClass:"hero is-success is-fullheight"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('div',{staticClass:"column is-4 is-offset-4"},[_c('h3',{staticClass:"title has-text-grey"},[_vm._v("Login")]),_vm._v(" "),_c('p',{staticClass:"subtitle has-text-grey"},[_vm._v("Please login to proceed.")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('figure',{staticClass:"avatar"},[_c('img',{attrs:{"src":'/static/img/logo.png'}})]),_vm._v(" "),_c('form',[_c('div',{staticClass:"title is-5 has-text-left has-text-grey-dark"},[_vm._v(" Enter your details below ")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"email","rules":"required|email","placeholder":"Your email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"type":"password","name":"password","rules":"required|min:6","placeholder":"Your password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-danger"},on:{"click":function($event){_vm.login()}}},[_vm._v("Login")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control has-text-centered"},[_c('a',{staticClass:"icon-button facebook",attrs:{"href":"#"},on:{"click":function($event){_vm.authenticate('facebook')}}},[_c('i',{staticClass:"icon-facebook fa fa-facebook"}),_c('span')]),_vm._v(" "),_c('a',{staticClass:"icon-button google-plus",attrs:{"href":"#"},on:{"click":function($event){_vm.authenticate('google')}}},[_c('i',{staticClass:"icon-google-plus fa fa-google-plus"}),_c('span')])])])],1)]),_vm._v(" "),_c('p',{staticClass:"has-text-grey"},[_c('router-link',{attrs:{"to":"/register"}},[_vm._v("\n                  Sign up\n              ")]),_vm._v("  · \n              "),_c('router-link',{attrs:{"to":"/forgot/password"}},[_vm._v("\n                  Forgot password?\n              ")])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HDjL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("CB5X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_454bc4a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("5jPT");
function injectStyle (ssrContext) {
  __webpack_require__("XjSL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-454bc4a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_454bc4a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HE7X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HFYB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicInput__ = __webpack_require__("f8TI");
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BasicInput__["a" /* default */]]
});

/***/ }),

/***/ "HIXN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_NewsRepo__ = __webpack_require__("O7DD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_ace__ = __webpack_require__("L3z5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_ace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_ace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_brace_mode_html__ = __webpack_require__("hCU/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_brace_mode_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_brace_mode_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_brace_theme_monokai__ = __webpack_require__("eKfU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_brace_theme_monokai___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_brace_theme_monokai__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'news-edit',
    components: { editor: __WEBPACK_IMPORTED_MODULE_3_vue2_ace___default.a },
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_NewsRepo__["a" /* default */](this.$auth),
            loading: false,
            news: {},
            content: ''
        };
    },
    created: function created() {
        this.getNews(this.$route.params.id);
    },
    mounted: function mounted() {
        var self = this;
        this.$on('editor-update', function (val) {
            self.news.text = val;
        });
    },

    methods: {
        getNews: function getNews(id) {
            var _this = this;

            this.repo.show(id).then(function (response) {
                _this.news = response.data.data;
                _this.content = _this.news.text;
            });
        },
        save: function save() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this2;
                    _this2.loading = true;

                    _this2.repo.update(_this2.news.id, _this2.news).then(function (response) {

                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/news');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "HSFr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('premade-comment',{attrs:{"loadedPremadeComment":_vm.premadeComment,"update":true}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HX4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("3a6P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c61e58a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("PViL");
function injectStyle (ssrContext) {
  __webpack_require__("dPEa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c61e58a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c61e58a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HXoX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+" \n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.pivot)?_c('th',[_vm._v("Schools")]):_vm._e(),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{on:{"click":function($event){_vm.show(item.id)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.alias))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.placeholder))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.description))]),_vm._v(" "),(item.schools)?_c('td',[_vm._v(" "+_vm._s(Array.prototype.map.call(item.schools, function(item) { return item.name; }).join(",")))]):_c('td',[_vm._v("All schools")]),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'magic-word', params: { id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])]),_vm._v(" "),_c('router-link',{staticClass:"button is-warning tooltip",attrs:{"to":{ name: 'magic-word-edit', params: { id: item.id }},"data-tooltip":"Edit"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-edit"})])]),_vm._v(" "),(!item.static)?_c('button',{staticClass:"button is-danger tooltip",attrs:{"data-tooltip":"Delete"},on:{"click":function($event){_vm.showDeleteModal($event, item.id, index)}}},[_vm._m(1,true)]):_vm._e()],1):_vm._e()])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HlxK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("mdkB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cf0eba6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("26yX");
function injectStyle (ssrContext) {
  __webpack_require__("uBJu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cf0eba6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cf0eba6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I0YH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'premade-categories-show',
  components: {},
  data: function data() {
    return {
      item: {}
    };
  },
  created: function created() {
    this.getPremadeCategory(this.$route.params.id);
  },

  methods: {
    getPremadeCategory: function getPremadeCategory(id) {
      var _this = this;

      this.premadeCategoryRepo.get(id).then(function (response) {
        _this.item = response.data.data;
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "I1GP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+"\n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',[_c('td',[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.teacher))]),_vm._v(" "),_c('td',{class:{'has-text-success': item.fee > 0}},[_vm._v("$"+_vm._s(item.fee))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.payout_date))])])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I4XH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I6q9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IGxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("/x+4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83d1cc20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("Bhag");
function injectStyle (ssrContext) {
  __webpack_require__("Lpuv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-83d1cc20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83d1cc20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IZbS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isFullwidth: Boolean,
    accordion: Boolean
  },

  computed: {
    $collapseItems: function $collapseItems() {
      return this.$children.filter(function (child) {
        return child._isCollapseItem;
      });
    }
  },

  methods: {
    openByIndex: function openByIndex(index) {
      if (this.accordion) {
        this.$collapseItems.forEach(function (item, i) {
          if (i !== index) {
            item.isActived = false;
          }
        });
      }
    }
  }

});

/***/ }),

/***/ "IkSW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("utXB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_469476fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("ZdgU");
function injectStyle (ssrContext) {
  __webpack_require__("u/GD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-469476fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_469476fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J60W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("eGWK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282207fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("mWgo");
function injectStyle (ssrContext) {
  __webpack_require__("L6P0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-282207fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282207fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J8FP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_WrapperInput_vue__ = __webpack_require__("5sHQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_009e769c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_WrapperInput_vue__ = __webpack_require__("Qz24");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_WrapperInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_009e769c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_WrapperInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J9gl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JCdL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JE3q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JLaO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("ZuYL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae2b4c9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("vXoJ");
function injectStyle (ssrContext) {
  __webpack_require__("mgMI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ae2b4c9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae2b4c9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JXkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("so2T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95053282_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("+OdD");
function injectStyle (ssrContext) {
  __webpack_require__("/x0O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-95053282"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95053282_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jees":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SentenceTag_vue__ = __webpack_require__("WnvN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0534bc29_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SentenceTag_vue__ = __webpack_require__("Xu1q");
function injectStyle (ssrContext) {
  __webpack_require__("Q8K+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0534bc29"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SentenceTag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0534bc29_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SentenceTag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K3L8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdditionalInfo_vue__ = __webpack_require__("vb1P");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vk-lesson',
  components: { AdditionalInfo: __WEBPACK_IMPORTED_MODULE_1__AdditionalInfo_vue__["a" /* default */] },
  props: {
    lessonForUpdate: { required: true },
    loading: { required: true, default: false }
  },
  data: function data() {
    return {
      lesson: {},
      excludeProperties: ['id', 'name', 'words', 'provider_full_id']
    };
  },
  created: function created() {
    this.lesson = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.lessonForUpdate);
    if (!this.lesson.id) {
      this.lesson.additionalInfo = this.vkDefaultAdditionalInfo();
    }
  },

  methods: {
    save: function save() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          if (!_this.vkLessonFormat(_this.lesson.additionalInfo.provider_full_id)) {
            return;
          }
          _this.$emit('save', _this.lesson);
        }
      });
    }
  },
  watch: {

    lessonForUpdate: function lessonForUpdate(lesson) {
      this.lesson = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, lesson);
    }

  }

});

/***/ }),

/***/ "KqJy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("c/5L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e64482c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("bxnX");
function injectStyle (ssrContext) {
  __webpack_require__("ARc3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e64482c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e64482c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kqpv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L+oz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("oNTC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9ae832c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("TIav");
function injectStyle (ssrContext) {
  __webpack_require__("nAcR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a9ae832c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9ae832c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L1Ji":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MELesson__ = __webpack_require__("d4a3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VKLesson__ = __webpack_require__("eiW3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RestLesson__ = __webpack_require__("vP2q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sb-lessons-add',
  props: {
    lesson: { required: true },
    update: { required: false, default: false },
    disableSchool: { required: false, default: false }
  },
  components: { MELesson: __WEBPACK_IMPORTED_MODULE_0__MELesson__["a" /* default */], VKLesson: __WEBPACK_IMPORTED_MODULE_1__VKLesson__["a" /* default */], RestLesson: __WEBPACK_IMPORTED_MODULE_2__RestLesson__["a" /* default */] },
  data: function data() {
    return {
      loading: false,
      school: {}
    };
  },
  created: function created() {
    if (this.schools.length == 0) {
      this.loadSchools();
    }
  },

  methods: {
    save: function save(lesson) {
      var _this = this;

      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.loading = true;
          if (_this.update) {
            self.stbyLessonRepo.update(lesson.id, lesson).then(function (response) {
              self.loading = false;
              self.$toast.success(response.data.message);
              self.$router.push('/dashboard/sb-lessons');
            }).catch(function (response) {
              self.loading = false;
            });
          } else {
            self.stbyLessonRepo.store(lesson).then(function (response) {
              self.loading = false;
              self.$toast.success(response.data.message);
              self.$router.push('/dashboard/sb-lessons');
            }).catch(function (response) {
              self.loading = false;
            });
          }
        }
      });
    }
  },
  watch: {

    'schools': function schools(_schools) {
      if (_schools.length > 0) {
        var school = this.lesson.school ? this.lesson.school : _schools[0];
        this.school = school;
      }
      //this.stbySchools(this.schools);
    },
    'school': function school(_school) {
      this.lesson.school_id = _school.id;
    },
    'lesson': function lesson(_lesson) {

      if (this.lesson.additionalInfo.name === '') {
        this.lesson.additionalInfo.name = _lesson.name;
      }
      if (this.lesson.additionalInfo.provider_full_id === '') {
        this.lesson.additionalInfo.provider_full_id = _lesson.provider_id;
      }
      if (this.lesson.additionalInfo.words === '') {
        this.lesson.additionalInfo.words = _lesson.words;
      }
      console.log(_lesson);
    }
  }

});

/***/ }),

/***/ "L6P0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LL00":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("WkxT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aacb2e32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("dZ1S");
function injectStyle (ssrContext) {
  __webpack_require__("6ZQ/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aacb2e32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aacb2e32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LOeR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryTag_vue__ = __webpack_require__("lMa6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e980b29_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryTag_vue__ = __webpack_require__("mJq/");
function injectStyle (ssrContext) {
  __webpack_require__("oh3C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e980b29"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryTag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e980b29_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryTag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LV5U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_AuthRepo__ = __webpack_require__("puMg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'password-reset',
    components: {},
    data: function data() {
        return {
            user: { token: this.$route.params.token },
            loading: false,
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_AuthRepo__["a" /* default */](this.$auth)
        };
    },
    created: function created() {},

    methods: {
        passwordReset: function passwordReset() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this.loading = true;
                    var self = _this;
                    _this.repo.passwordReset(_this.user).then(function (response) {
                        self.loading = false;
                        _this.$toast.success(response.data.message);
                        _this.$router.push('/');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    }

});

/***/ }),

/***/ "LYI0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("PJeJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a61f881_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("7IV6");
function injectStyle (ssrContext) {
  __webpack_require__("R8dk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a61f881"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a61f881_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lpuv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LstL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36fd7aab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("wH9m");
function injectStyle (ssrContext) {
  __webpack_require__("rxcD")
  __webpack_require__("J9gl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36fd7aab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MaRQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("+0Vw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_018aa968_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("8m/A");
function injectStyle (ssrContext) {
  __webpack_require__("T7m2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-018aa968"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_018aa968_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MnGM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("HIXN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_988cc274_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("zwA8");
function injectStyle (ssrContext) {
  __webpack_require__("I6q9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-988cc274"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_988cc274_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MtcF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_LessonRepo__ = __webpack_require__("VMRg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repos_SchoolRepo__ = __webpack_require__("gh8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'lessons-add',
    components: {},
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_LessonRepo__["a" /* default */](this.$auth),
            schoolRepo: new __WEBPACK_IMPORTED_MODULE_2__repos_SchoolRepo__["a" /* default */](this.$auth),
            loading: false,
            schools: [],
            lesson: {}
        };
    },
    created: function created() {
        this.getSchools();
    },

    methods: {
        getSchools: function getSchools() {
            var _this = this;

            this.schoolRepo.all().then(function (response) {
                _this.schools = response.data.data;
                if (_this.schools && _this.schools.length > 0) {
                    _this.lesson.school_id = _this.schools[0].id;
                }
            });
        },
        save: function save() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this2;
                    _this2.loading = true;
                    _this2.repo.store(_this2.lesson).then(function (response) {
                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/lessons');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "NCNF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_izitoast__ = __webpack_require__("Md/4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_izitoast_dist_css_iziToast_css__ = __webpack_require__("I4XH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_izitoast_dist_css_iziToast_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_izitoast_dist_css_iziToast_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_util_BulmaInput_vue__ = __webpack_require__("a/qn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_util_BulmaPagination_vue__ = __webpack_require__("k++z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_util_LoadingButton_vue__ = __webpack_require__("5Q78");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_util_Collapse_vue__ = __webpack_require__("gCSv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_util_Item_vue__ = __webpack_require__("f4zy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_EventBus_js__ = __webpack_require__("n2zA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_authenticate__ = __webpack_require__("WrNK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue2_dnd__ = __webpack_require__("6XFc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue2_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue2_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_scrollto__ = __webpack_require__("bm7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_sweetalert2__ = __webpack_require__("oYt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_progressbar__ = __webpack_require__("zYko");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_masked_input__ = __webpack_require__("4q2C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_bulma_datepicker__ = __webpack_require__("Cu96");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__mixins_http_mixin_vue__ = __webpack_require__("lOWM");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.























//import VueHtml5Editor from 'vue-html5-editor'

/*import Multiselect from 'vue-multiselect'
Vue.component(Multiselect)*/



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('multiselect', __WEBPACK_IMPORTED_MODULE_24_vue_multiselect___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('star-rating', __WEBPACK_IMPORTED_MODULE_25_vue_star_rating___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('masked-input', __WEBPACK_IMPORTED_MODULE_22_vue_masked_input__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('bulma-pagination', __WEBPACK_IMPORTED_MODULE_8__components_util_BulmaPagination_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('bulma-input', __WEBPACK_IMPORTED_MODULE_7__components_util_BulmaInput_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('loading-button', __WEBPACK_IMPORTED_MODULE_9__components_util_LoadingButton_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('collapse', __WEBPACK_IMPORTED_MODULE_10__components_util_Collapse_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('collapse-item', __WEBPACK_IMPORTED_MODULE_11__components_util_Item_vue__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_26__mixins_http_mixin_vue__["a" /* default */]);

//axios.defaults.baseURL = 'http://localhost:8000/';
//axios.defaults.baseURL = 'http://blablaapi.dinkara.com/';
//axios.defaults.baseURL = 'http://blablacommentz.test/';
__WEBPACK_IMPORTED_MODULE_17_axios___default.a.defaults.baseURL = 'https://api.blablacommentz.com/';
__WEBPACK_IMPORTED_MODULE_17_axios___default.a.defaults.storageURL = __WEBPACK_IMPORTED_MODULE_17_axios___default.a.defaults.baseURL + 'storage/';

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_21_vue_analytics___default.a, {
    id: 'UA-111495631-1',
    checkDuplicatedScript: true
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$me = {
    price: 0,
    user: {
        profile: {
            name: ''
        }
    },
    id: -1
};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_17_axios___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_16_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_17_axios___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_23_vue_bulma_datepicker__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue2_dnd___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_izitoast___default.a, {
    timeout: 5000,
    theme: 'dark',
    position: 'topCenter',
    progressBarColor: '#d5e1df'
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_18_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_19_vue_sweetalert2__["a" /* default */]);
/*Vue.use(VueHtml5Editor,{
    name: "vue-editor",
    visibleModules: [
        "text",
        "color",
        "font",
        "align",
        "list",
        "link",
        "unlink",
        "hr",
        "eraser",
        "undo",
        "info",
    ]
});*/

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_20_vue_progressbar___default.a, {
    color: '#00d1b2',
    failedColor: '#ff3860',
    thickness: '2px',
    autoRevert: true,
    location: 'top',
    inverse: false
});

var auth_options = {
    baseUrl: __WEBPACK_IMPORTED_MODULE_17_axios___default.a.defaults.baseURL + "/api", // Your API domain
    tokenName: 'token',
    responseDataKey: 'data',
    logoutUrl: "api/logout",
    loginUrl: "/login",
    registerUrl: "/register",
    providers: {
        facebook: {
            clientId: '516738055355291',
            redirectUri: 'https://app.blablacommentz.com/' // Your client app URL

        },
        google: {
            clientId: '55138306884-3vefu9mekhlncgci48c0f5i075jr11jq.apps.googleusercontent.com',
            redirectUri: 'https://app.blablacommentz.com/' // Your client app URL
        }
    },

    /**
     * Default response interceptor for Axios library
     * @contect {VueAuthenticate}
     */
    bindResponseInterceptor: function bindResponseInterceptor($auth) {
        $auth.$http.interceptors.response.use(function (response) {
            $auth.setToken(response.data);
            return response;
        });
    },

    /**
     * Default request interceptor for Axios library
     * @context {VueAuthenticate}
     */
    bindRequestInoterceptor: function bindRequestInoterceptor($auth) {
        var tokenHeader = $auth.options.tokenHeader;

        $auth.$http.interceptors.request.use(function (config) {
            if ($auth.isAuthenticated()) {
                config.headers[tokenHeader] = [$auth.options.tokenType, $auth.getToken()].join(' ');
            }
            return config;
        });
    }

};

var auth = new __WEBPACK_IMPORTED_MODULE_13_vue_authenticate__["a" /* VueAuthenticate */](__WEBPACK_IMPORTED_MODULE_17_axios___default.a, auth_options);

window.axios = __WEBPACK_IMPORTED_MODULE_17_axios___default.a;
window.auth = auth;

// Add a request interceptor
__WEBPACK_IMPORTED_MODULE_17_axios___default.a.interceptors.request.use(function (config) {
    app.$Progress.start();
    // Do something before request is sent
    return config;
}, function (error) {
    app.$Progress.fail();
    // Do something with request error
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// Add a response interceptor
__WEBPACK_IMPORTED_MODULE_17_axios___default.a.interceptors.response.use(function (response) {
    // Do something with response data
    app.$Progress.finish();
    return response;
}, function (error) {
    // Do something with response error
    app.$Progress.fail();
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vue_authenticate__["b" /* default */], auth_options);

// You can also pass in the default options
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_scrollto___default.a, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    cancelable: true,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

var app = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

window.app = app;

window.addEventListener('unhandledrejection', function (event) {
    // Can prevent error output on the console:
    event.preventDefault();

    var promise = event.promise;

    promise.catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_12__services_EventBus_js__["a" /* EventBus */].$emit("serverError", { component: app, error: error });
    });
});

/***/ }),

/***/ "NOw2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NSY/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_UserRepo__ = __webpack_require__("lyrB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'users-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Avatar',
                key: ''
            }, {
                name: 'Email',
                key: 'email'
            }, {
                name: 'Name',
                key: ''
            }, {
                name: 'Nick',
                key: ''
            }, {
                name: 'Last login',
                key: 'last_login'
            }],
            reverse: true,
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_UserRepo__["a" /* default */](this.$auth)
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        show: function show(id) {
            this.$router.push('/dashboard/users/' + id);
        },
        showDeleteModal: function showDeleteModal(event, id, index) {
            event.stopPropagation();
            var self = this;
            this.$swal({
                title: 'Are you sure?',
                text: "This will delete this user permanently!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3273dc',
                cancelButtonColor: '#ff3860',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    self.deleteUser(id, index);
                }
            }).catch(function (result) {});
        },
        deleteUser: function deleteUser(id, index) {
            var _this = this;

            this.repo.delete(id).then(function (response) {
                _this.items.splice(index, 1);
                _this.$swal('Deleted!', 'User has been deleted.', 'success');
            });
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "NTch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"provider_id","rules":"required","placeholder":"Provider id"},model:{value:(_vm.student.provider_id),callback:function ($$v) {_vm.$set(_vm.student, "provider_id", $$v)},expression:"student.provider_id"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.student.name),callback:function ($$v) {_vm.$set(_vm.student, "name", $$v)},expression:"student.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"","placeholder":"Nick"},model:{value:(_vm.student.nick),callback:function ($$v) {_vm.$set(_vm.student, "nick", $$v)},expression:"student.nick"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.student.gender),expression:"student.gender"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.student, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"male"}},[_vm._v("male")]),_vm._v(" "),_c('option',{attrs:{"value":"female"}},[_vm._v("female")])])])])]),_vm._v(" "),(_vm.schools && _vm.schools.length > 0)?_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.student.school_id),expression:"student.school_id"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.student, "school_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.schools),function(school){return _c('option',{domProps:{"value":school.id}},[_vm._v(_vm._s(school.name))])}),0)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-user-circle"}),_vm._v(" Students")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NfQZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Text:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.text))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Categories:")]),_vm._v(" "),_vm._l((_vm.item.categories),function(cat){return _c('div',{staticClass:"control"},[_c('p',[_vm._v(_vm._s(cat.name))])])})],2)]),_vm._v(" "),(_vm.item.user && _vm.item.user.profile)?_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Teacher:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.user.profile.name))])])])]):_vm._e(),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Sentences")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                Back\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NpNI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"provider_id","rules":"required","placeholder":"Provider id"},model:{value:(_vm.lesson.provider_id),callback:function ($$v) {_vm.$set(_vm.lesson, "provider_id", $$v)},expression:"lesson.provider_id"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.lesson.name),callback:function ($$v) {_vm.$set(_vm.lesson, "name", $$v)},expression:"lesson.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Words"},model:{value:(_vm.lesson.words),callback:function ($$v) {_vm.$set(_vm.lesson, "words", $$v)},expression:"lesson.words"}})],1)]),_vm._v(" "),(_vm.schools && _vm.schools.length > 0)?_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.lesson.school_id),expression:"lesson.school_id"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.lesson, "school_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.schools),function(school){return _c('option',{domProps:{"value":school.id}},[_vm._v(_vm._s(school.name))])}),0)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" Lessons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nrdq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column"},[_c('sentences-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.sentences,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Sentences")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O7DD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Http__ = __webpack_require__("OK7G");




/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES


// private sector
var $http = void 0;

//public sector

var NewsRepo = function () {
    function NewsRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NewsRepo);

        $http = new __WEBPACK_IMPORTED_MODULE_3__services_Http__["a" /* default */]($auth);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(NewsRepo, [{
        key: 'show',
        value: function show(id) {
            return $http.get(NewsRepo.$resource + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'store',
        value: function store(data) {
            return $http.post(NewsRepo.$resource, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'all',
        value: function all() {
            return $http.get(NewsRepo.$resource).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'paginate',
        value: function paginate(page, q, orderBy) {
            var query = "page=" + page;
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(NewsRepo.$resource + "/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'update',
        value: function update(id, data) {
            return $http.put(NewsRepo.$resource + "/" + id, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            return $http.delete(NewsRepo.$resource + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }]);

    return NewsRepo;
}();

NewsRepo.$resource = 'news';
/* harmony default export */ __webpack_exports__["a"] = (NewsRepo);

/***/ }),

/***/ "OK7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios_index__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios_index__);



/**
 * Created by ndzak on 4/22/2016.
 */



var API_ENDPOINT = "api/admin/";

var Http = function () {
    function Http($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Http);

        if ($auth) {
            this.token = $auth.getToken();
            this._bearer = 'Bearer ' + (this.token ? this.token : "");
        }
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Http, [{
        key: "get",
        value: function get(url) {

            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(API_ENDPOINT + url, {
                method: 'GET',
                headers: {
                    'Authorization': this._bearer,
                    'Accept': 'application/json'
                }
            }).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (error) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
            });
        }
    }, {
        key: "post",
        value: function post(url, data) {
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(API_ENDPOINT + url, data, {
                method: 'POST',
                headers: {
                    'Authorization': this._bearer,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }

            }).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (error) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
            });
        }
    }, {
        key: "put",
        value: function put(url, data) {
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(API_ENDPOINT + url, data, {
                method: 'PUT',
                headers: {
                    'Authorization': this._bearer,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (error) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
            });
        }
    }, {
        key: "delete",
        value: function _delete(url) {
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(API_ENDPOINT + url, {
                method: 'DELETE',
                headers: {
                    'Authorization': this._bearer,
                    'Accept': 'application/json'
                }
            }).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (error) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
            });
        }
    }]);

    return Http;
}();

/* harmony default export */ __webpack_exports__["a"] = (Http);

/***/ }),

/***/ "OO5v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card collapse-item is-primary",class:{ 'is-fullwidth': _vm.$parent.isFullwidth, 'is-active': _vm.isActived }},[_c('header',{staticClass:"card-header touchable",attrs:{"role":"tab","aria-expanded":_vm.selected ? 'true' : 'fase'},on:{"click":_vm.toggle}},[_c('h3',{staticClass:"card-header-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('transition',{attrs:{"name":"collapsed-fade","css":false,"appear":""},on:{"before-appear":_vm.before,"appear":_vm.enter,"appear-cancel":_vm.cancel,"before-enter":_vm.before,"enter":_vm.enter,"enter-cancel":_vm.cancel,"leave":_vm.leave,"leave-cancel":_vm.cancel}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActived),expression:"isActived"}],staticClass:"card-content"},[_c('div',{staticClass:"card-content-box"},[_vm._t("default")],2)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"card-header-icon"},[_c('i',{staticClass:"fa fa-angle-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OPFZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OvKu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("Wluu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cad6c61e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("W2Lf");
function injectStyle (ssrContext) {
  __webpack_require__("3h0n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cad6c61e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cad6c61e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OvVz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('router-link',{staticClass:"button is-info is-pulled-right",attrs:{"to":{name: 'add-category' }}},[_vm._v("Add new")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('categories-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.categories,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v(" Categories")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P1sU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_SchoolRepo__ = __webpack_require__("gh8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repos_CategoryRepo__ = __webpack_require__("94/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repos_CommentRepo__ = __webpack_require__("V/pO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__repos_LessonRepo__ = __webpack_require__("VMRg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__repos_NewsRepo__ = __webpack_require__("O7DD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__repos_STBYLessonRepo__ = __webpack_require__("rmeB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__repos_SentenceRepo__ = __webpack_require__("5sB1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__repos_StudentRepo__ = __webpack_require__("CSv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__repos_TicketRepo__ = __webpack_require__("407P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__repos_PremadeCategoryRepo__ = __webpack_require__("a6xk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__repos_PremadeSentenceRepo__ = __webpack_require__("l8mi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__repos_PremadeCommentRepo__ = __webpack_require__("zlxJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__repos_MagicWordRepo__ = __webpack_require__("GDBq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_HelperArrays__ = __webpack_require__("V6+6");

//
















/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            schoolRepo: new __WEBPACK_IMPORTED_MODULE_1__repos_SchoolRepo__["a" /* default */](),
            categoryRepo: new __WEBPACK_IMPORTED_MODULE_2__repos_CategoryRepo__["a" /* default */](),
            commentRepo: new __WEBPACK_IMPORTED_MODULE_3__repos_CommentRepo__["a" /* default */](),
            lessonRepo: new __WEBPACK_IMPORTED_MODULE_4__repos_LessonRepo__["a" /* default */](),
            newsRepo: new __WEBPACK_IMPORTED_MODULE_5__repos_NewsRepo__["a" /* default */](),
            stbyLessonRepo: new __WEBPACK_IMPORTED_MODULE_6__repos_STBYLessonRepo__["a" /* default */](),
            sentenceRepo: new __WEBPACK_IMPORTED_MODULE_7__repos_SentenceRepo__["a" /* default */](),
            studentRepo: new __WEBPACK_IMPORTED_MODULE_8__repos_StudentRepo__["a" /* default */](),
            ticketRepo: new __WEBPACK_IMPORTED_MODULE_9__repos_TicketRepo__["a" /* default */](),
            premadeCategoryRepo: new __WEBPACK_IMPORTED_MODULE_10__repos_PremadeCategoryRepo__["a" /* default */](),
            premadeSentenceRepo: new __WEBPACK_IMPORTED_MODULE_11__repos_PremadeSentenceRepo__["a" /* default */](),
            premadeCommentRepo: new __WEBPACK_IMPORTED_MODULE_12__repos_PremadeCommentRepo__["a" /* default */](),
            magicWordRepo: new __WEBPACK_IMPORTED_MODULE_13__repos_MagicWordRepo__["a" /* default */](),
            helperArrays: new __WEBPACK_IMPORTED_MODULE_14__services_HelperArrays__["a" /* default */](),
            schools: [],
            subscription_status: [
            //{id:"'ACTIVE','TRIALING','PAST_DUE','DELETED'", text:"ANY"},
            { id: "ACTIVE", text: "ACTIVE" }, { id: "TRIALING", text: "TRIALING" }, { id: "PAST_DUE", text: "PAST DUE" }, { id: "DELETED", text: "DELETED" }],
            subscription_plans: [{ id: "527533,527534,527535", text: "ANY" }, { id: "527533", text: "MOTHLY" }, { id: "527534", text: "SIX  MONTHS" }, { id: "527535", text: "TWELVE MONTHS" }],
            MAGIC_EARS: { id: 1, name: 'Magic Ears' },
            VIPKID: { id: 3, name: 'VIPKID' },
            SUB_STATUS_ANY: null,
            SUB_PLAN_ANY: "527533,527534,527535",

            material: [['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5'], ['#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50'], ['#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800'], ['#FF5722', '#795548', '#9E9E9E', '#607D8B', '#3D4351']]
        };
    },

    created: function created() {
        //console.log('mixin hook called')
    },
    computed: {},
    methods: {
        isArray: function isArray(a) {
            return !!a && a.constructor === Array;
        },
        isObject: function isObject(a) {
            return !!a && a.constructor === Object;
        },
        updateSentenceColor: function updateSentenceColor(sentences, categories) {
            _.forEach(sentences, function (sen) {
                _.forEach(categories, function (cat) {
                    var index = _.findIndex(sen.premadeCategories, function (c) {
                        return c.id == cat.id;
                    });
                    if (index !== -1) {
                        sen.premadeCategories[index] = cat;
                    }
                });
            });
            return sentences;
        },
        prepareSentencesForServer: function prepareSentencesForServer(choosedSentences) {
            var sentences = [];
            var prev = -1;
            var i = 0;
            _.forEach(choosedSentences, function (value) {

                if (!value.isJoiner) {

                    sentences[i] = {
                        sentenceId: value.id,
                        order: i,
                        joiner: ""
                    };
                    prev = i;
                    i++;
                } else {
                    //if(prev > -1){
                    sentences[prev].joiner = value.text;
                    //}
                }
            });

            return sentences;
        },
        prepareSentencesForClient: function prepareSentencesForClient(commentSentences) {
            var sentences = [];
            var joiners = this.helperArrays.joiners();
            var i = 0;
            _.forEach(commentSentences, function (value) {
                sentences.push({ id: value.id, text: value.text, premadeCategories: value.premadeCategories });
                if (value.pivot.joiner != '') {
                    _.forEach(joiners, function (value1) {
                        if (value.pivot.joiner == value1.text) {
                            sentences.push(value1);
                        }
                    });
                    i++;
                }
                i++;
            });

            return sentences;
        },
        loadSchools: function loadSchools() {
            var _this = this;

            this.schoolRepo.all().then(function (response) {
                _this.schools = response.data.data;
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        },
        stbySchools: function stbySchools(items) {
            items.forEach(function (item) {
                if (!['VIPKID', 'Magic Ears'].includes(item.name)) {
                    item['$isDisabled'] = true;
                }
            });
            //return result;
        },
        isMEFullFormat: function isMEFullFormat(str) {
            str = str.toUpperCase();
            if (str === "") {
                return true;
            }
            var res = str.split("-");
            if (res.length == 3) {
                var str1 = res[0];
                var str2 = res[1];
                var str3 = res[2];
                if (str1[0] !== "L" || str2[0] !== "U" || str3[0] !== "L") {
                    return true;
                }
            }
            return false;
        },
        meLessonFormat: function meLessonFormat(str) {
            var fullFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            str = str.toUpperCase();
            if (str === "") {
                return true;
            }
            var res = str.split("-");
            if (res.length !== 3) {
                return false;
            } else {
                var str1 = res[0];
                var str2 = res[1];
                var str3 = res[2];
                var ch = true;
                if (fullFormat) {
                    if (str1[0] !== "L" || str2[0] !== "U" || str3[0] !== "L") {
                        if (str1.length === 0 || isNaN(str1) || str1.includes("E") || str2.length === 0 || isNaN(str2) || str2.includes("E") || str3.length === 0 || isNaN(str3) || str3.includes("E")) {
                            return false;
                        }
                        return true;
                    }
                    str1 = str1.substring(1, str1.length);
                    str2 = str2.substring(1, str2.length);
                    str3 = str3.substring(1, str3.length);
                }

                if (str1.length === 0 || isNaN(str1) || str1.includes("E") || str2.length === 0 || isNaN(str2) || str2.includes("E") || str3.length === 0 || isNaN(str3) || str3.includes("E")) {
                    return false;
                }
                return true;
            }
        },
        vkLessonFormat: function vkLessonFormat(str) {
            str = str.toUpperCase();
            if (str === "") {
                return true;
            }
            var res = str.split("-");

            if (res.length === 4) {
                return this.is_trial_vipkid(res);
            }
            if (res.length === 5) {
                return this.is_mc_vipkid(res);
            }
            return false;
        },
        is_trial_vipkid: function is_trial_vipkid(parts) {
            var str = parts[0];

            if (['MSCP'].includes(str)) {
                return this.is_mcsp_vipkid(parts);
            }
            if (!['T1', 'LT1'].includes(str)) {
                return false;
            }
            var str1 = parts[1];
            var str2 = parts[2];
            var str3 = parts[3];
            if (str1.length < 2 || str2.length < 3 || str3.length < 2 || str1[0] !== "U" || str2[0] !== "L" && str2[1] !== "C" || str3[0] !== "L") {
                return false;
            }
            str1 = str1.substring(1, str1.length);
            str2 = str2.substring(2, str2.length);
            str3 = str3.substring(1, str3.length);
            if (str1.length === 0 || str1.includes("E") || isNaN(str1) || str2.length === 0 || str2.includes("E") || isNaN(str2) || str3.length === 0 || str3.includes("E") || isNaN(str3)) {
                return false;
            }
            return true;
        },
        is_mcsp_vipkid: function is_mcsp_vipkid(parts) {
            //skip first element
            var str1 = parts[1];
            var str2 = parts[2];
            var str3 = parts[3];
            if (str1.length < 2 || str2.length < 2 || str3.length < 2 || str1[0] !== "L" || str2[0] !== "U" || str3[0] !== "L") {
                return false;
            }
            str1 = str1.substring(1, str1.length);
            str2 = str2.substring(1, str2.length);
            str3 = str3.substring(1, str3.length);
            if (str1.length === 0 || str1.includes("E") || isNaN(str1) || str2.length === 0 || str2.includes("E") || isNaN(str2) || str3.length === 0 || str3.includes("E") || isNaN(str3)) {
                return false;
            }
            return true;
        },
        is_mc_vipkid: function is_mc_vipkid(parts) {
            var str = parts[0];
            var str4 = parts[4];
            if (['T1'].includes(str)) {
                if (str4.length !== 0 && !str4.includes("E") || !isNaN(str4)) {
                    parts.pop();
                    return this.is_trial_vipkid(parts);
                }
            }
            if (!['BK', 'DG', 'FS', 'ST', 'ES', 'GM', 'MVP01', 'PH', 'PP', 'FT', 'TP', 'VV', 'W3', 'W2', 'W1', 'LT1', 'ME', 'MCS', 'MC', 'T1', 'IMC'].includes(str)) {
                return false;
            }
            var str1 = parts[1];
            var str2 = parts[2];
            var str3 = parts[3];
            if (str1.length < 2 || str2.length < 2 || str3.length < 3 || str1[0] !== "L" || str2[0] !== "U" || str3[0] !== "L" && str3[1] !== "C") {
                return false;
            }
            str1 = str1.substring(1, str1.length);
            str2 = str2.substring(1, str2.length);
            str3 = str3.substring(2, str3.length);
            if (str1.length === 0 || str1.includes("E") || isNaN(str1) || str2.length === 0 || str2.includes("E") || isNaN(str2) || str3.length === 0 || str3.includes("E") || isNaN(str3) || str4.length === 0 || str4.includes("E") || isNaN(str4)) {
                return false;
            }
            return true;
        },
        makeLink: function makeLink(text) {
            return (text || "").toString().replace(/([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi, function (match, space, url) {
                var hyperlink = url;
                if (!hyperlink.match('^https?:\/\/')) {
                    hyperlink = 'http://' + hyperlink;
                }
                return space + '<a target="_blank" href="' + hyperlink + '">' + url + '</a>';
            });
        },
        snakeToCamelCase: function snakeToCamelCase(str) {
            return this.capitalize(str.replace(/(\_\w)/g, function (m) {
                return " " + m[1].toUpperCase();
            }));
        },
        capitalize: function capitalize(s) {
            if (typeof s !== 'string') return '';
            return s.charAt(0).toUpperCase() + s.slice(1);
        },
        meDefaultAdditionalInfo: function meDefaultAdditionalInfo() {
            return {
                crown_page: "",
                ending_song_length: "",
                game: "",
                id: "",
                name: "",
                other_key_words: "",
                practice_words: "",
                prop_ideas: "",
                provider_full_id: "",
                provider_id: "",
                role_play_slides: "",
                sentences: "",
                show_time: "",
                words: ""
            };
        },
        vkDefaultAdditionalInfo: function vkDefaultAdditionalInfo() {
            return {
                assessment: '',
                connected_speach: '',
                digital_rewards: '',
                discussion_questions: '',
                goals: '',
                google_slides: '',
                grammar: '',
                id: '',
                intonation: '',
                listening: '',
                materials: '',
                math: '',
                name: '',
                notes: '',
                noun: '',
                objective: '',
                outline: '',
                phonics: '',
                phonics_reader: '',
                project_options: '',
                props: '',
                provider_full_id: '',
                reading: '',
                reading_comp: '',
                reward_system: '',
                sentence_pattern: '',
                sight_words: '',
                social_science: '',
                sounds: '',
                tips_tricks: '',
                verb: '',
                vocabulary_strategies: '',
                words: ''
            };
        },
        restDefaultAdditionalInfo: function restDefaultAdditionalInfo() {
            return {
                grammar: '',
                id: '',
                math: '',
                name: '',
                objective: '',
                phonics: '',
                project_options: '',
                provider_full_id: '',
                sentence_pattern: '',
                sight_words: '',
                social_science: '',
                words: ''
            };
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "PAWM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_CommentRepo__ = __webpack_require__("V/pO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'comments-show',
  components: {},
  data: function data() {
    return {
      repo: new __WEBPACK_IMPORTED_MODULE_0__repos_CommentRepo__["a" /* default */](this.$auth),
      item: {}
    };
  },
  created: function created() {
    this.getUser(this.$route.params.id);
  },

  methods: {
    getUser: function getUser(id) {
      var _this = this;

      this.repo.show(id).then(function (response) {
        _this.item = response.data.data;
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "PJeJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_StudentRepo__ = __webpack_require__("CSv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table__ = __webpack_require__("L+oz");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'students-view',
    components: { StudentsTable: __WEBPACK_IMPORTED_MODULE_2__Table__["a" /* default */] },
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_StudentRepo__["a" /* default */](this.$auth),
            students: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1
        };
    },
    created: function created() {
        this.getStudents();
    },

    methods: {
        onSearch: function onSearch(q) {
            this.page = 1;
            this.q = q;
            this.getStudents();
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getStudents();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getStudents();
        },
        getStudents: function getStudents() {
            var _this = this;

            this.repo.paginate(this.page, this.q, this.orderBy).then(function (response) {
                _this.students = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "PViL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.premadeCategory.name),callback:function ($$v) {_vm.$set(_vm.premadeCategory, "name", $$v)},expression:"premadeCategory.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('multiselect',{attrs:{"label":"name","name":"schools","track-by":"name","options":_vm.schools,"multiple":true,"placeholder":"Choose schools"},model:{value:(_vm.premadeCategory.schools),callback:function ($$v) {_vm.$set(_vm.premadeCategory, "schools", $$v)},expression:"premadeCategory.schools"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('span',{staticClass:"heading"},[_vm._v("Background color ")]),_vm._v(" "),_c('swatches',{attrs:{"show-border":true,"row-length":5,"popover-to":"left","show-fallback":"","colors":_vm.material},model:{value:(_vm.premadeCategory.color),callback:function ($$v) {_vm.$set(_vm.premadeCategory, "color", $$v)},expression:"premadeCategory.color"}})],1),_vm._v(" "),_c('div',{staticClass:"column is-1"},[_c('span',{staticClass:"heading"},[_vm._v("Text color ")]),_vm._v(" "),_c('swatches',{attrs:{"show-border":true,"show-fallback":"","colors":"text-basic"},model:{value:(_vm.premadeCategory.text_color),callback:function ($$v) {_vm.$set(_vm.premadeCategory, "text_color", $$v)},expression:"premadeCategory.text_color"}})],1)]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v("Premade Categories")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pz2p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q3Fm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_CategoryRepo__ = __webpack_require__("94/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'categories-edit',
    components: {},
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_CategoryRepo__["a" /* default */](this.$auth),
            loading: false,
            categories: [],
            category: {}
        };
    },
    created: function created() {
        this.getCategory(this.$route.params.id);
    },

    methods: {
        getCategory: function getCategory(id) {
            var _this = this;

            this.repo.show(id).then(function (response) {
                _this.category = response.data.data;
            });
        },
        save: function save() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this2;
                    _this2.loading = true;

                    _this2.repo.update(_this2.category.id, _this2.category).then(function (response) {

                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/categories');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "Q8K+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QH1o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",attrs:{"id":"terms"}},[_c('h1',[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"150%","font-size":"26px"}},[_vm._v("TERMS OF USE")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","line-height":"150%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"150%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"150%","color":"#a6a6a6","mso-themecolor":"background1","mso-themeshade":"166"}},[_c('span',{staticStyle:{"color":"#7f7f7f","font-size":"15px","text-align":"justify"}},[_vm._v("Last updated")]),_c('span',{staticStyle:{"color":"#7f7f7f","font-size":"14.6667px","text-align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#7f7f7f","font-size":"15px","text-align":"justify"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-id":"0d5ae8ae-7749-9afb-1fed-6556cb563dc0","data-type":"question"}},[_vm._v("December 05, 2017")])])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("AGREEMENT TO TERMS")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("These Terms of Use constitute a legally binding agreement made between you, whether personally or on behalf of an entity (“you”) and "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-id":"9d459c4e-c548-e5cb-7729-a118548965d2","data-type":"question"}},[_vm._v("BlaBla Commentz")])]),_vm._v(" ")]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("(“we,” “us” or “our”), concerning your access to and use of the "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-id":"fdf30452-99b8-c68b-5cdf-34af764cd1fd","data-type":"question"}},[_vm._v("http://blablacommentz.com/")])]),_vm._v(" website as well as any other media form, media channel, mobile website or mobile application related, linked, or otherwise connected thereto (collectively, the “Site”). You agree that by accessing the Site, you have read, understood, and agree to be bound by all of these Terms of Use "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v(". IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF USE, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SITE AND YOU MUST DISCONTINUE USE IMMEDIATELY.")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v("Supplemental terms and conditions or documents that may be posted on the Site from time to time are hereby expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes or modifications to these Terms of Use at any time and for any reason. We will alert you about any changes by updating the “Last updated” date of these Terms of Use, and you waive any right to receive specific notice of each such change. It is your responsibility to periodically review these Terms of Use to stay informed of updates. You will be subject to, and will be deemed to have been made aware of and to have accepted, the changes in any revised Terms of Use by your continued use of the Site after the date such revised Terms of Use are posted.  ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("The information provided on the Site is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation or which would subject us to any registration requirement within such jurisdiction or country. Accordingly, those persons who choose to access the Site from other locations do so on their own initiative and are solely responsible for compliance with local laws, if and to the extent local laws are applicable.")]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v("The Site is intended for users who are at least 13 years of age. All users who are minors in the jurisdiction in which they reside (generally under the age of 18) must have the permission of, and be directly supervised by, their parent or guardian to use the Site. If you are a minor, you must have your parent or guardian read and agree to these Terms of Use")]),_c('span',{staticStyle:{"color":"#595959","font-size":"14.6667px"}},[_vm._v(" ")]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v("prior to you using the Site.")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("INTELLECTUAL PROPERTY RIGHTS")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("Unless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (the “Marks”) are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of the United States, foreign jurisdictions, and international conventions. The Content and the Marks are provided on the Site “AS IS” for your information and personal use only. Except as expressly provided in these Terms of Use, no part of the Site and no Content or Marks may be copied, reproduced, aggregated, republished, uploaded, posted, publicly displayed, encoded, translated, transmitted, distributed, sold, licensed, or otherwise exploited for any commercial purpose whatsoever, without our express prior written permission.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("Provided that you are eligible to use the Site, you are granted a limited license to access and use the Site and to download or print a copy of any portion of the Content to which you have properly gained access solely for your personal, non-commercial use. We reserve all rights not expressly granted to you in and to the Site, the Content and the Marks.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("USER REPRESENTATIONS")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("By using the Site, you represent and warrant that: ")]),_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v(" ")]),_vm._v(" "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_c('span',{staticStyle:{"color":"#595959","font-size":"11pt"}},[_vm._v("(")]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v("1)")]),_c('span',{staticStyle:{"color":"#595959","font-size":"11pt"}},[_vm._v(" ")]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v("all registration information you submit will be true, accurate, current, and complete; (")]),_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"color":"#595959"}},[_vm._v("2")])]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v(") you will maintain the accuracy of such information and promptly update such registration information")]),_c('span',{staticStyle:{"color":"#595959","font-size":"11pt"}},[_vm._v(" ")]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v("as necessary; ")])])]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v("(")]),_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"color":"#595959"}},[_vm._v("3")])]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v(") you have the legal capacity and you agree to comply with these Terms of Use;")]),_c('span',{staticStyle:{"color":"#595959","font-size":"11pt"}},[_vm._v(" ")]),_vm._v(" "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"color":"#595959"}},[_vm._v("(4")])]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v(")")]),_c('span',{staticStyle:{"color":"#595959","font-size":"11pt"}},[_vm._v(" ")]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v("you are not under the age of 13; ")])])]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v("(")]),_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"color":"#595959"}},[_vm._v("5")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v(") you are not a minor in the jurisdiction in which you reside "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v(", ")])]),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("or if a minor, you have received parental permission to use the Site ")])]),_vm._v("; ")]),_c('span',{staticStyle:{"color":"#595959","font-size":"11pt"}},[_vm._v(" ")]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v("(")]),_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"color":"#595959"}},[_vm._v("6")])]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v(") you will not access the Site through automated or non-human means, whether through a bot, script or otherwise;")]),_c('span',{staticStyle:{"color":"#595959","font-size":"11pt"}},[_vm._v(" ")]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v("(")]),_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"color":"#595959"}},[_vm._v("7")])]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v(") you will not use the Site for any illegal or unauthorized purpose; and (")]),_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"color":"#595959"}},[_vm._v("8")])]),_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v(") your use of the Site will not violate any applicable law or regulation.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("If you provide any information that is untrue, inaccurate, not current, or incomplete, we have the right to suspend or terminate your account and refuse any and all current or future use of the Site (or any portion thereof).")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("USER REGISTRATION")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("You may be required to register with the Site. You agree to keep your password confidential and will be responsible for all use of your account and password. We reserve the right to remove, reclaim, or change a username you select if we determine, in our sole discretion, that such username is inappropriate, obscene, or otherwise objectionable.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("FEES AND PAYMENT")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"color":"#595959","font-size":"15px"}},[_vm._v("We accept the following forms of payment:")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"17.25px"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"46.9pt","text-indent":"-18.55pt","line-height":"17.25px"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v("You may be required to purchase or pay a fee to access some of our services. You agree to provide current, complete, and accurate purchase and account information for all purchases made via the Site. You further agree to promptly update account and payment information, including email address, payment method, and payment card expiration date, so that we can complete your transactions and contact you as needed.  We bill you through an online billing account for purchases made via the Site. Sales tax will be added to the price of purchases as deemed required by us. We may change prices at any time. All payments shall be in U.S. dollars.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("You agree to pay all charges or fees at the prices then in effect for your purchases, and you authorize us to charge your chosen payment provider for any such amounts upon making your purchase. "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("If ")])]),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("your purchase is subject to recurring charges, then you consent to our charging your payment method on a recurring basis without requiring your prior approval for each recurring charge, until you notify us of your cancellation.")])])])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v("We reserve the right to correct any errors or mistakes in pricing, even if we have already requested or received payment. We also reserve the right to refuse any order placed through the Site.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("FREE TRIAL")])])])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("We offer a "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-id":"3f053c87-320c-4c3a-2d73-c199bf826436","data-type":"question"}},[_vm._v("30")])]),_vm._v(" -day free trial to new users who register with the Site. "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("The account will not be charged and the subscription will be suspended until upgraded to a paid version")])]),_vm._v(" ")]),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v(" ")]),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("at the end of the free trial.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("CANCELLATION")])])])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("All purchases are non-refundable. ")])]),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("  ")])]),_vm._v("You can cancel your subscription at any time ")]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("by logging into your account or contacting us using the contact ")])])]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("  ")])])]),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("information provided below ")])]),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v(". Your cancellation will take effect at the end of the current paid term. ")])])]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("If you are unsatisfied with our services, please email us at "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-id":"7c40698b-5cc8-bb58-245d-2fbd1b57dfba","data-type":"question"}},[_vm._v("ndzakovic@yahoo.com")])])]),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v(". ")]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("PROHIBITED ACTIVITIES")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("You may not access or use the Site for any purpose other than that for which we make the Site available. The Site may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"17.25px"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"16.8667px","color":"#595959"}},[_vm._v("As a user of the Site, you agree not to:")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"17.25px"}},[_c('span',{staticStyle:{"font-size":"11pt","line-height":"16.8667px","color":"#595959"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("1")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Systematically retrieve data or other content from the Site to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("2")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Make any unauthorized use of the Site, including collecting usernames and/or email addresses of users by electronic or other means for the purpose of sending unsolicited email, or creating user accounts by automated means or under false pretenses.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("3")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Use a buying agent or purchasing agent to make purchases on the Site.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("4")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Use the Site to advertise or offer to sell goods and services.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("5")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Circumvent, disable, or otherwise interfere with security-related features of the Site, including features that prevent or restrict the use or copying of any Content or enforce limitations on the use of the Site and/or the Content contained therein.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("6")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Engage in unauthorized framing of or linking to the Site.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("7")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information such as user passwords.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("8")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Make improper use of our support services or submit false reports of abuse or misconduct.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("9")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Engage in any automated use of the system, such as using scripts to send comments or messages, or using any data mining, robots, or similar data gathering and extraction tools.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("10")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Interfere with, disrupt, or create an undue burden on the Site or the networks or services connected to the Site.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("11")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Attempt to impersonate another user or person or use the username of another user.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("12")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Sell or otherwise transfer your profile.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("13")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Use any information obtained from the Site in order to harass, abuse, or harm another person.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("14")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Use the Site as part of any effort to compete with us or otherwise use the Site and/or the Content for any revenue-generating endeavor or commercial enterprise.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("15")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Decipher, decompile, disassemble, or reverse engineer any of the software comprising or in any way making up a part of the Site.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("16")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Attempt to bypass any measures of the Site designed to prevent or restrict access to the Site, or any portion of the Site.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("17")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Harass, annoy, intimidate, or threaten any of our employees or agents engaged in providing any portion of the Site to you.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("18")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Delete the copyright or other proprietary rights notice from any Content.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("19")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Copy or adapt the Site’s software, including but not limited to Flash, PHP, HTML, JavaScript, or other code.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("20")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other material, including excessive use of capital letters and spamming (continuous posting of repetitive text), that interferes with any party’s uninterrupted use and enjoyment of the Site or modifies, impairs, disrupts, alters, or interferes with the use, features, functions, operation, or maintenance of the Site.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("21")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Upload or transmit (or attempt to upload or to transmit) any material that acts as a passive or active information collection or transmission mechanism, including without limitation, clear graphics interchange formats (“gifs”), 1×1 pixels, web bugs, cookies, or other similar devices (sometimes referred to as “spyware” or “passive collection mechanisms” or “pcms”).")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("22")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Except as may be the result of standard search engine or Internet browser usage, use, launch, develop, or distribute any automated system, including without limitation, any spider, robot, cheat utility, scraper, or offline reader that accesses the Site, or using or launching any unauthorized script or other software.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("23")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Disparage, tarnish, or otherwise harm, in our opinion, us and/or the Site.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"forloop"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_vm._v("24")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-size":"14.6667px"}},[_vm._v(".")]),_c('span',{staticStyle:{"text-indent":"-29.4px","color":"#595959","font-family":"arial","font-size":"9.33333px"}},[_vm._v("     ")]),_c('span',{staticStyle:{"text-indent":"-22.05pt","color":"#595959","font-size":"14.6667px"}},[_vm._v("Use the Site in a manner inconsistent with any applicable laws or regulations.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"50.4pt","text-indent":"-22.05pt","line-height":"17.25px"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("USER GENERATED CONTRIBUTIONS")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"17.25px"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"16.8667px","color":"#595959"}},[_vm._v("The Site may invite you to chat, contribute to, or participate in blogs, message boards, online forums, and other functionality, and may provide you with the opportunity to create, submit, post, display, transmit, perform, publish, distribute, or broadcast content and materials to us or on the Site, including but not limited to text, writings, video, audio, photographs, graphics, comments, suggestions, or personal information or other material (collectively, \"Contributions\"). Contributions may be viewable by other users of the Site and through third-party websites. As such, any Contributions you transmit may be treated as non-confidential and non-proprietary. When you create or make available any Contributions, you thereby represent and warrant that:")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"17.25px"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_vm._v(" ")]),_c('span',{staticStyle:{"color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('ol',{staticStyle:{"margin-left":"54px"}},[_c('li',{staticStyle:{"padding-left":"30px","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_c('span',{staticStyle:{"font-variant-numeric":"normal","font-stretch":"normal","line-height":"normal"}},[_vm._v("    ")]),_vm._v("The creation, distribution, transmission, public display, or performance, and the accessing, downloading, or copying of your Contributions do not and will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark, trade secret, or moral rights of any third party.")])])]),_vm._v(" "),_c('li',{staticStyle:{"padding-left":"30px","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_c('span',{staticStyle:{"font-variant-numeric":"normal","font-stretch":"normal","line-height":"normal"}},[_vm._v("    ")]),_vm._v("You are the creator and owner of or have the necessary licenses, rights, consents, releases, and permissions to use and to authorize us, the Site, and other users of the Site to use your Contributions in any manner contemplated by the Site and these Terms of Use.")])])]),_vm._v(" "),_c('li',{staticStyle:{"padding-left":"30px","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_c('span',{staticStyle:{"font-variant-numeric":"normal","font-stretch":"normal","line-height":"normal"}},[_vm._v("  ")]),_vm._v("You have the written consent, release, and/or permission of each and every identifiable individual person in your Contributions to use the name or likeness of each and every such identifiable individual person to enable inclusion and use of your Contributions in any manner contemplated by the Site and these Terms of Use.")])])]),_vm._v(" "),_c('li',{staticStyle:{"padding-left":"30px","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_c('span',{staticStyle:{"font-variant-numeric":"normal","font-stretch":"normal","line-height":"normal"}},[_vm._v("      ")]),_vm._v("Your Contributions are not false, inaccurate, or misleading.")])])]),_vm._v(" "),_c('li',{staticStyle:{"padding-left":"30px","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_c('span',{staticStyle:{"font-variant-numeric":"normal","font-stretch":"normal","line-height":"normal"}},[_vm._v("    ")]),_vm._v("Your Contributions are not unsolicited or unauthorized advertising, promotional materials, pyramid schemes, chain letters, spam, mass mailings, or other forms of solicitation.")])])]),_vm._v(" "),_c('li',{staticStyle:{"padding-left":"30px","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_c('span',{staticStyle:{"font-variant-numeric":"normal","font-stretch":"normal","line-height":"normal"}},[_vm._v("    ")]),_vm._v("Your Contributions are not obscene, lewd, lascivious, filthy, violent, harassing, libelous, slanderous, or otherwise objectionable (as determined by us).")])])]),_vm._v(" "),_c('li',{staticStyle:{"padding-left":"30px","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_c('span',{staticStyle:{"font-variant-numeric":"normal","font-stretch":"normal","line-height":"normal"}},[_vm._v("      ")]),_vm._v("Your Contributions do not ridicule, mock, disparage, intimidate, or abuse anyone.")])])]),_vm._v(" "),_c('li',{staticStyle:{"padding-left":"30px","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_c('span',{staticStyle:{"font-variant-numeric":"normal","font-stretch":"normal","line-height":"normal"}},[_vm._v("      ")]),_vm._v("Your Contributions do not advocate the violent overthrow of any government or incite, encourage, or threaten physical harm against another.")])])]),_vm._v(" "),_c('li',{staticStyle:{"padding-left":"30px","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_c('span',{staticStyle:{"font-variant-numeric":"normal","font-stretch":"normal","line-height":"normal"}},[_vm._v("      ")]),_vm._v("Your Contributions do not violate any applicable law, regulation, or rule.")])])]),_vm._v(" "),_c('li',{staticStyle:{"padding-left":"30px","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_c('span',{staticStyle:{"font-variant-numeric":"normal","font-stretch":"normal","line-height":"normal"}},[_vm._v("  ")]),_vm._v("Your Contributions do not violate the privacy or publicity rights of any third party.")])])]),_vm._v(" "),_c('li',{staticStyle:{"padding-left":"30px","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_c('span',{staticStyle:{"font-variant-numeric":"normal","font-stretch":"normal","line-height":"normal"}},[_vm._v("  ")]),_vm._v("Your Contributions do not contain any material that solicits personal information from anyone under the age of 18 or exploits people under the age of 18 in a sexual or violent manner.")])])]),_vm._v(" "),_c('li',{staticStyle:{"padding-left":"30px","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_c('span',{staticStyle:{"font-variant-numeric":"normal","font-stretch":"normal","line-height":"normal"}},[_vm._v("  ")]),_vm._v("Your Contributions do not violate any federal or state law concerning child pornography, or otherwise intended to protect the health or well-being of minors;")])])]),_vm._v(" "),_c('li',{staticStyle:{"padding-left":"30px","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_c('span',{staticStyle:{"font-variant-numeric":"normal","font-stretch":"normal","line-height":"normal"}},[_vm._v("  ")]),_vm._v("Your Contributions do not include any offensive comments that are connected to race, national origin, gender, sexual preference, or physical handicap.")])])]),_vm._v(" "),_c('li',{staticStyle:{"padding-left":"30px","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_c('span',{staticStyle:{"font-variant-numeric":"normal","font-stretch":"normal","line-height":"normal"}},[_vm._v("  ")]),_vm._v("Your Contributions do not otherwise violate, or link to material that violates, any provision of these Terms of Use, or any applicable law or regulation.")])])])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"17.25px"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"16.8667px","color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"17.25px"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"16.8667px","color":"#595959"}},[_vm._v("Any use of the Site in violation of the foregoing violates these Terms of Use and may result in, among other things, termination or suspension of your rights to use the Site.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("CONTRIBUTION LICENSE")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("By posting your Contributions to any part of the Site "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("  ")])]),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("or making Contributions accessible to the Site by linking your account from the Site to any of your social networking accounts ")])]),_vm._v(", you automatically grant, and you represent and warrant that you have the right to grant, to us an unrestricted, unlimited, irrevocable, perpetual, non-exclusive, transferable, royalty-free, fully-paid, worldwide right, and license to host, use, copy, reproduce, disclose, sell, resell, publish, broadcast, retitle, archive, store, cache, publicly perform, publicly display, reformat, translate, transmit, excerpt (in whole or in part), and distribute such Contributions (including, without limitation, your image and voice) for any purpose, commercial, advertising, or otherwise, and to prepare derivative works of, or incorporate into other works, such Contributions, and grant and authorize sublicenses of the foregoing. The use and distribution may occur in any media formats and through any media channels.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v("This license will apply to any form, media, or technology now known or hereafter developed, and includes our use of your name, company name, and franchise name, as applicable, and any of the trademarks, service marks, trade names, logos, and personal and commercial images you provide. You waive all moral rights in your Contributions, and you warrant that moral rights have not otherwise been asserted in your Contributions.")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v("We do not assert any ownership over your Contributions. You retain full ownership of all of your Contributions and any intellectual property rights or other proprietary rights associated with your Contributions. We are not liable for any statements or representations in your Contributions provided by you in any area on the Site. You are solely responsible for your Contributions to the Site and you expressly agree to exonerate us from any and all responsibility and to refrain from any legal action against us regarding your Contributions.  ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("We have the right, in our sole and absolute discretion, (1) to edit, redact, or otherwise change any Contributions; (2) to re-categorize any Contributions to place them in more appropriate locations on the Site; and (3) to pre-screen or delete any Contributions at any time and for any reason, without notice. We have no obligation to monitor your Contributions.  ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("   ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("GUIDELINES FOR REVIEWS")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("We may provide you areas on the Site to leave reviews or ratings. When posting a review, you must comply with the following criteria: (1) you should have firsthand experience with the person/entity being reviewed; (2) your reviews should not contain offensive profanity, or abusive, racist, offensive, or hate language; (3) your reviews should not contain discriminatory references based on religion, race, gender, national origin, age, marital status, sexual orientation, or disability; (4) your reviews should not contain references to illegal activity; (5) you should not be affiliated with competitors if posting negative reviews; (6) you should not make any conclusions as to the legality of conduct; (7) you may not post any false or misleading statements; and (8) you may not organize a campaign encouraging others to post reviews, whether positive or negative.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v("We may accept, reject, or remove reviews in our sole discretion. We have absolutely no obligation to screen reviews or to delete reviews, even if anyone considers reviews objectionable or inaccurate. Reviews are not endorsed by us, and do not necessarily represent our opinions or the views of any of our affiliates or partners. We do not assume liability for any review or for any claims, liabilities, or losses resulting from any review. By posting a review, you")]),_c('span',{staticStyle:{"line-height":"115%"}},[_vm._v(" ")]),_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v("hereby grant to us a perpetual, non-exclusive, worldwide, royalty-free, fully-paid, assignable, and sublicensable right and license to reproduce, modify, translate, transmit by any means, display, perform, and/or distribute all content relating to reviews.")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v("   ")])])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("SOCIAL MEDIA")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("As part of the functionality of the Site, you may link your account with online accounts you have with third-party service providers (each such account, a “Third-Party Account”) by either: (1) providing your Third-Party Account login information through the Site; or (2) allowing us to access your Third-Party Account, as is permitted under the applicable terms and conditions that govern your use of each Third-Party Account. You represent and warrant that you are entitled to disclose your Third-Party Account login information to us and/or grant us access to your Third-Party Account, without breach by you of any of the terms and conditions that govern your use of the applicable Third-Party Account, and without obligating us to pay any fees or making us subject to any usage limitations imposed by the third-party service provider of the Third-Party Account. By granting us access to any Third-Party Accounts, you understand that (1) we may access, make available, and store (if applicable) any content that you have provided to and stored in your Third-Party Account (the “Social Network Content”) so that it is available on and through the Site via your account, including without limitation any friend lists and (2) we may submit to and receive from your Third-Party Account additional information to the extent you are notified when you link your account with the Third-Party Account. Depending on the Third-Party Accounts you choose and subject to the privacy settings that you have set in such Third-Party Accounts, personally identifiable information that you post to your Third-Party Accounts may be available on and through your account on the Site. Please note that if a Third-Party Account or associated service becomes unavailable or our access to such Third-Party Account is terminated by the third-party service provider, then Social Network Content may no longer be available on and through the Site. You will have the ability to disable the connection between your account on the Site and your Third-Party Accounts at any time. PLEASE NOTE THAT YOUR RELATIONSHIP WITH THE THIRD-PARTY SERVICE PROVIDERS ASSOCIATED WITH YOUR THIRD-PARTY ACCOUNTS IS GOVERNED SOLELY BY YOUR AGREEMENT(S) WITH SUCH THIRD-PARTY SERVICE PROVIDERS. We make no effort to review any Social Network Content for any purpose, including but not limited to, for accuracy, legality, or non-infringement, and we are not responsible for any Social Network Content. You acknowledge and agree that we may access your email address book associated with a Third-Party Account and your contacts list stored on your mobile device or tablet computer solely for purposes of identifying and informing you of those contacts who have also registered to use the Site. You can deactivate the connection between the Site and your Third-Party Account by contacting us using the contact information below or through your account settings (if applicable). We will attempt to delete any information stored on our servers that was obtained through such Third-Party Account, except the username and profile picture that become associated with your account.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("SUBMISSIONS")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("You acknowledge and agree that any questions, comments, suggestions, ideas, feedback, or other information regarding the Site (\"Submissions\") provided by you to us are non-confidential and shall become our sole property. We shall own exclusive rights, including all intellectual property rights, and shall be entitled to the unrestricted use and dissemination of these Submissions for any lawful purpose, commercial or otherwise, without acknowledgment or compensation to you. You hereby waive all moral rights to any such Submissions, and you hereby warrant that any such Submissions are original with you or that you have the right to submit such Submissions. You agree there shall be no recourse against us for any alleged or actual infringement or misappropriation of any proprietary right in your Submissions.")]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("THIRD-PARTY WEBSITES AND CONTENT")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("The Site may contain (or you may be sent via the Site) links to other websites (\"Third-Party Websites\") as well as articles, photographs, text, graphics, pictures, designs, music, sound, video, information, applications, software, and other content or items belonging to or originating from third parties (\"Third-Party Content\"). Such Third-Party Websites and Third-Party Content are not investigated, monitored, or checked for accuracy, appropriateness, or completeness by us, and we are not responsible for any Third-Party Websites accessed through the Site or any Third-Party Content posted on, available through, or installed from the Site, including the content, accuracy, offensiveness, opinions, reliability, privacy practices, or other policies of or contained in the Third-Party Websites or the Third-Party Content. Inclusion of, linking to, or permitting the use or installation of any Third-Party Websites or any Third-Party Content does not imply approval or endorsement thereof by us. If you decide to leave the Site and access the Third-Party Websites or to use or install any Third-Party Content, you do so at your own risk, and you should be aware these Terms of Use no longer govern. You should review the applicable terms and policies, including privacy and data gathering practices, of any website to which you navigate from the Site or relating to any applications you use or install from the Site. Any purchases you make through Third-Party Websites will be through other websites and from other companies, and we take no responsibility whatsoever in relation to such purchases which are exclusively between you and the applicable third party. You agree and acknowledge that we do not endorse the products or services offered on Third-Party Websites and you shall hold us harmless from any harm caused by your purchase of such products or services. Additionally, you shall hold us harmless from any losses sustained by you or harm caused to you relating to or resulting in any way from any Third-Party Content or any contact with Third-Party Websites.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("ADVERTISERS")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("We allow advertisers to display their advertisements and other information in certain areas of the Site, such as sidebar advertisements or banner advertisements. If you are an advertiser, you shall take full responsibility for any advertisements you place on the Site and any services provided on the Site or products sold through those advertisements. Further, as an advertiser, you warrant and represent that you possess all rights and authority to place advertisements on the Site, including, but not limited to, intellectual property rights, publicity rights, and contractual rights. "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("We ")])])]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")]),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("simply provide the space to place such advertisements, and we have no other relationship with advertisers.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("U.S. GOVERNMENT RIGHTS")])])])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11pt","line-height":"115%","color":"#595959","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-attachment":"initial","background-origin":"initial","background-clip":"initial"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-attachment":"initial","background-origin":"initial","background-clip":"initial"}},[_vm._v("Our services are “commercial items” as defined in Federal Acquisition Regulation (“FAR”) 2.101. If our services are acquired by or on behalf of any agency not within the Department of Defense (“DOD”), our services are subject to the terms of these Terms of Use in accordance with FAR 12.212 (for computer software) and FAR 12.211 (for technical data). If our services are acquired by or on behalf of any agency within the Department of Defense, our services are subject to the terms of these Terms of Use in accordance with Defense Federal Acquisition Regulation (“DFARS”) 227.7202")]),_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-attachment":"initial","background-origin":"initial","background-clip":"initial"}},[_vm._v("‑")]),_c('span',{staticStyle:{"line-height":"115%","color":"#595959","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-attachment":"initial","background-origin":"initial","background-clip":"initial"}},[_vm._v("3. In addition, DFARS 252.227")]),_c('span',{staticStyle:{"line-height":"115%","color":"#595959","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-attachment":"initial","background-origin":"initial","background-clip":"initial"}},[_vm._v("‑")])]),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-attachment":"initial","background-origin":"initial","background-clip":"initial"}},[_vm._v("7015 applies to technical data acquired by the DOD. This U.S. Government Rights clause is in lieu of, and supersedes, any other FAR, DFARS, or other clause or provision that addresses government rights in computer software or technical data under these Terms of Use.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("SITE MANAGEMENT")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("We reserve the right, but not the obligation, to: (1) monitor the Site for violations of these Terms of Use; (2) take appropriate legal action against anyone who, in our sole discretion, violates the law or these Terms of Use, including without limitation, reporting such user to law enforcement authorities; (3) in our sole discretion and without limitation, refuse, restrict access to, limit the availability of, or disable (to the extent technologically feasible) any of your Contributions or any portion thereof; (4) in our sole discretion and without limitation, notice, or liability, to remove from the Site or otherwise disable all files and content that are excessive in size or are in any way burdensome to our systems; and (5) otherwise manage the Site in a manner designed to protect our rights and property and to facilitate the proper functioning of the Site.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("PRIVACY POLICY")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("We care about data privacy and security. Please review our Privacy Policy:"),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("https://app.blablacommentz.com/dashboard/privacy ")])]),_vm._v(". By using the Site, you agree to be bound by our Privacy Policy, which is incorporated into these Terms of Use. Please be advised the Site is hosted in the United States. If you access the Site from the European Union, Asia, or any other region of the world with laws or other requirements governing personal data collection, use, or disclosure that differ from applicable laws in the United States, then through your continued use of the Site, ")]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("you are transferring your data to the United States, and you expressly consent to have your data transferred to and processed in the United States. "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("Further, we do not knowingly accept, request, or solicit information from children or knowingly market to children. Therefore, in accordance with the U.S. Children’s Online Privacy Protection Act, if we receive actual knowledge that anyone under the age of 13 has provided personal information to us without the requisite and verifiable parental consent, we will delete that information from the Site ")])])]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("  ")])])]),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("as quickly as is reasonably practical.")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("COPYRIGHT INFRINGEMENTS")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("We respect the intellectual property rights of others. If you believe that any material available on or through the Site infringes upon any copyright you own or control, please immediately notify us using the contact information provided below (a “Notification”). A copy of your Notification will be sent to the person who posted or stored the material addressed in the Notification. Please be advised that pursuant to federal law you may be held liable for damages if you make material misrepresentations in a Notification. Thus, if you are not sure that material located on or linked to by the Site infringes your copyright, you should consider first contacting an attorney.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("TERM AND TERMINATION")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("These Terms of Use shall remain in full force and effect while you use the Site. WITHOUT LIMITING ANY OTHER PROVISION OF THESE TERMS OF USE, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SITE (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE TERMS OF USE OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR USE OR PARTICIPATION IN THE SITE OR DELETE "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("YOUR ")])])]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("  ")])])]),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("ACCOUNT AND ")])]),_vm._v("ANY CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v("If we terminate or suspend your account for any reason, you are prohibited from registering and creating a new account under your name, a fake or borrowed name, or the name of any third party, even if you may be acting on behalf of the third party. In addition to terminating or suspending your account, we reserve the right to take appropriate legal action, including without limitation pursuing civil, criminal, and injunctive redress.")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"19px"}},[_vm._v("MODIFICATIONS AND INTERRUPTIONS")])])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("We reserve the right to change, modify, or remove the contents of the Site at any time or for any reason at our sole discretion without notice. However, we have no obligation to update any information on our Site. We also reserve the right to modify or discontinue all or part of the Site without notice at any time. We will not be liable to you or any third party for any modification, price change, suspension, or discontinuance of the Site.  ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('span',{staticStyle:{"line-height":"115%","color":"#595959"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("We cannot guarantee the Site will be available at all times. We may experience hardware, software, or other problems or need to perform maintenance related to the Site, resulting in interruptions, delays, or errors. We reserve the right to change, revise, update, suspend, discontinue, or otherwise modify the Site at any time or for any reason without notice to you. You agree that we have no liability whatsoever for any loss, damage, or inconvenience caused by your inability to access or use the Site during any downtime or discontinuance of the Site. Nothing in these Terms of Use will be construed to obligate us to maintain and support the Site or to supply any corrections, updates, or releases in connection therewith.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"19px"}},[_vm._v("GOVERNING LAW")])])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("These Terms of Use and your use of the Site are governed by and construed in accordance with the laws of the "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("Country ")])]),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v(" of")])]),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("Serbia ")])])]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("applicable to agreements made and to be entirely performed within the "),_c('strong',[_c('strong',{staticStyle:{"font-size":"14.6667px"},attrs:{"data-type":"if"}},[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"conditional-block"}},[_vm._v("Country of ")])])])]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_c('strong',[_c('strong',{staticStyle:{"font-size":"14.6667px"},attrs:{"data-type":"if"}},[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"conditional-block"}},[_vm._v("  ")])])])]),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_c('strong',[_c('strong',{staticStyle:{"font-size":"14.6667px"},attrs:{"data-type":"if"}},[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"conditional-block"}},[_vm._v("Serbia ")])])]),_vm._v(", without regard to its conflict of law principles. ")]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("DISPUTE RESOLUTION")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("Any legal action of whatever nature brought by either you or us (collectively, the “Parties” and individually, a “Party”) shall be commenced or prosecuted in the state and federal courts located in "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-id":"40eea829-de8e-e8ed-6f5d-f33e5a67f160","data-type":"question"}},[_vm._v("Serbia")])]),_vm._v(" County, "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-id":"bfee4bc3-e41e-d0fb-b2a6-eeba63bf170f","data-type":"question"}},[_vm._v("SRB")])]),_vm._v(" , and the Parties hereby consent to, and waive all defenses of lack of personal jurisdiction and forum non conveniens with respect to venue and jurisdiction in such state and federal courts. Application of the United Nations Convention on Contracts for the International Sale of Goods and the Uniform Computer Information Transaction Act (UCITA) are excluded from these Terms ")]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("of Use.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("CORRECTIONS")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("There may be information on the Site that contains typographical errors, inaccuracies, or omissions, including descriptions, pricing, availability, and various other information. We reserve the right to correct any errors, inaccuracies, or omissions and to change or update the information on the Site at any time, without prior notice.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("DISCLAIMER")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE OF THE SITE AND OUR SERVICES WILL BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SITE’S CONTENT OR THE CONTENT OF ANY WEBSITES LINKED TO THE SITE AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE SITE, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SITE, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("LIMITATIONS OF LIABILITY")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF THE SITE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("NOTWITHSTANDING ")])])]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("  ")])])]),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO ")])]),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("THE AMOUNT PAID, ")])])]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("  ")])])]),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("IF ANY, BY YOU TO US ")])]),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("  ")])])]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_c('span',{staticStyle:{"font-size":"15px","color":"#595959","text-transform":"uppercase"}},[_vm._v("DURING")]),_c('span',{staticStyle:{"font-size":"11pt","color":"#595959","text-transform":"uppercase"}},[_vm._v(" ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"15px","color":"#595959","text-transform":"uppercase"}},[_vm._v("THE THREE (3) MONTH PERIOD PRIOR TO ANY CAUSE OF ACTION ")]),_c('span',{staticStyle:{"font-size":"11pt","color":"#595959","text-transform":"uppercase"}},[_vm._v(" ")]),_c('span',{staticStyle:{"font-size":"15px","color":"#595959","text-transform":"uppercase"}},[_vm._v("ARISING")]),_vm._v(" ")])])]),_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v(".  CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("INDEMNIFICATION")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("You agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and all of our respective officers, agents, partners, and employees, from and against any loss, damage, liability, claim, or demand, including reasonable attorneys’ fees and expenses, made by any third party due to or arising out of: "),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("(1) your Contributions; ")])]),_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"},attrs:{"data-type":"if"}},[_vm._v("  ")])]),_vm._v("(2) use of the Site; (3) breach of these Terms of Use; (4) any breach of your representations and warranties set forth in these Terms of Use; (5) your violation of the rights of a third party, including but not limited to intellectual property rights; or (6) any overt harmful act toward any other user of the Site with whom you connected via the Site. Notwithstanding the foregoing, we reserve the right, at your expense, to assume the exclusive defense and control of any matter for which you are required to indemnify us, and you agree to cooperate, at your expense, with our defense of such claims. We will use reasonable efforts to notify you of any such claim, action, or proceeding which is subject to this indemnification upon becoming aware of it.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("USER DATA")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("We will maintain certain data that you transmit to the Site for the purpose of managing the performance of the Site, as well as data relating to your use of the Site. Although we perform regular routine backups of data, you are solely responsible for all data that you transmit or that relates to any activity you have undertaken using the Site. You agree that we shall have no liability to you for any loss or corruption of any such data, and you hereby waive any right of action against us arising from any such loss or corruption of such data.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("Visiting the Site, sending us emails, and completing online forms constitute electronic communications. You consent to receive electronic communications, and you agree that all agreements, notices, disclosures, and other communications we provide to you electronically, via email and on the Site, satisfy any legal requirement that such communication be in writing. YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SITE. You hereby waive any rights or requirements under any statutes, regulations, rules, ordinances, or other laws in any jurisdiction which require an original signature or delivery or retention of non-electronic records, or to payments or the granting of credits by any means other than electronic means.")]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("CALIFORNIA USERS AND RESIDENTS")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("If any complaint with us is not satisfactorily resolved, you can contact the Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs in writing at 1625 North Market Blvd., Suite N 112, Sacramento, California 95834 or by telephone at (800) 952-5210 or (916) 445-1254.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%","font-size":"19px"}},[_vm._v("MISCELLANEOUS")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("These Terms of Use and any policies or operating rules posted by us on the Site or in respect to the Site constitute the entire agreement and understanding between you and us. Our failure to exercise or enforce any right or provision of these Terms of Use shall not operate as a waiver of such right or provision. These Terms of Use operate to the fullest extent permissible by law. We may assign any or all of our rights and obligations to others at any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our reasonable control. If any provision or part of a provision of these Terms of Use is determined to be unlawful, void, or unenforceable, that provision or part of the provision is deemed severable from these Terms of Use and does not affect the validity and enforceability of any remaining provisions. There is no joint venture, partnership, employment or agency relationship created between you and us as a result of these Terms of Use or use of the Site. You agree that these Terms of Use will not be construed against us by virtue of having drafted them. You hereby waive any and all defenses you may have based on the electronic form of these Terms of Use and the lack of signing by the parties hereto to execute these Terms of Use.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"115%"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_c('span',{staticStyle:{"line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"19px"}},[_vm._v("CONTACT US")])])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"15px","line-height":"115%","color":"#595959"}},[_vm._v("In order to resolve a complaint regarding the Site or to receive further information regarding use of the Site, please contact us at:")]),_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("BlaBla Commentz")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("__________")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"14.6667px","color":"#595959"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("Nis ,   Serbia ")])])]),_c('span',{staticStyle:{"font-size":"14.6667px","color":"#595959"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("18000")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("__________")])])])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","line-height":"115%"}},[_c('span',{staticStyle:{"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"}},[_c('strong',[_c('strong',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("ndzakovic@yahoo.com")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QaVU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("rcNQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d79967f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("zVUp");
function injectStyle (ssrContext) {
  __webpack_require__("nYEN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d79967f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d79967f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QqJJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qz24":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"control has-addons flatpickr",class:( _obj = {}, _obj[("has-addons-" + _vm.alignment)] = _vm.alignment, _obj ),attrs:{"data-wrap":"true","data-clickOpens":"false"}},[_c('input',{staticClass:"input",class:_vm.inputClass,attrs:{"type":"text","placeholder":_vm.placeholder,"data-input":""},domProps:{"value":_vm.value}}),_vm._v(" "),_vm._t("default")],2)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R5vV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R6bT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("eU9U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78a8a174_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("VGIc");
function injectStyle (ssrContext) {
  __webpack_require__("TscU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78a8a174"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78a8a174_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R8dk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RBir":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_UserRepo__ = __webpack_require__("lyrB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Table__ = __webpack_require__("3/g/");

//
//
//
//
//
//
//
//
//
//
//
//
//
//




var fileDownload = __webpack_require__("3UNf");

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'users-view',
    components: { UsersTable: __WEBPACK_IMPORTED_MODULE_3__Table__["a" /* default */] },
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_UserRepo__["a" /* default */](this.$auth),
            users: [],
            total: 0,
            q: '',
            orderBy: 'users.id,asc',
            page: 1,
            sort: 'users.id',
            direction: 'asc'
        };
    },
    created: function created() {},

    methods: {
        onOrderBy: function onOrderBy(data) {
            this.sort = data.sort;
            this.direction = data.direction;
            //`console.log(data);
            this.getUsersForExport(data);
        },
        onPageChanged: function onPageChanged(data) {
            this.page = data.page;
            this.getUsersForExport(data);
        },
        onSearch: function onSearch(data) {
            this.page = 1;
            this.sort = 'users.id';
            this.direction = 'asc';
            this.getUsersForExport(data);
        },
        getUsersForExport: function getUsersForExport(data) {
            var _this = this;

            var search = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, {
                'sort': this.sort,
                'direction': this.direction,
                'page': this.page
            });
            this.repo.export(search).then(function (response) {
                if (search.export) {
                    fileDownload(response.data, 'export.csv');
                } else {
                    _this.users = response.data.data;
                    _this.total = response.data.meta.pagination.total_pages;
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "RKk3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SingleInput_vue__ = __webpack_require__("HFYB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e604b220_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SingleInput_vue__ = __webpack_require__("Bw0s");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SingleInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e604b220_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SingleInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RfaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("bLHn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5550bea9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("soJL");
function injectStyle (ssrContext) {
  __webpack_require__("4Cux")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5550bea9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5550bea9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SJrb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'privacy',
    components: {},
    created: function created() {},

    methods: {}
});

/***/ }),

/***/ "SrMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'premade-sentences-edit',
    components: {},
    data: function data() {
        return {
            loading: false,
            premadeSentences: [],
            schools: [],
            premadeSentence: { schools: [], premadeCategories: [], text: '' },
            premadeCategories: [],
            magicWords: []
        };
    },
    created: function created() {
        this.loadSchools();
        this.loadMagicWords();
    },

    methods: {
        getPremadeSentence: function getPremadeSentence(id) {
            var _this = this;

            this.premadeSentenceRepo.get(id).then(function (response) {
                _this.premadeSentence = response.data.data;
            });
        },
        save: function save() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this2;
                    _this2.loading = true;

                    _this2.premadeSentenceRepo.update(_this2.premadeSentence.id, _this2.premadeSentence).then(function (response) {

                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/premade-sentences');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        },
        loadSchools: function loadSchools() {
            var _this3 = this;

            this.loading = true;
            this.schoolRepo.all().then(function (response) {
                _this3.schools = response.data.data;
                _this3.loading = false;
                _this3.loadPremadeCategories();
            }).catch(function (response) {
                _this3.loading = false;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        },
        loadPremadeCategories: function loadPremadeCategories() {
            var _this4 = this;

            this.loading = true;
            this.premadeCategoryRepo.all().then(function (response) {
                _this4.premadeCategories = response.data.data;
                _this4.loading = false;
                _this4.getPremadeSentence(_this4.$route.params.id);
            }).catch(function (response) {
                _this4.loading = false;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        },
        loadMagicWords: function loadMagicWords() {
            var _this5 = this;

            this.loading = true;
            this.magicWordRepo.all().then(function (response) {
                _this5.magicWords = response.data.data;
                _this5.loading = false;
            }).catch(function (response) {
                _this5.loading = false;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        },
        addToSentence: function addToSentence(text) {
            this.premadeSentence.text = this.premadeSentence.text + text;
        }
    },
    watch: {}

});

/***/ }),

/***/ "Svtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CategoryList_vue__ = __webpack_require__("3MKM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryTag_vue__ = __webpack_require__("LOeR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SentenceTag_vue__ = __webpack_require__("Jees");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuedraggable__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'premade-comment',
    components: { CategoryList: __WEBPACK_IMPORTED_MODULE_3__CategoryList_vue__["a" /* default */], draggable: __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default.a, CategoryTag: __WEBPACK_IMPORTED_MODULE_4__CategoryTag_vue__["a" /* default */], SentenceTag: __WEBPACK_IMPORTED_MODULE_5__SentenceTag_vue__["a" /* default */] },
    props: ['loadedPremadeComment', 'update'],
    data: function data() {
        return {
            loading: false,
            schools: [],
            premadeComments: {},
            premadeComment: { premadeSentences: [], schools: [], text: '', html: '', caption: '', favorite: 1, score: 1 },
            sentence: '',
            premadeSentences: [],
            filteredSentences: [],
            choosedSentences: [],
            premadeCategories: [],
            categoryFilters: [],
            showSaveModal: false,
            saveCommentLoading: false
        };
    },
    created: function created() {
        this.loadSchools();
        this.loadPremadeCategories();
    },

    methods: {
        saveComment: function saveComment() {
            var _this = this;

            var self = this;
            this.premadeComment.premadeSentences = this.prepareSentencesForServer(this.choosedSentences);
            this.loading = true;
            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var _self = _this;
                    if (_this.update) {
                        _this.premadeCommentRepo.update(_this.premadeComment.id, _this.premadeComment).then(function (response) {
                            _self.loading = false;
                            _self.$toast.success(response.data.message);
                            _self.$router.push('/dashboard/premade-comments');
                        }).catch(function (response) {
                            _self.loading = false;
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(response);
                        });
                    } else {
                        _this.premadeCommentRepo.store(_this.premadeComment).then(function (response) {
                            _self.loading = false;
                            _self.$toast.success(response.data.message);
                            _self.$router.push('/dashboard/premade-comments');
                        }).catch(function (response) {
                            _self.loading = false;
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(response);
                        });
                    }
                }
            });
        },
        loadPremadeSentences: function loadPremadeSentences() {
            var _this2 = this;

            this.loading = true;
            this.premadeSentenceRepo.all().then(function (response) {
                _this2.premadeSentences = response.data.data;
                _this2.loading = false;
                if (_this2.premadeCategories.length > 0) {
                    _this2.premadeSentences = _this2.updateSentenceColor(_this2.premadeSentences, _this2.premadeCategories);
                }
                _this2.filteredSentences = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.premadeSentences));
            }).catch(function (response) {
                _this2.loading = false;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(response);
            });
        },
        loadPremadeCategories: function loadPremadeCategories() {
            var _this3 = this;

            this.loading = true;
            this.premadeCategoryRepo.all().then(function (response) {
                _this3.premadeCategories = response.data.data;
                _this3.loading = false;
                _this3.loadPremadeSentences();
            }).catch(function (response) {
                _this3.loading = false;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(response);
            });
        },
        togleCategoryFilter: function togleCategoryFilter(categoryFilters) {

            this.categoryFilters = categoryFilters;
            this.applyFilters();
        },
        applyFilters: function applyFilters() {
            var _this4 = this;

            var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'desc';

            var toKeep = [];
            this.filteredSentences = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.premadeSentences));
            if (this.categoryFilters.length > 0) {
                for (var j = 0; j < this.filteredSentences.length; j++) {
                    var sentence = this.filteredSentences[j];
                    var hasCategory = false;
                    for (var i = 0; i < this.categoryFilters.length; i++) {
                        var category = this.categoryFilters[i];
                        for (var k = 0; k < sentence.premadeCategories.length; k++) {
                            if (category.id == sentence.premadeCategories[k].id) {
                                hasCategory = true;
                                break;
                            }
                        }
                    }
                    if (hasCategory === true) {

                        toKeep.push(sentence);
                    }
                }

                this.filteredSentences = toKeep;
            }

            if (this.sentence != '') {
                this.filteredSentences = this.filteredSentences.filter(function (sentence) {
                    return sentence.text.toLowerCase().includes(_this4.sentence.toLowerCase());
                });
            }

            this.filteredSentences = _.orderBy(this.filteredSentences, function (e) {

                if (e.premadeCategories != null && e.premadeCategories.length > 0) {
                    return e.premadeCategories[0].id;
                }

                return e.id;
            }, [direction]);
        },
        addSentence: function addSentence(sentence) {
            this.choosedSentences.push(sentence);
            this.generateComment();
        },
        deleteSentence: function deleteSentence(index) {
            this.choosedSentences.splice(index, 1);
            this.generateComment();
        },
        clearChoosedSentences: function clearChoosedSentences() {
            this.choosedSentences = [];
            this.generateComment();
        },
        generateComment: function generateComment() {

            this.premadeComment.text = "";
            var self = this;
            var wasJoiner = false;
            _.forEach(this.choosedSentences, function (sentence) {

                if (!sentence.isJoiner) {
                    if (self.premadeComment.text != "") {
                        self.premadeComment.text += " ";
                    }
                    var filtered = sentence.text;
                    if (wasJoiner) {
                        filtered = filtered.charAt(0).toLowerCase() + filtered.slice(1);
                    }

                    self.premadeComment.text += filtered;
                } else {
                    var comment = self.premadeComment.text;
                    if (comment.substring(comment.length - 1) == "." || comment.substring(comment.length - 1) == "!" || comment.substring(comment.length - 1) == "," || comment.substring(comment.length - 1) == "?") {
                        comment = comment.substring(0, comment.length - 1);
                    }

                    self.premadeComment.text = comment + sentence.value;
                }

                wasJoiner = sentence.isJoiner;
            });

            this.premadeComment.html = this.$refs.editor.innerText = this.$refs.editor.innerHTML = this.premadeComment.text;
        }
    },
    watch: {
        sentence: _.debounce(function (value) {
            if (value.length >= 3) {

                this.searching = true;
                this.applyFilters();
                this.loading = false;
            } else if (value == '') {
                this.applyFilters();
            }
        }, 800),
        loadedPremadeComment: function loadedPremadeComment(value) {
            this.premadeComment.text = this.premadeComment.html = value.text;
            this.premadeComment.caption = value.caption;
            this.premadeComment.favorite = value.favorite;
            this.premadeComment.score = value.score;
            this.premadeComment.id = value.id;
            this.premadeComment.schools = value.schools;
            this.premadeComment.html = this.$refs.editor.innerText = this.$refs.editor.innerHTML = this.premadeComment.text;
            this.choosedSentences = this.prepareSentencesForClient(value.premadeSentences);
        }

    }

});

/***/ }),

/***/ "T7m2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TIav":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+" \n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{on:{"click":function($event){_vm.show(item.id)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.provider_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.nick))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.gender))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.school && item.school.name))]),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'student', params: { id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])]),_vm._v(" "),_c('router-link',{staticClass:"button is-warning tooltip",attrs:{"to":{ name: 'student-edit', params: { id: item.id }},"data-tooltip":"Edit"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-edit"})])]),_vm._v(" "),_c('button',{staticClass:"button is-danger tooltip",attrs:{"data-tooltip":"Delete"},on:{"click":function($event){_vm.showDeleteModal($event, item.id, index)}}},[_vm._m(1,true)])],1):_vm._e()])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TRxv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sb-lessons-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: { 'query': '', school: {}, status: 'requested' },
            statuses: ['requested', 'approved', 'declined'],
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Provider id',
                key: 'provider_id'
            }, {
                name: 'Name',
                key: 'name'
            }, {
                name: 'Words',
                key: 'words'
            }, {
                name: 'Status',
                key: 'status'
            }],
            reverse: true
        };
    },
    created: function created() {
        if (this.schools.length == 0) {
            this.loadSchools();
        }
        this.search.school = this.MAGIC_EARS;
    },

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        show: function show(lesson_id, id) {
            this.$router.push('/dashboard/sb-lesson-changes/' + lesson_id + '/' + id);
        },
        approve: function approve(event, item) {
            var _this = this;

            event.stopPropagation();
            this.stbyLessonRepo.approveChanges(item).then(function (response) {
                _this.$emit("approve", item.id);
                //this.$router.push('/dashboard/sb-lesson-changes');
            });
        },
        decline: function decline(event, item) {
            var _this2 = this;

            event.stopPropagation();
            this.stbyLessonRepo.declineChanges(item).then(function (response) {
                _this2.$emit("decline", item.id);
                //this.$router.push('/dashboard/sb-lesson-changes');
            });
        }
    },
    watch: {
        'search.query': _.debounce(function (value) {
            this.$emit("search", this.search);
        }, 800),

        'search.school': function searchSchool(value) {
            this.$emit("search", this.search);
        },
        'search.status': function searchStatus(value) {
            this.$emit("search", this.search);
        }
    },
    computed: {}
});

/***/ }),

/***/ "TscU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TuuF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TuvA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",attrs:{"id":"privacy"}},[_c('div',{attrs:{"id":"ppHeader"}},[_vm._v("Privacy Policy")]),_c('div',{attrs:{"id":"ppBody"}},[_c('div',{staticClass:"ppConsistencies"},[_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"quick-links text-center"},[_vm._v("Information Collection")])]),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"quick-links text-center"},[_vm._v("Information Usage")])]),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"quick-links text-center"},[_vm._v("Information Protection")])]),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"quick-links text-center"},[_vm._v("Cookie Usage")])]),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"quick-links text-center"},[_vm._v("3rd Party Disclosure")])]),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"quick-links text-center"},[_vm._v("3rd Party Links")])]),_c('div',{staticClass:"col-2"})]),_c('div',{staticStyle:{"clear":"both","height":"10px"}}),_c('div',{staticClass:"ppConsistencies"},[_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"col-12 quick-links2 gen-text-center"},[_vm._v("Google AdSense")])]),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"col-12 quick-links2 gen-text-center"},[_vm._v("\n        Fair Information Practices\n        "),_c('div',{staticClass:"col-8 gen-text-left gen-xs-text-center",staticStyle:{"font-size":"12px","position":"relative","left":"20px"}},[_vm._v("Fair information"),_c('br'),_vm._v(" Practices")])])]),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"col-12 quick-links2 gen-text-center coppa-pad"},[_vm._v("\n        COPPA\n\n    ")])]),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"col-12 quick-links2 quick4 gen-text-center caloppa-pad"},[_vm._v("\n        CalOPPA\n\n    ")])]),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"quick-links2 gen-text-center"},[_vm._v("Our Contact Information"),_c('br')])])]),_c('div',{staticStyle:{"clear":"both","height":"10px"}}),_vm._v(" "),_c('div',{staticClass:"innerText"},[_vm._v("This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. PII, as described in US privacy law and information security, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website."),_c('br')]),_c('span',{attrs:{"id":"infoCo"}}),_c('br'),_c('div',{staticClass:"grayText"},[_c('strong',[_vm._v("What personal information do we collect from the people that visit our blog, website or app?")])]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address  or other details to help you with your experience.")]),_c('br'),_c('div',{staticClass:"grayText"},[_c('strong',[_vm._v("When do we collect information?")])]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("We collect information from you when you register on our site or enter information on our site.")]),_c('br'),_vm._v(" "),_c('span',{attrs:{"id":"infoUs"}}),_c('br'),_c('div',{staticClass:"grayText"},[_c('strong',[_vm._v("How do we use your information? ")])]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v(" We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:"),_c('br'),_c('br')]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested.")]),_c('span',{attrs:{"id":"infoPro"}}),_c('br'),_c('div',{staticClass:"grayText"},[_c('strong',[_vm._v("How do we protect your information?")])]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("We do not use vulnerability scanning and/or scanning to PCI standards.")]),_c('div',{staticClass:"innerText"},[_vm._v("An external PCI compliant payment gateway handles all CC transactions.")]),_c('div',{staticClass:"innerText"},[_vm._v("We use regular Malware Scanning."),_c('br'),_c('br')]),_c('div',{staticClass:"innerText"},[_vm._v("Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (SSL) technology. ")]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("We implement a variety of security measures when a user enters, submits, or accesses their information to maintain the safety of your personal information.")]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("All transactions are processed through a gateway provider and are not stored or processed on our servers.")]),_c('span',{attrs:{"id":"coUs"}}),_c('br'),_c('div',{staticClass:"grayText"},[_c('strong',[_vm._v("Do we use 'cookies'?")])]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("We do not use cookies for tracking purposes ")]),_c('div',{staticClass:"innerText"},[_c('br'),_vm._v("You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies."),_c('br')]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("If you turn cookies off, Some of the features that make your site experience more efficient may not function properly.that make your site experience more efficient and may not function properly.")]),_c('br'),_c('span',{attrs:{"id":"trDi"}}),_c('br'),_c('div',{staticClass:"grayText"},[_c('strong',[_vm._v("Third-party disclosure")])]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information.")]),_c('span',{attrs:{"id":"trLi"}}),_c('br'),_c('div',{staticClass:"grayText"},[_c('strong',[_vm._v("Third-party links")])]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("Occasionally, at our discretion, we may include or offer third-party products or services on our website. These third-party sites have separate and independent privacy policies. We therefore have no responsibility or liability for the content and activities of these linked sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites.")]),_c('span',{attrs:{"id":"gooAd"}}),_c('br'),_c('div',{staticClass:"blueText"},[_c('strong',[_vm._v("Google")])]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users. https://support.google.com/adwordspolicy/answer/1316548?hl=en "),_c('br'),_c('br')]),_c('div',{staticClass:"innerText"},[_vm._v("We use Google AdSense Advertising on our website.")]),_c('div',{staticClass:"innerText"},[_c('br'),_vm._v("Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy."),_c('br')]),_c('div',{staticClass:"innerText"},[_c('br'),_c('strong',[_vm._v("We have implemented the following:")])]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" Remarketing with Google AdSense")]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" Google Display Network Impression Reporting")]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" Demographics and Interests Reporting")]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" DoubleClick Platform Integration"),_c('br')]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website. ")]),_c('div',{staticClass:"innerText"},[_c('br'),_c('strong',[_vm._v("Opting out:")]),_c('br'),_vm._v("\n        Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on.")]),_c('span',{attrs:{"id":"calOppa"}}),_c('br'),_c('div',{staticClass:"blueText"},[_c('strong',[_vm._v("California Online Privacy Protection Act")])]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy.  The law's reach stretches well beyond California to require any person or company in the United States (and conceivably the world) that operates websites collecting Personally Identifiable Information from California consumers to post a conspicuous privacy policy on its website stating exactly the information being collected and those individuals or companies with whom it is being shared. -  See more at: http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf"),_c('br')]),_c('div',{staticClass:"innerText"},[_c('br'),_c('strong',[_vm._v("According to CalOPPA, we agree to the following:")]),_c('br')]),_c('div',{staticClass:"innerText"},[_vm._v("Users can visit our site anonymously.")]),_c('div',{staticClass:"innerText"},[_vm._v("Once this privacy policy is created, we will add a link to it on our home page or as a minimum, on the first significant page after entering our website."),_c('br')]),_c('div',{staticClass:"innerText"},[_vm._v("Our Privacy Policy link includes the word 'Privacy' and can easily be found on the page specified above.")]),_c('div',{staticClass:"innerText"},[_c('br'),_vm._v("You will be notified of any Privacy Policy changes:")]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" On our Privacy Policy Page"),_c('br')]),_c('div',{staticClass:"innerText"},[_vm._v("Can change your personal information:")]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" By logging in to your account")]),_c('div',{staticClass:"innerText"},[_c('br'),_c('strong',[_vm._v("How does our site handle Do Not Track signals?")]),_c('br')]),_c('div',{staticClass:"innerText"},[_vm._v("We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place. ")]),_c('div',{staticClass:"innerText"},[_c('br'),_c('strong',[_vm._v("Does our site allow third-party behavioral tracking?")]),_c('br')]),_c('div',{staticClass:"innerText"},[_vm._v("It's also important to note that we do not allow third-party behavioral tracking")]),_c('span',{attrs:{"id":"coppAct"}}),_c('br'),_c('div',{staticClass:"blueText"},[_c('strong',[_vm._v("COPPA (Children Online Privacy Protection Act)")])]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("When it comes to the collection of personal information from children under the age of 13 years old, the Children's Online Privacy Protection Act (COPPA) puts parents in control.  The Federal Trade Commission, United States' consumer protection agency, enforces the COPPA Rule, which spells out what operators of websites and online services must do to protect children's privacy and safety online."),_c('br'),_c('br')]),_c('div',{staticClass:"innerText"},[_vm._v("We do not specifically market to children under the age of 13 years old.")]),_c('span',{attrs:{"id":"ftcFip"}}),_c('br'),_c('div',{staticClass:"blueText"},[_c('strong',[_vm._v("Fair Information Practices")])]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("The Fair Information Practices Principles form the backbone of privacy law in the United States and the concepts they include have played a significant role in the development of data protection laws around the globe. Understanding the Fair Information Practice Principles and how they should be implemented is critical to comply with the various privacy laws that protect personal information."),_c('br'),_c('br')]),_c('div',{staticClass:"innerText"},[_c('strong',[_vm._v("In order to be in line with Fair Information Practices we will take the following responsive action, should a data breach occur:")])]),_c('div',{staticClass:"innerText"},[_vm._v("We will notify you via email")]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" Within 7 business days")]),_c('div',{staticClass:"innerText"},[_c('br'),_vm._v("We also agree to the Individual Redress Principle which requires that individuals have the right to legally pursue enforceable rights against data collectors and processors who fail to adhere to the law. This principle requires not only that individuals have enforceable rights against data users, but also that individuals have recourse to courts or government agencies to investigate and/or prosecute non-compliance by data processors.")]),_c('span',{attrs:{"id":"canSpam"}}),_c('br'),_c('div',{staticClass:"blueText"},[_c('strong',[_vm._v("CAN SPAM Act")])]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial messages, gives recipients the right to have emails stopped from being sent to them, and spells out tough penalties for violations."),_c('br'),_c('br')]),_c('div',{staticClass:"innerText"},[_c('strong',[_vm._v("We collect your email address in order to:")])]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" Send information, respond to inquiries, and/or other requests or questions")]),_c('div',{staticClass:"innerText"},[_c('br'),_c('strong',[_vm._v("To be in accordance with CANSPAM, we agree to the following:")])]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" Not use false or misleading subjects or email addresses.")]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" Identify the message as an advertisement in some reasonable way.")]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" Include the physical address of our business or site headquarters.")]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" Monitor third-party email marketing services for compliance, if one is used.")]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" Honor opt-out/unsubscribe requests quickly.")]),_c('div',{staticClass:"innerText"},[_vm._v("      "),_c('strong',[_vm._v("•")]),_vm._v(" Allow users to unsubscribe by using the link at the bottom of each email.")]),_c('div',{staticClass:"innerText"},[_c('strong',[_c('br'),_vm._v("If at any time you would like to unsubscribe from receiving future emails, you can email us at")])]),_c('div',{staticClass:"innerText"},[_vm._v("ndzakovic@yahoo.com and we will promptly remove you from "),_c('strong',[_vm._v("ALL")]),_vm._v(" correspondence.")]),_c('br'),_c('span',{attrs:{"id":"ourCon"}}),_c('br'),_c('div',{staticClass:"blueText"},[_c('strong',[_vm._v("Contacting Us")])]),_c('br'),_c('div',{staticClass:"innerText"},[_vm._v("If there are any questions regarding this privacy policy, you may contact us using the information below."),_c('br'),_c('br')]),_c('div',{staticClass:"innerText"},[_vm._v("blablacommentz.com")]),_vm._v("Nis, Nis 18000 "),_c('div',{staticClass:"innerText"},[_vm._v("Serbia")]),_c('div',{staticClass:"innerText"},[_vm._v("ndzakovic@yahoo.com")]),_c('div',{staticClass:"innerText"},[_c('br'),_vm._v("Last Edited on 2017-12-02")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U1zr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+" \n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{on:{"click":function($event){_vm.show(item.id)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Array.prototype.map.call(item.premadeCategories, function(item) { return item.name; }).join(",")))]),_vm._v(" "),(item.schools)?_c('td',[_vm._v(" "+_vm._s(Array.prototype.map.call(item.schools, function(item) { return item.name; }).join(",")))]):_c('td',[_vm._v("All schools")]),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'premade-sentence', params: { id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])]),_vm._v(" "),_c('router-link',{staticClass:"button is-warning tooltip",attrs:{"to":{ name: 'premade-sentence-edit', params: { id: item.id }},"data-tooltip":"Edit"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-edit"})])]),_vm._v(" "),_c('button',{staticClass:"button is-danger tooltip",attrs:{"data-tooltip":"Delete"},on:{"click":function($event){_vm.showDeleteModal($event, item.id, index)}}},[_vm._m(1,true)])],1):_vm._e()])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U32u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CategoryItem__ = __webpack_require__("zTKs");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CategoryList',
    components: { CategoryItem: __WEBPACK_IMPORTED_MODULE_1__CategoryItem__["a" /* default */] },
    props: {
        categories: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        // Is  draggable
        draggable: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            categoryFilters: [],
            newCategories: []
        };
    },
    created: function created() {},
    mounted: function mounted() {},

    methods: {
        end: function end(data) {

            this.$emit('reordered', this.newCategories);
        },
        togleCategoryFilter: function togleCategoryFilter(category) {

            var index = this.inCategoryFilters(category);

            if (index == -1) {
                this.categoryFilters = [];
                this.categoryFilters.push(category);
            } else {
                this.categoryFilters.splice(index, 1);
            }

            this.$emit('click', this.categoryFilters);
        },
        selectCategory: function selectCategory(category) {
            this.$emit('click', category);
        },
        inCategoryFilters: function inCategoryFilters(category) {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.indexOf(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.categoryFilters, 'id'), category.id);
        },
        toggleClick: function toggleClick() {

            this.$emit('click', this.category);
        }
    },
    watch: {
        categories: function categories(val) {
            this.newCategories = val;
        }
    }

});

/***/ }),

/***/ "Uami":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UayT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("qj2z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66cef508_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("BSq8");
function injectStyle (ssrContext) {
  __webpack_require__("OPFZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66cef508"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66cef508_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UdIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ue8q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjI3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UkDw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("VXQX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed06f668_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("Gom6");
function injectStyle (ssrContext) {
  __webpack_require__("u64L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ed06f668"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed06f668_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UmuT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+" \n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{on:{"click":function($event){_vm.show(item.id)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('td',{staticClass:"has-text-centered"},[(item.favorite == true)?_c('i',{staticClass:"fa fa-check has-text-success"}):_c('i',{staticClass:"fa fa-times has-text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.count))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.score))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.user && item.user.profile && item.user.profile.nick))]),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'comment', params: { id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])]),_vm._v(" "),_c('button',{staticClass:"button is-danger tooltip",attrs:{"data-tooltip":"Delete"},on:{"click":function($event){_vm.showDeleteModal($event, item.id, index)}}},[_vm._m(1,true)])],1):_vm._e()])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UztG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("wFDd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40586f4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("mvwp");
function injectStyle (ssrContext) {
  __webpack_require__("kK/n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40586f4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40586f4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V/pO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Http__ = __webpack_require__("OK7G");



/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES


// private sector
var $http = void 0;

//public sector

var CommentRepo = function () {
    function CommentRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CommentRepo);

        $http = new __WEBPACK_IMPORTED_MODULE_3__services_Http__["a" /* default */]($auth);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CommentRepo, [{
        key: 'show',
        value: function show(id) {
            return $http.get(CommentRepo.$resource + "/" + id + "?include=user.profile,sentences").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'store',
        value: function store(data) {
            return $http.post(CommentRepo.$resource, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'all',
        value: function all() {
            return $http.get(CommentRepo.$resource + "?include=user.profile,sentences").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'paginate',
        value: function paginate(page, q, orderBy) {
            var query = "page=" + page + "&include=user.profile,sentences";
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(CommentRepo.$resource + "/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'update',
        value: function update(id, data) {
            return $http.put(CommentRepo.$resource + "/" + id, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            return $http.delete(CommentRepo.$resource + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }]);

    return CommentRepo;
}();

CommentRepo.$resource = 'comments';
/* harmony default export */ __webpack_exports__["a"] = (CommentRepo);

/***/ }),

/***/ "V0CI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("Y4Yd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e187e0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("cMDo");
function injectStyle (ssrContext) {
  __webpack_require__("+GBL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e187e0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e187e0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V6+6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var HelperArrays = function () {
    function HelperArrays() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, HelperArrays);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(HelperArrays, [{
        key: 'joiners',
        value: function joiners() {
            return [{
                text: 'and',
                value: ', and',
                isJoiner: true
            }, {
                text: 'but',
                value: ', but',
                isJoiner: true
            }, {
                text: 'however',
                value: ', however',
                isJoiner: true
            }, {
                text: 'even',
                value: ', even',
                isJoiner: true
            }, {
                text: 'additionally',
                value: ', additionally',
                isJoiner: true
            }];
        }
    }]);

    return HelperArrays;
}();

/* harmony default export */ __webpack_exports__["a"] = (HelperArrays);

/***/ }),

/***/ "V9jG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_UserRepo__ = __webpack_require__("lyrB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repos_RoleRepo__ = __webpack_require__("nzVJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'users-add',
    components: {},
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_UserRepo__["a" /* default */](this.$auth),
            roleRepo: new __WEBPACK_IMPORTED_MODULE_2__repos_RoleRepo__["a" /* default */](this.$auth),
            loading: false,
            roles: [],
            projects: [],
            user: { role: 'user', projects: [] }
        };
    },
    created: function created() {
        this.getRoles();
    },

    methods: {
        getRoles: function getRoles() {
            var _this = this;

            this.roleRepo.all().then(function (response) {
                _this.roles = response.data.data;
            });
        },
        save: function save() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this2;
                    _this2.loading = true;
                    _this2.repo.store(_this2.user).then(function (response) {
                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "VGIc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[_c('nav',{staticClass:"navbar is-dark is-fixed-top"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-brand"},[_c('router-link',{staticClass:"navbar-item",attrs:{"to":_vm.routes.length > 0 ? _vm.routes[0].to : ''}},[_c('img',{staticClass:"logo is-paddingless",attrs:{"src":'/static/img/transparent.png'}}),_vm._v(" "),_c('section',{staticClass:"hero is-hidden-mobile"},[_c('div',{staticClass:"hero-body"},[_c('div',{},[_c('h1',{staticClass:"title has-text-primary"},[_c('img',{staticClass:"header",attrs:{"src":'/static/img/header.png'}})])])])])]),_vm._v(" "),_vm._m(0)],1)])]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline",staticStyle:{"margin-bottom":"100px"}},[_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"menu columns box"},[_c('div',{staticClass:"column"},[_c('aside',[_c('p',{staticClass:"menu-label is-2"},[_vm._v("\n                            Dashboard\n                          ")]),_vm._v(" "),_c('ul',{staticClass:"menu-list"},[_vm._l((_vm.routes),function(route){return _c('li',[_c('router-link',{class:{'is-active': _vm.routeMatch(route.to)},attrs:{"to":route.to}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa",class:route.icon})]),_vm._v(" "+_vm._s(route.heading)+"\n                                  ")])],1)}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.logout()}}},[_vm._m(1),_vm._v(" Logout\n                                  ")])])],2)])])])]),_vm._v(" "),_c('div',{staticClass:"column is-10 is-12-mobile is-12-touch"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)]),_vm._v(" "),_c('footer',{staticClass:"footer has-shadow fix-footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content has-text-centered"},[_c('div',{staticClass:"columns is-multiline",staticStyle:{"margin-bottom":"-20px"}},[_c('div',{staticClass:"column is-4 has-text-left"},[_c('router-link',{attrs:{"to":"/dashboard/terms"}},[_c('u',[_vm._v("Terms and Conditions")])])],1),_vm._v(" "),_c('div',{staticClass:"column is-4 has-text-centered"},[_c('router-link',{attrs:{"to":"/dashboard/ticket"}},[_c('u',[_vm._v("Contact us")])])],1),_vm._v(" "),_c('div',{staticClass:"column is-4 has-text-right"},[_c('router-link',{attrs:{"to":"/dashboard/privacy"}},[_c('u',[_vm._v("Privacy policy")])])],1)]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Copyright © "+_vm._s(new Date().getFullYear())+" "),_c('span',{staticClass:"has-text-primary"},[_vm._v("BlaBla Commentz")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-burger burger is-hidden-desktop",attrs:{"data-target":"navbar-mobile"}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-power-off"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VL+6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VMRg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Http__ = __webpack_require__("OK7G");




/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES


// private sector
var $http = void 0;

//public sector

var LessonRepo = function () {
    function LessonRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LessonRepo);

        $http = new __WEBPACK_IMPORTED_MODULE_3__services_Http__["a" /* default */]($auth);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LessonRepo, [{
        key: 'show',
        value: function show(id) {
            return $http.get(LessonRepo.$resource + "/" + id + "?include=school").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'store',
        value: function store(data) {
            return $http.post(LessonRepo.$resource, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'all',
        value: function all() {
            return $http.get(LessonRepo.$resource + "?include=school").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'paginate',
        value: function paginate(data) {
            var query = "include=school";
            return $http.post(LessonRepo.$resource + "/paginate?" + query, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'update',
        value: function update(id, data) {
            return $http.put(LessonRepo.$resource + "/" + id, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            return $http.delete(LessonRepo.$resource + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }]);

    return LessonRepo;
}();

LessonRepo.$resource = 'lessons';
/* harmony default export */ __webpack_exports__["a"] = (LessonRepo);

/***/ }),

/***/ "VXQX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'login',
    components: {},
    data: function data() {
        return {
            email: '',
            password: '',
            loading: false
        };
    },
    created: function created() {},
    mounted: function mounted() {

        var social = this.$route.query.social;
        var self = this;
        if (social) {
            setTimeout(function () {
                self.authenticate(social);
            }, 500);
        }
    },

    methods: {
        login: function login() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this;
                    _this.loading = true;
                    _this.$auth.login({ email: _this.email, password: _this.password }).then(function () {
                        self.loading = false;
                        self.$router.push(self.$route.query.redirect || '/dashboard');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response.response);
                    });
                }
            });
        },
        authenticate: function authenticate(provider) {
            var component = this;
            console.log(provider);
            this.$auth.authenticate(provider).then(function () {
                component.$router.push('/dashboard');
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response.response);
            });
        }
    }

});

/***/ }),

/***/ "VZOn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column"},[_c('lessons-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.lessons,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged,"approve":_vm.approvedChanges,"decline":_vm.declinedChanges}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" StandBy Lesson Changes")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ViIf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('router-link',{staticClass:"button is-info is-pulled-right",attrs:{"to":{name: 'add-lesson' }}},[_vm._v("Add new")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('lessons-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.lessons,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" Lessons")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vj6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"label has-text-grey-dark"},[_vm._v("Created Account From:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"is-info is-fullwidth"},[_c('datepicker',{attrs:{"placeholder":"","config":{ enableTime: false, dateFormat: 'Y-m-d' }},model:{value:(_vm.search.start_date),callback:function ($$v) {_vm.$set(_vm.search, "start_date", $$v)},expression:"search.start_date"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"label has-text-grey-dark"},[_vm._v("Created Account To:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"is-info is-fullwidth"},[_c('datepicker',{attrs:{"placeholder":"","config":{ enableTime: false, dateFormat: 'Y-m-d' }},model:{value:(_vm.search.end_date),callback:function ($$v) {_vm.$set(_vm.search, "end_date", $$v)},expression:"search.end_date"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"label has-text-grey-dark"},[_vm._v("Last Login From:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"is-info is-fullwidth"},[_c('datepicker',{attrs:{"placeholder":"","config":{ enableTime: false, dateFormat: 'Y-m-d' }},model:{value:(_vm.search.ll_from),callback:function ($$v) {_vm.$set(_vm.search, "ll_from", $$v)},expression:"search.ll_from"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"label has-text-grey-dark"},[_vm._v("Last Login To:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"is-info is-fullwidth"},[_c('datepicker',{attrs:{"placeholder":"","config":{ enableTime: false, dateFormat: 'Y-m-d' }},model:{value:(_vm.search.ll_to),callback:function ($$v) {_vm.$set(_vm.search, "ll_to", $$v)},expression:"search.ll_to"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"label has-text-grey-dark"},[_vm._v("Next Billing Date From:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"is-info is-fullwidth"},[_c('datepicker',{attrs:{"placeholder":"","config":{ enableTime: false, dateFormat: 'Y-m-d' }},model:{value:(_vm.search.nbt_from),callback:function ($$v) {_vm.$set(_vm.search, "nbt_from", $$v)},expression:"search.nbt_from"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"label has-text-grey-dark"},[_vm._v("Next Billing Date To:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"is-info is-fullwidth"},[_c('datepicker',{attrs:{"placeholder":"","config":{ enableTime: false, dateFormat: 'Y-m-d' }},model:{value:(_vm.search.nbt_to),callback:function ($$v) {_vm.$set(_vm.search, "nbt_to", $$v)},expression:"search.nbt_to"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"label has-text-grey-dark"},[_vm._v("Extended trial:")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.extended),expression:"search.extended"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.search, "extended", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Both")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Yes")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("No")])])])])]),_vm._v(" "),_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"label has-text-grey-dark"},[_vm._v("Logged In Min Times:")]),_vm._v(" "),_c('div',{staticClass:"is-fullwidth"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.logged_in),expression:"search.logged_in"}],staticClass:"input",attrs:{"type":"number"},domProps:{"value":(_vm.search.logged_in)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "logged_in", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"label has-text-grey-dark"},[_vm._v("Subscription status:")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.sub_status),expression:"search.sub_status"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.search, "sub_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Any")]),_vm._v(" "),_vm._l((_vm.subscription_status),function(item){return _c('option',{domProps:{"value":item.id}},[_vm._v(_vm._s(item.text))])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"label has-text-grey-dark"},[_vm._v("Subscription plan:")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.sub_plan),expression:"search.sub_plan"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.search, "sub_plan", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Both(with and without)")]),_vm._v(" "),_vm._l((_vm.subscription_plans),function(item){return _c('option',{domProps:{"value":item.id}},[_vm._v(_vm._s(item.text))])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"label has-text-grey-dark"},[_vm._v("School:")]),_vm._v(" "),_c('div',{staticClass:"select is-info is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.schools),expression:"search.schools"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.search, "schools", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Any")]),_vm._v(" "),_vm._l((_vm.schools),function(school){return _c('option',{domProps:{"value":school.id}},[_vm._v(_vm._s(school.name))])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"label has-text-grey-dark",staticStyle:{"color":"transparent !important"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"is-info is-fullwidth"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.clearSearch()}}},[_vm._v("Clear Search")])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"label has-text-grey-dark",staticStyle:{"color":"transparent !important"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"is-info is-fullwidth"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.filter(false)}}},[_vm._v("Search")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"label has-text-grey-dark",staticStyle:{"color":"transparent !important"}},[_vm._v("Export")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"is-info is-fullwidth"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-primary"},on:{"click":function($event){_vm.filter(true)}}},[_vm._v("Export")])],1)])])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                        "+_vm._s(col.name)+" \n                        "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{on:{"click":function($event){_vm.show(item.id)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.profile && item.profile.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.subscription && item.subscription.next_bill_date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.subscription && item.subscription.plan))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.last_login))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.created_at.date))])])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-12"},[_c('h1',{staticClass:"title is-2"},[_vm._v("Filters:")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VxLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'terms',
    components: {},
    created: function created() {},

    methods: {}
});

/***/ }),

/***/ "W2Lf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-8"},[_c('div',{staticClass:"field"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.premadeSentence.text),expression:"premadeSentence.text"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"is-primary textarea",class:{'input': true, 'is-danger': _vm.errors.has('text') },attrs:{"name":"text","type":"text","placeholder":"Text"},domProps:{"value":(_vm.premadeSentence.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.premadeSentence, "text", $event.target.value)}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade-fast"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('text')),expression:"errors.has('text')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('text')))])]),_vm._v(" "),_c('div',{staticClass:"p5"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.magicWords),function(item,index){return _c('span',{staticClass:"help"},[_c('a',{attrs:{"href":"javascript:{}"},domProps:{"innerHTML":_vm._s(item.alias)},on:{"click":function($event){_vm.addToSentence(item.alias)}}}),_vm._v(" - "),_c('span',{domProps:{"innerHTML":_vm._s(item.description)}})])})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"field"},[_c('multiselect',{attrs:{"label":"name","track-by":"name","name":"categories","placeholder":"Choose category","options":_vm.premadeCategories,"multiple":false},model:{value:(_vm.premadeSentence.premadeCategories[0]),callback:function ($$v) {_vm.$set(_vm.premadeSentence.premadeCategories, 0, $$v)},expression:"premadeSentence.premadeCategories[0]"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('multiselect',{attrs:{"placeholder":"Choose schools","label":"name","track-by":"name","name":"schools","options":_vm.schools,"multiple":true},model:{value:(_vm.premadeSentence.schools),callback:function ($$v) {_vm.$set(_vm.premadeSentence, "schools", $$v)},expression:"premadeSentence.schools"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-2  is-offset-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v(" Sentences")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"help"},[_vm._v("In order to make sentences viable for any student, use magic templates like shown below "),_c('span',{staticClass:"has-text-info"},[_vm._v("(click on any of items in order to add it to sentence above)")]),_vm._v(":")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WCSi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_STBYLesson__ = __webpack_require__("tiiL");
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sb-lessons-edit',
  components: { STBYLesson: __WEBPACK_IMPORTED_MODULE_0__components_STBYLesson__["a" /* default */] },
  data: function data() {
    return {
      lesson: { additionalInfo: {} }
    };
  },
  created: function created() {
    this.getLesson(this.$route.params.id);
  },

  methods: {
    getLesson: function getLesson(id) {
      var _this = this;

      this.stbyLessonRepo.show(id).then(function (response) {
        _this.lesson = response.data.data;
        console.log(_this.lesson);
        if (!_this.lesson.additionalInfo) {
          _this.lesson.additionalInfo = { name: '', provider_id: '', provider_full_id: '', words: '' };
        }
        if (_this.lesson.school) {
          _this.lesson.school_id = _this.lesson.school.id;
        }
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "WGvK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("akR0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0797ef6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("ilwF");
function injectStyle (ssrContext) {
  __webpack_require__("cpHN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0797ef6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0797ef6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WImk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.wrap ? 'WrapperInput' : 'SingleInput',{tag:"component",attrs:{"value":_vm.date,"placeholder":_vm.placeholder,"inputClass":_vm.inputClass,"alignment":_vm.alignment}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WK54":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"button clickable",class:{'is-outlined': !_vm.selected},style:(_vm.style),on:{"mouseenter":_vm.setSelectedStyle,"mouseleave":_vm.setNormalStyle,"click":_vm.toggleClick}},[_vm._v(_vm._s(_vm.category.name))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wd1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("WCSi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36adfca4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("1eIv");
function injectStyle (ssrContext) {
  __webpack_require__("8UkF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36adfca4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36adfca4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WkxT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_SchoolRepo__ = __webpack_require__("gh8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'schools-show',
  components: {},
  data: function data() {
    return {
      repo: new __WEBPACK_IMPORTED_MODULE_0__repos_SchoolRepo__["a" /* default */](this.$auth),
      item: {}
    };
  },
  created: function created() {
    this.getSchool(this.$route.params.id);
  },

  methods: {
    getSchool: function getSchool(id) {
      var _this = this;

      this.repo.show(id).then(function (response) {
        _this.item = response.data.data;
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "Wluu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'premade-sentences-add',
    components: {},
    data: function data() {
        return {
            loading: false,
            schools: [],
            magicWords: [],
            premadeSentences: {},
            premadeSentence: { schools: [], premadeCategories: [], text: '' },
            premadeCategories: []
        };
    },
    created: function created() {
        this.loadSchools();
        this.loadMagicWords();
    },

    methods: {
        save: function save() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this;
                    _this.loading = true;
                    _this.premadeSentenceRepo.store(_this.premadeSentence).then(function (response) {
                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/premade-sentences');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        },
        loadSchools: function loadSchools() {
            var _this2 = this;

            this.loading = true;
            this.schoolRepo.all().then(function (response) {
                _this2.schools = response.data.data;
                _this2.loading = false;
                _this2.loadPremadeCategories();
            }).catch(function (response) {
                _this2.loading = false;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        },
        loadMagicWords: function loadMagicWords() {
            var _this3 = this;

            this.loading = true;
            this.magicWordRepo.all().then(function (response) {
                _this3.magicWords = response.data.data;
                _this3.loading = false;
            }).catch(function (response) {
                _this3.loading = false;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        },
        loadPremadeCategories: function loadPremadeCategories() {
            var _this4 = this;

            this.loading = true;
            this.premadeCategoryRepo.all().then(function (response) {
                _this4.premadeCategories = response.data.data;
                _this4.loading = false;
            }).catch(function (response) {
                _this4.loading = false;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        },
        addToSentence: function addToSentence(text) {
            this.premadeSentence.text = this.premadeSentence.text + text;
        }
    },
    watch: {}

});

/***/ }),

/***/ "WnvN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SentenceTag',
    components: {},
    props: ['sentence', 'text'],
    data: function data() {
        return {
            loading: false,
            saving: false
        };
    },
    created: function created() {},
    mounted: function mounted() {},

    methods: {},
    watch: {}

});

/***/ }),

/***/ "Wzr8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X89I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__("hj5Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0d9d4a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__("fcWh");
function injectStyle (ssrContext) {
  __webpack_require__("VL+6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f0d9d4a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0d9d4a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X9zB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PremadeComment_vue__ = __webpack_require__("mRqq");
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'premade-sentences-edit',
    components: { PremadeComment: __WEBPACK_IMPORTED_MODULE_1__components_PremadeComment_vue__["a" /* default */] },
    data: function data() {
        return {
            premadeComment: { premadeSentences: [], schools: [], text: '', html: '', caption: '', favorite: 1, score: 1 }
        };
    },
    created: function created() {
        this.getPremadeComment(this.$route.params.id);
    },

    methods: {
        getPremadeComment: function getPremadeComment(id) {
            var _this = this;

            this.premadeCommentRepo.get(id).then(function (response) {
                _this.premadeComment = response.data.data;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "Xb/0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XjSL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xsxh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("GWl8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24abd2bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("OvVz");
function injectStyle (ssrContext) {
  __webpack_require__("R5vV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24abd2bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24abd2bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xu1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.sentence.isJoiner)?_c('p',{staticClass:"sentence-font-size tag multiline-text zero-vertical-margin",style:({'background-color' : _vm.sentence.premadeCategories[0].color, 'color' : _vm.sentence.premadeCategories[0].text_color})},[_vm._v(_vm._s(_vm.text))]):_c('p',{staticClass:"sentence-font-size height-min-content zero-vertical-margin tag is-light"},[_vm._v(_vm._s(_vm.sentence.text))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xy3J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"email","rules":"required|email","placeholder":"Email"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"type":"password","name":"password","rules":"required|min:6","placeholder":"Password"},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"type":"password","name":"password_confirmation","rules":"required","placeholder":"Confirm password"},model:{value:(_vm.user.password_confirmation),callback:function ($$v) {_vm.$set(_vm.user, "password_confirmation", $$v)},expression:"user.password_confirmation"}})],1)]),_vm._v(" "),(_vm.roles && _vm.roles.length > 0)?_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Roles:")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.role),expression:"user.role"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.user, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.roles),function(role){return _c('option',{domProps:{"value":role.name}},[_vm._v(_vm._s(role.name))])}),0)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" Users")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y4Yd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_NewsRepo__ = __webpack_require__("O7DD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_ace__ = __webpack_require__("L3z5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_ace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_ace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_brace_mode_html__ = __webpack_require__("hCU/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_brace_mode_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_brace_mode_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_brace_theme_monokai__ = __webpack_require__("eKfU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_brace_theme_monokai___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_brace_theme_monokai__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'news-add',
    components: {
        editor: __WEBPACK_IMPORTED_MODULE_3_vue2_ace___default.a
    },
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_NewsRepo__["a" /* default */](this.$auth),
            loading: false,
            news: { type: 'update', text: '' },
            content: ''
        };
    },
    created: function created() {},
    mounted: function mounted() {
        var self = this;
        this.$on('editor-update', function (val) {
            self.news.text = val;
        });
    },

    methods: {
        save: function save() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this;
                    _this.loading = true;
                    _this.repo.store(_this.news).then(function (response) {
                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/news');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "Y7Gc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v("Provider full ID (e.g. MC-L1-U1-LC1-1, T1-L1-U1-LC1)")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"provider_full_id","hasError":!_vm.vkLessonFormat(_vm.lesson.additionalInfo.provider_full_id),"rules":"required","placeholder":"Provider full id"},model:{value:(_vm.lesson.additionalInfo.provider_full_id),callback:function ($$v) {_vm.$set(_vm.lesson.additionalInfo, "provider_full_id", $$v)},expression:"lesson.additionalInfo.provider_full_id"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade-fast"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.vkLessonFormat(_vm.lesson.additionalInfo.provider_full_id)),expression:"!vkLessonFormat(lesson.additionalInfo.provider_full_id)"}],staticClass:"help is-danger"},[_vm._v("Wrong format")])]),_vm._v(" "),_c('span',[_vm._v("Example: MC-L1-U1-LC1-1, T1-L1-U1-LC1,..")])],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v("Lesson Name")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.lesson.additionalInfo.name),callback:function ($$v) {_vm.$set(_vm.lesson.additionalInfo, "name", $$v)},expression:"lesson.additionalInfo.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v("Words (Vocabulary)")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"words","rules":"required","placeholder":"Words"},model:{value:(_vm.lesson.additionalInfo.words),callback:function ($$v) {_vm.$set(_vm.lesson.additionalInfo, "words", $$v)},expression:"lesson.additionalInfo.words"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.lesson.additionalInfo),function(property,index){return (!_vm.excludeProperties.includes(index))?_c('div',{staticClass:"column is-6"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v(_vm._s(_vm.snakeToCamelCase(index)))]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.lesson.additionalInfo[index]),expression:"lesson.additionalInfo[index]"}],staticClass:"textarea",attrs:{"name":index,"rules":"","placeholder":_vm.snakeToCamelCase(index)},domProps:{"value":(_vm.lesson.additionalInfo[index])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lesson.additionalInfo, index, $event.target.value)}}})])]):_vm._e()}),0),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n            Back\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YNWR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'premade-sentences-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Text',
                key: 'text'
            }, {
                name: 'Categories',
                key: 'premade_categories.name'
            }, {
                name: 'Schools',
                key: ''
            }],
            reverse: true
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        show: function show(id) {
            this.$router.push('/dashboard/premade-sentences/' + id);
        },
        showDeleteModal: function showDeleteModal(event, id, index) {
            event.stopPropagation();
            var self = this;
            this.$swal({
                title: 'Are you sure?',
                text: "This will delete this premade sentence permanently!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3273dc',
                cancelButtonColor: '#ff3860',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    self.deletePremadeSentence(id, index);
                }
            }).catch(function (result) {});
        },
        deletePremadeSentence: function deletePremadeSentence(id, index) {
            var _this = this;

            this.premadeSentenceRepo.delete(id).then(function (response) {
                _this.items.splice(index, 1);
                _this.$swal('Deleted!', 'Premade sentence has been deleted.', 'success');
            });
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "YXYS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("fYRV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fec6f4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("5o/F");
function injectStyle (ssrContext) {
  __webpack_require__("Ue8q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fec6f4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fec6f4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YY9u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Login__ = __webpack_require__("UkDw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Register__ = __webpack_require__("IGxP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicy__ = __webpack_require__("vtOW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TermsOfUse__ = __webpack_require__("ejOc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ForgotPassword__ = __webpack_require__("X89I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PasswordReset__ = __webpack_require__("ufQ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dashboard__ = __webpack_require__("R6bT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_stats_View__ = __webpack_require__("yTXi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_news_View__ = __webpack_require__("UayT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_news_Show__ = __webpack_require__("8rVm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_news_Add__ = __webpack_require__("V0CI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_news_Edit__ = __webpack_require__("MnGM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_tickets_View__ = __webpack_require__("zMJB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_tickets_Show__ = __webpack_require__("bnQb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_users_View__ = __webpack_require__("J60W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_users_Show__ = __webpack_require__("IkSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_users_Add__ = __webpack_require__("c6Si");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_users_Edit__ = __webpack_require__("Gb8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_categories_View__ = __webpack_require__("Xsxh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_categories_Show__ = __webpack_require__("m4wb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_categories_Add__ = __webpack_require__("CjfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_categories_Edit__ = __webpack_require__("et7B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_sentences_View__ = __webpack_require__("uPQC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_sentences_Show__ = __webpack_require__("1zQf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_comments_View__ = __webpack_require__("mN3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_comments_Show__ = __webpack_require__("DHWA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_schools_View__ = __webpack_require__("DsCb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_schools_Show__ = __webpack_require__("LL00");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_schools_Add__ = __webpack_require__("C83k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_schools_Edit__ = __webpack_require__("uTud");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_lessons_View__ = __webpack_require__("i7WV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_lessons_Show__ = __webpack_require__("txU0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_lessons_Add__ = __webpack_require__("jTXb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_lessons_Edit__ = __webpack_require__("e7JC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_students_View__ = __webpack_require__("LYI0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_students_Show__ = __webpack_require__("FhEh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_students_Add__ = __webpack_require__("CZxE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_students_Edit__ = __webpack_require__("ntjD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_sb_lessons_View__ = __webpack_require__("HlxK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_sb_lessons_Show__ = __webpack_require__("qPMP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_sb_lessons_Add__ = __webpack_require__("DtX9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_sb_lessons_Edit__ = __webpack_require__("Wd1b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_sb_lesson_changes_View_vue__ = __webpack_require__("+TdP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_sb_lesson_changes_Show__ = __webpack_require__("YXYS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_user_export_View_vue__ = __webpack_require__("t06V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_premade_categories_View__ = __webpack_require__("MaRQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_premade_categories_Show__ = __webpack_require__("lf52");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_premade_categories_Add__ = __webpack_require__("HX4F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_premade_categories_Edit__ = __webpack_require__("JLaO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_premade_sentences_View__ = __webpack_require__("EsnJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_premade_sentences_Show__ = __webpack_require__("vR+Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_premade_sentences_Add__ = __webpack_require__("OvKu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_premade_sentences_Edit__ = __webpack_require__("mlaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_premade_comments_View__ = __webpack_require__("cjbQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_premade_comments_Show__ = __webpack_require__("7ZMG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_premade_comments_Add__ = __webpack_require__("RfaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_premade_comments_Edit__ = __webpack_require__("FfLQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_magic_words_View__ = __webpack_require__("HDjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_magic_words_Show__ = __webpack_require__("cjUp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_magic_words_Add__ = __webpack_require__("q91X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_magic_words_Edit__ = __webpack_require__("QaVU");





























































//Premade section




















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'login',
        component: __WEBPACK_IMPORTED_MODULE_2__Login__["a" /* default */],
        meta: { requiresGuest: true }
    }, {
        path: '/register',
        name: 'register',
        component: __WEBPACK_IMPORTED_MODULE_3__Register__["a" /* default */],
        meta: { requiresGuest: true }
    }, {
        path: '/forgot/password',
        name: 'forgot-password',
        component: __WEBPACK_IMPORTED_MODULE_6__ForgotPassword__["a" /* default */],
        meta: { requiresGuest: true }
    }, {
        path: '/privacy',
        name: 'privacy',
        component: __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicy__["a" /* default */]
    }, {
        path: '/terms',
        name: 'terms',
        component: __WEBPACK_IMPORTED_MODULE_5__TermsOfUse__["a" /* default */]
    }, {
        path: '/password/reset/:token',
        name: 'password-reset',
        component: __WEBPACK_IMPORTED_MODULE_7__PasswordReset__["a" /* default */],
        meta: { requiresGuest: true }
    }, {
        path: '/dashboard',
        component: __WEBPACK_IMPORTED_MODULE_8__Dashboard__["a" /* default */],
        meta: { requiresAuth: true },
        children: [{
            path: '',
            component: __WEBPACK_IMPORTED_MODULE_16__components_users_View__["a" /* default */]
        }, {
            path: 'stats',
            component: __WEBPACK_IMPORTED_MODULE_9__components_stats_View__["a" /* default */]
        }, {
            path: 'news',
            component: __WEBPACK_IMPORTED_MODULE_10__components_news_View__["a" /* default */]
        }, {
            path: 'news/new',
            name: 'add-news',
            component: __WEBPACK_IMPORTED_MODULE_12__components_news_Add__["a" /* default */]
        }, {
            path: 'news/:id',
            name: 'news',
            component: __WEBPACK_IMPORTED_MODULE_11__components_news_Show__["a" /* default */]
        }, {
            path: 'news/edit/:id',
            name: 'news-edit',
            component: __WEBPACK_IMPORTED_MODULE_13__components_news_Edit__["a" /* default */]
        }, {
            path: 'tickets',
            component: __WEBPACK_IMPORTED_MODULE_14__components_tickets_View__["a" /* default */]
        }, {
            path: 'tickets/:id',
            name: 'ticket',
            component: __WEBPACK_IMPORTED_MODULE_15__components_tickets_Show__["a" /* default */]
        }, {
            path: 'users-export',
            component: __WEBPACK_IMPORTED_MODULE_46__components_user_export_View_vue__["a" /* default */]
        }, {
            path: 'users',
            component: __WEBPACK_IMPORTED_MODULE_16__components_users_View__["a" /* default */]
        }, {
            path: 'users/new',
            name: 'add-user',
            component: __WEBPACK_IMPORTED_MODULE_18__components_users_Add__["a" /* default */]
        }, {
            path: 'users/:id',
            name: 'user',
            component: __WEBPACK_IMPORTED_MODULE_17__components_users_Show__["a" /* default */]
        }, {
            path: 'users/edit/:id',
            name: 'user-edit',
            component: __WEBPACK_IMPORTED_MODULE_19__components_users_Edit__["a" /* default */]
        },

        //Start of Magic words
        {
            path: 'magic-words',
            component: __WEBPACK_IMPORTED_MODULE_59__components_magic_words_View__["a" /* default */]
        }, {
            path: 'magic-words/new',
            name: 'add-magic-word',
            component: __WEBPACK_IMPORTED_MODULE_61__components_magic_words_Add__["a" /* default */]
        }, {
            path: 'magic-words/:id',
            name: 'magic-word',
            component: __WEBPACK_IMPORTED_MODULE_60__components_magic_words_Show__["a" /* default */]
        }, {
            path: 'magic-words/edit/:id',
            name: 'magic-word-edit',
            component: __WEBPACK_IMPORTED_MODULE_62__components_magic_words_Edit__["a" /* default */]
        },
        //End of Magic words

        {
            path: 'categories',
            component: __WEBPACK_IMPORTED_MODULE_20__components_categories_View__["a" /* default */]
        }, {
            path: 'categories/new',
            name: 'add-category',
            component: __WEBPACK_IMPORTED_MODULE_22__components_categories_Add__["a" /* default */]
        }, {
            path: 'categories/:id',
            name: 'category',
            component: __WEBPACK_IMPORTED_MODULE_21__components_categories_Show__["a" /* default */]
        }, {
            path: 'categories/edit/:id',
            name: 'category-edit',
            component: __WEBPACK_IMPORTED_MODULE_23__components_categories_Edit__["a" /* default */]
        }, {
            path: 'sentences',
            component: __WEBPACK_IMPORTED_MODULE_24__components_sentences_View__["a" /* default */]
        }, {
            path: 'sentences/:id',
            name: 'sentence',
            component: __WEBPACK_IMPORTED_MODULE_25__components_sentences_Show__["a" /* default */]
        }, {
            path: 'comments',
            component: __WEBPACK_IMPORTED_MODULE_26__components_comments_View__["a" /* default */]
        }, {
            path: 'comments/:id',
            name: 'comment',
            component: __WEBPACK_IMPORTED_MODULE_27__components_comments_Show__["a" /* default */]
        }, {
            path: 'schools',
            component: __WEBPACK_IMPORTED_MODULE_28__components_schools_View__["a" /* default */]
        }, {
            path: 'schools/new',
            name: 'add-school',
            component: __WEBPACK_IMPORTED_MODULE_30__components_schools_Add__["a" /* default */]
        }, {
            path: 'schools/:id',
            name: 'school',
            component: __WEBPACK_IMPORTED_MODULE_29__components_schools_Show__["a" /* default */]
        }, {
            path: 'schools/edit/:id',
            name: 'school-edit',
            component: __WEBPACK_IMPORTED_MODULE_31__components_schools_Edit__["a" /* default */]
        }, {
            path: 'lessons',
            component: __WEBPACK_IMPORTED_MODULE_32__components_lessons_View__["a" /* default */]
        }, {
            path: 'lessons/new',
            name: 'add-lesson',
            component: __WEBPACK_IMPORTED_MODULE_34__components_lessons_Add__["a" /* default */]
        }, {
            path: 'lessons/:id',
            name: 'lesson',
            component: __WEBPACK_IMPORTED_MODULE_33__components_lessons_Show__["a" /* default */]
        }, {
            path: 'lessons/edit/:id',
            name: 'lesson-edit',
            component: __WEBPACK_IMPORTED_MODULE_35__components_lessons_Edit__["a" /* default */]
        }, {
            path: 'sb-lessons',
            component: __WEBPACK_IMPORTED_MODULE_40__components_sb_lessons_View__["a" /* default */]
        }, {
            path: 'sb-lessons/new',
            name: 'sb-add-lesson',
            component: __WEBPACK_IMPORTED_MODULE_42__components_sb_lessons_Add__["a" /* default */]
        }, {
            path: 'sb-lessons/:id',
            name: 'sb-lesson',
            component: __WEBPACK_IMPORTED_MODULE_41__components_sb_lessons_Show__["a" /* default */]
        }, {
            path: 'sb-lessons/edit/:id',
            name: 'sb-lesson-edit',
            component: __WEBPACK_IMPORTED_MODULE_43__components_sb_lessons_Edit__["a" /* default */]
        }, {
            path: 'sb-lesson-changes',
            component: __WEBPACK_IMPORTED_MODULE_44__components_sb_lesson_changes_View_vue__["a" /* default */]
        }, {
            path: 'sb-lesson-changes/:lesson_id/:id',
            name: 'sb-lesson-changes-show',
            component: __WEBPACK_IMPORTED_MODULE_45__components_sb_lesson_changes_Show__["a" /* default */]
        }, {
            path: 'students',
            component: __WEBPACK_IMPORTED_MODULE_36__components_students_View__["a" /* default */]
        }, {
            path: 'students/new',
            name: 'add-student',
            component: __WEBPACK_IMPORTED_MODULE_38__components_students_Add__["a" /* default */]
        }, {
            path: 'students/:id',
            name: 'student',
            component: __WEBPACK_IMPORTED_MODULE_37__components_students_Show__["a" /* default */]
        }, {
            path: 'students/edit/:id',
            name: 'student-edit',
            component: __WEBPACK_IMPORTED_MODULE_39__components_students_Edit__["a" /* default */]
        },
        //Premade section
        {
            path: 'premade-categories',
            component: __WEBPACK_IMPORTED_MODULE_47__components_premade_categories_View__["a" /* default */]
        }, {
            path: 'premade-categories/new',
            name: 'add-premade-category',
            component: __WEBPACK_IMPORTED_MODULE_49__components_premade_categories_Add__["a" /* default */]
        }, {
            path: 'premade-categories/:id',
            name: 'premade-category',
            component: __WEBPACK_IMPORTED_MODULE_48__components_premade_categories_Show__["a" /* default */]
        }, {
            path: 'premade-categories/edit/:id',
            name: 'premade-category-edit',
            component: __WEBPACK_IMPORTED_MODULE_50__components_premade_categories_Edit__["a" /* default */]
        },
        //sentences
        {
            path: 'premade-sentences',
            component: __WEBPACK_IMPORTED_MODULE_51__components_premade_sentences_View__["a" /* default */]
        }, {
            path: 'premade-sentences/new',
            name: 'add-premade-sentence',
            component: __WEBPACK_IMPORTED_MODULE_53__components_premade_sentences_Add__["a" /* default */]
        }, {
            path: 'premade-sentences/:id',
            name: 'premade-sentence',
            component: __WEBPACK_IMPORTED_MODULE_52__components_premade_sentences_Show__["a" /* default */]
        }, {
            path: 'premade-sentences/edit/:id',
            name: 'premade-sentence-edit',
            component: __WEBPACK_IMPORTED_MODULE_54__components_premade_sentences_Edit__["a" /* default */]
        },
        //comments
        {
            path: 'premade-comments',
            component: __WEBPACK_IMPORTED_MODULE_55__components_premade_comments_View__["a" /* default */]
        }, {
            path: 'premade-comments/new',
            name: 'add-premade-comment',
            component: __WEBPACK_IMPORTED_MODULE_57__components_premade_comments_Add__["a" /* default */]
        }, {
            path: 'premade-comments/:id',
            name: 'premade-comment',
            component: __WEBPACK_IMPORTED_MODULE_56__components_premade_comments_Show__["a" /* default */]
        }, {
            path: 'premade-comments/edit/:id',
            name: 'premade-comment-edit',
            component: __WEBPACK_IMPORTED_MODULE_58__components_premade_comments_Edit__["a" /* default */]
        }, {
            path: 'privacy',
            component: __WEBPACK_IMPORTED_MODULE_4__PrivacyPolicy__["a" /* default */]
        }, {
            path: 'terms',
            component: __WEBPACK_IMPORTED_MODULE_5__TermsOfUse__["a" /* default */]
        }]
    }]
});

router.beforeEach(function (to, from, next) {
    // prevent access to login & register once signed in...
    if (to.matched.some(function (record) {
        return record.meta.requiresGuest;
    }) && window.auth.isAuthenticated()) {
        next({ path: '/dashboard' });
    }
    if (to.matched.some(function (record) {
        return record.meta.requiresAuth;
    })) {
        // routes with meta.requiresAuth attr require user to be authorized
        // if not, redirect to /auth/signin...
        if (!window.auth.isAuthenticated()) {
            next({
                path: '/',
                query: { redirect: to.fullPath }
            });
        }
    }
    next(); // make sure to always call next()!
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yanf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"box notification is-primary"},[_c('div',{staticClass:"heading"},[_vm._v("Current balance")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("$"+_vm._s(_vm.stats.current))])])]),_vm._v(" "),_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"box notification is-info"},[_c('div',{staticClass:"heading"},[_vm._v("Referred users")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.stats.referrals))])])]),_vm._v(" "),_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"box notification is-danger"},[_c('div',{staticClass:"heading"},[_vm._v("Total earned")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("$"+_vm._s(_vm.stats.earned))])])])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('affiliates-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.affiliates,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-credit-card-alt"}),_vm._v(" Stats")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z/x1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_CategoryRepo__ = __webpack_require__("94/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'categories-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false },
        pivot: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Name',
                key: 'name'
            }],
            reverse: true,
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_CategoryRepo__["a" /* default */](this.$auth)
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        show: function show(id) {
            this.$router.push('/dashboard/categories/' + id);
        },
        showDeleteModal: function showDeleteModal(event, id, index) {
            event.stopPropagation();
            var self = this;
            this.$swal({
                title: 'Are you sure?',
                text: "This will delete this category permanently!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3273dc',
                cancelButtonColor: '#ff3860',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    self.deleteCategory(id, index);
                }
            }).catch(function (result) {});
        },
        deleteCategory: function deleteCategory(id, index) {
            var _this = this;

            this.repo.delete(id).then(function (response) {
                _this.items.splice(index, 1);
                _this.$swal('Deleted!', 'Category has been deleted.', 'success');
            });
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "Z6AU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+" \n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.pivot)?_c('th',[_vm._v("Color")]):_vm._e(),_vm._v(" "),(_vm.pivot)?_c('th',[_vm._v("Text color")]):_vm._e(),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{on:{"click":function($event){_vm.show(item.id)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),(_vm.pivot && item.pivot && item.pivot.color)?_c('td',[_c('div',{staticClass:"color-box",style:({'backgroundColor': item.pivot.color})})]):_vm._e(),_vm._v(" "),(_vm.pivot && item.pivot && item.pivot.text_color)?_c('td',[_c('div',{staticClass:"color-box",style:({'backgroundColor': item.pivot.text_color})})]):_vm._e(),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'category', params: { id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])]),_vm._v(" "),_c('router-link',{staticClass:"button is-warning tooltip",attrs:{"to":{ name: 'category-edit', params: { id: item.id }},"data-tooltip":"Edit"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-edit"})])]),_vm._v(" "),_c('button',{staticClass:"button is-danger tooltip",attrs:{"data-tooltip":"Delete"},on:{"click":function($event){_vm.showDeleteModal($event, item.id, index)}}},[_vm._m(1,true)])],1):_vm._e()])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z8QD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BasicInput__ = __webpack_require__("f8TI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SingleInput__ = __webpack_require__("RKk3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WrapperInput__ = __webpack_require__("J8FP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flatpickr__ = __webpack_require__("GxBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flatpickr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_flatpickr__);

//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__BasicInput__["a" /* default */]],

  props: {
    alignment: String,
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  components: {
    SingleInput: __WEBPACK_IMPORTED_MODULE_2__SingleInput__["a" /* default */],
    WrapperInput: __WEBPACK_IMPORTED_MODULE_3__WrapperInput__["a" /* default */]
  },

  data: function data() {
    return {
      datepicker: null,
      selectedDates: null
    };
  },
  mounted: function mounted() {
    if (!this.datepicker) {
      this.config.onValueUpdate = this.dateUpdated;
      this.datepicker = new __WEBPACK_IMPORTED_MODULE_4_flatpickr___default.a(this.$el, this.config);
      this.setDate(this.value);
    }
    this.$watch('config', this.redraw);
    this.$watch('value', this.setDate);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.datepicker && !this.static) {
      this.datepicker.destroy();
      this.datepicker = null;
    }
  },


  methods: {
    redraw: function redraw(newConfig) {
      this.datepicker.config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.datepicker.config, newConfig);
      this.datepicker.redraw();
      this.datepicker.jumpToDate();
    },
    setDate: function setDate(newDate, oldDate) {
      newDate && this.datepicker.setDate(newDate);
    },
    dateUpdated: function dateUpdated(selectedDates, dateStr) {
      this.date = dateStr;
    }
  },

  computed: {
    wrap: function wrap() {
      return !!this.config.wrap;
    },
    static: function _static() {
      return !!this.config.static;
    },
    name: function name() {
      return this.wrap ? 'wrapperInput' : 'singleInput';
    },

    date: {
      get: function get() {
        return this.selectedDates || this.value;
      },
      set: function set(newValue) {
        if (this.selectedDates !== newValue) {
          this.selectedDates = newValue;
          this.$emit('input', newValue);
        }
      }
    }
  }
});

/***/ }),

/***/ "Z8zg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZdgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Email:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.email))])])])]),_vm._v(" "),(_vm.item.profile)?_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Name:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.profile.name))])])])]):_vm._e(),_vm._v(" "),(_vm.item.profile && _vm.item.profile.school)?_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("School:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.profile.school.name))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Roles:")]),_vm._v(" "),_vm._l((_vm.item.roles),function(role){return _c('div',{staticClass:"control"},[_c('p',[_vm._v(_vm._s(role.name))])])})],2)]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label clickable title is-4",on:{"click":_vm.toggleSessionsTable}},[_vm._v("Sessions "),(!_vm.showSessionsTable)?_c('i',{staticClass:"fa has-text-light fa-chevron-down"}):_vm._e(),_vm._v(" "),(_vm.showSessionsTable)?_c('i',{staticClass:"fa has-text-light fa-chevron-up"}):_vm._e()]),_vm._v(" "),(_vm.sessions != null)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSessionsTable),expression:"showSessionsTable"}],staticClass:"control"},[_c('sessions-table',{attrs:{"page":_vm.sessionsPage,"total":_vm.sessionsTotal,"items":_vm.sessions,"actions":false},on:{"search":_vm.onSessionsSearch,"sort":_vm.onSessionsOrderBy,"pageChanged":_vm.onSessionsPageChanged}})],1):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSessionsTable),expression:"showSessionsTable"}],staticClass:"control"},[_c('span',[_vm._v("No sessions assigned")])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label clickable title is-4",on:{"click":_vm.toggleCatTable}},[_vm._v("Categories "),(!_vm.showCatTable)?_c('i',{staticClass:"fa has-text-light fa-chevron-down"}):_vm._e(),_vm._v(" "),(_vm.showCatTable)?_c('i',{staticClass:"fa has-text-light fa-chevron-up"}):_vm._e()]),_vm._v(" "),(_vm.categories != null)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCatTable),expression:"showCatTable"}],staticClass:"control"},[_c('categories-table',{attrs:{"pivot":true,"page":_vm.catPage,"total":_vm.catTotal,"items":_vm.categories,"actions":false},on:{"search":_vm.onCatSearch,"sort":_vm.onCatOrderBy,"pageChanged":_vm.onCatPageChanged}})],1):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCatTable),expression:"showCatTable"}],staticClass:"control"},[_c('span',[_vm._v("No categories assigned")])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label clickable title is-4",on:{"click":_vm.toggleSentencesTable}},[_vm._v("Sentences "),(!_vm.showSentencesTable)?_c('i',{staticClass:"fa has-text-light fa-chevron-down"}):_vm._e(),_vm._v(" "),(_vm.showSentencesTable)?_c('i',{staticClass:"fa has-text-light fa-chevron-up"}):_vm._e()]),_vm._v(" "),(_vm.sentences != null)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSentencesTable),expression:"showSentencesTable"}],staticClass:"control"},[_c('sentences-table',{attrs:{"page":_vm.sentencesPage,"total":_vm.sentencesTotal,"items":_vm.sentences,"actions":false},on:{"search":_vm.onSentencesSearch,"sort":_vm.onSentencesOrderBy,"pageChanged":_vm.onSentencesPageChanged}})],1):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSentencesTable),expression:"showSentencesTable"}],staticClass:"control"},[_c('span',[_vm._v("No sentences assigned")])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label clickable title is-4",on:{"click":_vm.toggleCommTable}},[_vm._v("Comments "),(!_vm.showCommTable)?_c('i',{staticClass:"fa has-text-light fa-chevron-down"}):_vm._e(),_vm._v(" "),(_vm.showCommTable)?_c('i',{staticClass:"fa has-text-light fa-chevron-up"}):_vm._e()]),_vm._v(" "),(_vm.comments != null)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCommTable),expression:"showCommTable"}],staticClass:"control"},[_c('comments-table',{attrs:{"page":_vm.commentsPage,"total":_vm.commentsTotal,"items":_vm.comments,"actions":false},on:{"search":_vm.onCommSearch,"sort":_vm.onCommOrderBy,"pageChanged":_vm.onCommPageChanged}})],1):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCommTable),expression:"showCommTable"}],staticClass:"control"},[_c('span',[_vm._v("No comments assigned")])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label clickable title is-4",on:{"click":_vm.toggleNewsTable}},[_vm._v("News "),(!_vm.showNewsTable)?_c('i',{staticClass:"fa has-text-light fa-chevron-down"}):_vm._e(),_vm._v(" "),(_vm.showNewsTable)?_c('i',{staticClass:"fa has-text-light fa-chevron-up"}):_vm._e()]),_vm._v(" "),(_vm.news != null)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNewsTable),expression:"showNewsTable"}],staticClass:"control"},[_c('news-table',{attrs:{"page":_vm.newsPage,"pivot":true,"total":_vm.newsTotal,"items":_vm.news,"actions":false},on:{"search":_vm.onNewsSearch,"sort":_vm.onNewsOrderBy,"pageChanged":_vm.onNewsPageChanged}})],1):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNewsTable),expression:"showNewsTable"}],staticClass:"control"},[_c('span',[_vm._v("No news assigned")])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label clickable title is-4",on:{"click":_vm.toggleAffiliatesTable}},[_vm._v("Affiliate "),(!_vm.showAffiliatesTable)?_c('i',{staticClass:"fa has-text-light fa-chevron-down"}):_vm._e(),_vm._v(" "),(_vm.showAffiliatesTable)?_c('i',{staticClass:"fa has-text-light fa-chevron-up"}):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAffiliatesTable),expression:"showAffiliatesTable"}],staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"box notification is-primary"},[_c('div',{staticClass:"heading"},[_vm._v("Current balance")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("$"+_vm._s(_vm.affiliateStats.current))])])]),_vm._v(" "),_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"box notification is-info"},[_c('div',{staticClass:"heading"},[_vm._v("Referred users")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.affiliateStats.referrals))])])]),_vm._v(" "),_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"box notification is-danger"},[_c('div',{staticClass:"heading"},[_vm._v("Total earned")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("$"+_vm._s(_vm.affiliateStats.earned))])])])]),_vm._v(" "),(_vm.affiliates != null)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAffiliatesTable),expression:"showAffiliatesTable"}],staticClass:"control"},[_c('affiliate-table',{attrs:{"page":_vm.affiliatesPage,"pivot":true,"total":_vm.affiliatesTotal,"items":_vm.affiliates,"actions":false},on:{"search":_vm.onAffiliatesSearch,"sort":_vm.onAffiliatesOrderBy,"pageChanged":_vm.onAffiliatesPageChanged}})],1):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAffiliatesTable),expression:"showAffiliatesTable"}],staticClass:"control"},[_c('span',[_vm._v("Nothing to show")])])])]),_vm._v(" "),_c('div',{staticClass:"column is-3"},[_c('a',{staticClass:"button is-info is-block",attrs:{"href":"javascript:{}"},on:{"click":_vm.resetAffiliateBalance}},[_vm._v("\n            Set balance to paid\n          ")])]),_vm._v(" "),_c('div',{staticClass:"column is-2 is-offset-5 is-pulled-right"},[_c('router-link',{staticClass:"button is-block is-warning",attrs:{"to":{ name: 'user-edit', params: { id: _vm.item.id }}}},[_vm._v("\n                Edit\n            ")])],1),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" Users")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                Back\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZuYL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_swatches__ = __webpack_require__("gQ/s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_swatches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_swatches__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'premade-categories-edit',
    components: { Swatches: __WEBPACK_IMPORTED_MODULE_2_vue_swatches___default.a },
    props: {},
    data: function data() {
        return {
            loading: false,
            schools: [],
            premadeCategory: { schools: [], color: '#3D4351', text_color: '#00d1b2' }
        };
    },
    created: function created() {
        this.loadSchools();
    },

    methods: {
        getPremadeCategory: function getPremadeCategory(id) {
            var _this = this;

            this.premadeCategoryRepo.get(id).then(function (response) {
                _this.premadeCategory = response.data.data;
                _this.color = _this.premadeCategory.color;
                _this.text_color = _this.premadeCategory.text_color;
            });
        },
        loadSchools: function loadSchools() {
            var _this2 = this;

            this.loading = true;
            this.schoolRepo.all().then(function (response) {
                _this2.schools = response.data.data;
                _this2.loading = false;
                _this2.getPremadeCategory(_this2.$route.params.id);
            }).catch(function (response) {
                _this2.loading = false;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        },
        save: function save() {
            var _this3 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this3;
                    _this3.loading = true;

                    _this3.premadeCategoryRepo.update(_this3.premadeCategory.id, _this3.premadeCategory).then(function (response) {

                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/premade-categories');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "a/qe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_NewsRepo__ = __webpack_require__("O7DD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'news-show',
    components: {},
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_NewsRepo__["a" /* default */](this.$auth),
            item: {}
        };
    },
    created: function created() {
        this.getNews(this.$route.params.id);
    },

    methods: {
        getNews: function getNews(id) {
            var _this = this;

            this.repo.show(id).then(function (response) {
                _this.item = response.data.data;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "a/qn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BulmaInput_vue__ = __webpack_require__("l/c7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fbf10f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BulmaInput_vue__ = __webpack_require__("GnK6");
function injectStyle (ssrContext) {
  __webpack_require__("20uu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fbf10f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BulmaInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fbf10f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BulmaInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a6xk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__("yEsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__repos_Repo__ = __webpack_require__("7vHs");






/**
 * Created by ndzak on 4/23/2016.
 */



var CategoryRepo = function (_Repo) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CategoryRepo, _Repo);

    function CategoryRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CategoryRepo);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CategoryRepo.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CategoryRepo)).call(this, $auth, 'premade-categories'));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CategoryRepo, [{
        key: 'all',
        value: function all(q) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(CategoryRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CategoryRepo.prototype), 'all', this).call(this, q, "");
        }
    }, {
        key: 'store',
        value: function store(data) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(CategoryRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CategoryRepo.prototype), 'store', this).call(this, data, "");
        }
    }, {
        key: 'update',
        value: function update(id, data) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(CategoryRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CategoryRepo.prototype), 'update', this).call(this, id, data, "");
        }
    }, {
        key: 'get',
        value: function get(id) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(CategoryRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CategoryRepo.prototype), 'get', this).call(this, id, "");
        }
    }]);

    return CategoryRepo;
}(__WEBPACK_IMPORTED_MODULE_6__repos_Repo__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CategoryRepo);

/***/ }),

/***/ "akR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'premade-categories-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false },
        pivot: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Name',
                key: 'name'
            }, {
                name: 'Color',
                key: 'color'
            }, {
                name: 'Text Color',
                key: 'text_color'
            }, {
                name: 'Order',
                key: 'order'
            }, {
                name: 'Schools',
                key: 'universal'
            }],
            reverse: true
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        show: function show(id) {
            this.$router.push('/dashboard/premade-categories/' + id);
        },
        showDeleteModal: function showDeleteModal(event, id, index) {
            event.stopPropagation();
            var self = this;
            this.$swal({
                title: 'Are you sure?',
                text: "This will delete this premade category permanently!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3273dc',
                cancelButtonColor: '#ff3860',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    self.deletePremadeCategory(id, index);
                }
            }).catch(function (result) {});
        },
        deletePremadeCategory: function deletePremadeCategory(id, index) {
            var _this = this;

            this.premadeCategoryRepo.delete(id).then(function (response) {
                _this.items.splice(index, 1);
                _this.$swal('Deleted!', 'Premade category has been deleted.', 'success');
            });
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "an4X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.stbyInfo),function(property,index){return (!_vm.excludeProperties.includes(index))?_c('div',{staticClass:"column is-6"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v(_vm._s(_vm.snakeToCamelCase(index)))]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-in',{staticClass:"textarea",attrs:{"name":index,"rules":"","placeholder":_vm.snakeToCamelCase(index)},model:{value:(_vm.stbyInfo[index]),callback:function ($$v) {_vm.$set(_vm.stbyInfo, index, $$v)},expression:"stbyInfo[index]"}})],1)]):_vm._e()}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bG5l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bLHn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PremadeComment_vue__ = __webpack_require__("mRqq");
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'premade-sentences-add',
    components: { PremadeComment: __WEBPACK_IMPORTED_MODULE_1__components_PremadeComment_vue__["a" /* default */] },
    data: function data() {
        return {
            premadeComment: { premadeSentences: [], schools: [{ id: 3, name: 'VIPKID' }], text: '', html: '', caption: '', favorite: 1, score: 0 }
        };
    },
    created: function created() {},

    methods: {},
    watch: {}

});

/***/ }),

/***/ "bh4z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bhRq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Name:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.name))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Color:")]),_vm._v(" "),_c('div',{staticClass:"control has-text-centered",staticStyle:{"border":"1px solid black"},style:({'backgroundColor': _vm.item.color})},[_c('span',[_vm._v(_vm._s(_vm.item.color))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Text Color:")]),_vm._v(" "),_c('div',{staticClass:"control has-text-centered",staticStyle:{"border":"1px solid black"},style:({'backgroundColor': _vm.item.text_color})},[_c('span',[_vm._v(_vm._s(_vm.item.text_color))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Order:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.order))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Schools:")]),_vm._v(" "),(!_vm.item.schools)?_c('div',{staticClass:"control"},[_vm._v("All schools")]):_vm._l((_vm.item.schools),function(school){return _c('div',{staticClass:"control"},[_c('p',[_vm._v(_vm._s(school.name))])])})],2)]),_vm._v(" "),_c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('router-link',{staticClass:"button is-block is-warning",attrs:{"to":{ name: 'premade-category-edit', params: { id: _vm.item.id }}}},[_vm._v("\n                Edit\n            ")])],1),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v(" Categories")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                Back\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bnQb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("+f4n");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46f63b76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("E0hG");
function injectStyle (ssrContext) {
  __webpack_require__("bh4z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46f63b76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46f63b76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bxnX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+" \n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{on:{"click":function($event){_vm.show(item.id)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.url))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.logo))]),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'school', params: { id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])]),_vm._v(" "),_c('router-link',{staticClass:"button is-warning tooltip",attrs:{"to":{ name: 'school-edit', params: { id: item.id }},"data-tooltip":"Edit"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-edit"})])]),_vm._v(" "),_c('button',{staticClass:"button is-danger tooltip",attrs:{"data-tooltip":"Delete"},on:{"click":function($event){_vm.showDeleteModal($event, item.id, index)}}},[_vm._m(1,true)])],1):_vm._e()])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bxs/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c/5L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_SchoolRepo__ = __webpack_require__("gh8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'schools-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Name',
                key: 'name'
            }, {
                name: 'Url',
                key: 'url'
            }, {
                name: 'Logo',
                key: 'logo'
            }],
            reverse: true,
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_SchoolRepo__["a" /* default */](this.$auth)
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        show: function show(id) {
            this.$router.push('/dashboard/schools/' + id);
        },
        showDeleteModal: function showDeleteModal(event, id, index) {
            event.stopPropagation();
            var self = this;
            this.$swal({
                title: 'Are you sure?',
                text: "This will delete this school permanently!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3273dc',
                cancelButtonColor: '#ff3860',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    self.deleteSchool(id, index);
                }
            }).catch(function (result) {});
        },
        deleteSchool: function deleteSchool(id, index) {
            var _this = this;

            this.repo.delete(id).then(function (response) {
                _this.items.splice(index, 1);
                _this.$swal('Deleted!', 'School has been deleted.', 'success');
            });
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "c2cV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.magicWord.name),callback:function ($$v) {_vm.$set(_vm.magicWord, "name", $$v)},expression:"magicWord.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"title","rules":"required","placeholder":"Title"},model:{value:(_vm.magicWord.title),callback:function ($$v) {_vm.$set(_vm.magicWord, "title", $$v)},expression:"magicWord.title"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"placeholder","rules":"required","placeholder":"Placeholder"},model:{value:(_vm.magicWord.placeholder),callback:function ($$v) {_vm.$set(_vm.magicWord, "placeholder", $$v)},expression:"magicWord.placeholder"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"description","rules":"required","placeholder":"Description"},model:{value:(_vm.magicWord.description),callback:function ($$v) {_vm.$set(_vm.magicWord, "description", $$v)},expression:"magicWord.description"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"field"},[_c('multiselect',{attrs:{"label":"name","name":"schools","track-by":"name","options":_vm.schools,"multiple":true,"placeholder":"Choose schools"},model:{value:(_vm.magicWord.schools),callback:function ($$v) {_vm.$set(_vm.magicWord, "schools", $$v)},expression:"magicWord.schools"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"field"},[_c('multiselect',{attrs:{"name":"types","options":['input', 'textarea'],"multiple":false,"placeholder":"Field type"},model:{value:(_vm.magicWord.type),callback:function ($$v) {_vm.$set(_vm.magicWord, "type", $$v)},expression:"magicWord.type"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v("Magic Words")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                        Back\n                    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c6Si":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("V9jG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f1014e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("Xy3J");
function injectStyle (ssrContext) {
  __webpack_require__("yWbn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f1014e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f1014e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c9Cq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('multiselect',{attrs:{"disabled":_vm.disableSchool,"label":"name","name":"schools","track-by":"id","options":_vm.schools,"placeholder":"Choose school"},model:{value:(_vm.school),callback:function ($$v) {_vm.school=$$v},expression:"school"}})],1)])]),_vm._v(" "),(_vm.school.name === _vm.MAGIC_EARS.name)?_c('div',[_c('m-e-lesson',{attrs:{"lessonForUpdate":_vm.lesson,"update":_vm.update,"loading":_vm.loading},on:{"save":_vm.save}})],1):(_vm.school.name === _vm.VIPKID.name)?_c('div',[_c('v-k-lesson',{attrs:{"lessonForUpdate":_vm.lesson,"update":_vm.update,"loading":_vm.loading},on:{"save":_vm.save}})],1):_c('div',[_c('rest-lesson',{attrs:{"lessonForUpdate":_vm.lesson,"update":_vm.update,"loading":_vm.loading},on:{"save":_vm.save}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" StandBy Lessons")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cMDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',[_c('div',{staticClass:"columns box is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Title"},model:{value:(_vm.news.title),callback:function ($$v) {_vm.$set(_vm.news, "title", $$v)},expression:"news.title"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.news.type),expression:"news.type"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.news, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"update"}},[_vm._v("update")]),_vm._v(" "),_c('option',{attrs:{"value":"coupon"}},[_vm._v("coupon")]),_vm._v(" "),_c('option',{attrs:{"value":"subscription"}},[_vm._v("subscription")]),_vm._v(" "),_c('option',{attrs:{"value":"alert"}},[_vm._v("alert")])])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.news.description),expression:"news.description"}],staticClass:"textarea",attrs:{"name":"description","rules":"","placeholder":"Description"},domProps:{"value":(_vm.news.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.news, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('editor',{attrs:{"content":_vm.content,"lang":'html',"height":'500px',"theme":'monokai',"sync":true}})],1)])]),_vm._v(" "),_c('div',{staticClass:"columns box is-multiline"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.news.text)}})])]),_vm._v(" "),_c('div',{staticClass:"columns box is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" News")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ceAG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cjUp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("CXuH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeff3f26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("oCoU");
function injectStyle (ssrContext) {
  __webpack_require__("Kqpv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eeff3f26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeff3f26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cjbQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("AfLX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da397e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("8lGO");
function injectStyle (ssrContext) {
  __webpack_require__("/UuR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6da397e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da397e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cpHN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cw8l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('multiselect',{attrs:{"label":"name","name":"schools","track-by":"id","options":_vm.schools,"placeholder":"Choose school"},model:{value:(_vm.school),callback:function ($$v) {_vm.school=$$v},expression:"school"}})],1)])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+"\n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.provider_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.words))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.school.name))]),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'sb-lesson', params: { id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])]),_vm._v(" "),_c('router-link',{staticClass:"button is-warning tooltip",attrs:{"to":{ name: 'sb-lesson-edit', params: { id: item.id }},"data-tooltip":"Edit"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-edit"})])]),_vm._v(" "),_c('button',{staticClass:"button is-danger tooltip",attrs:{"data-tooltip":"Delete"},on:{"click":function($event){_vm.showDeleteModal($event, item.id, index)}}},[_vm._m(1,true)])],1):_vm._e()])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cwHv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d4a3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MELesson_vue__ = __webpack_require__("33Ry");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27b95b23_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MELesson_vue__ = __webpack_require__("/lxc");
function injectStyle (ssrContext) {
  __webpack_require__("A64A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27b95b23"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MELesson_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27b95b23_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MELesson_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dPEa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dZ1S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Name:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.name))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Url:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.url))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Logo:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.logo))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('router-link',{staticClass:"button is-block is-warning",attrs:{"to":{ name: 'school-edit', params: { id: _vm.item.id }}}},[_vm._v("\n                Edit\n            ")])],1),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-graduation-cap"}),_vm._v(" Schools")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                Back\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "daTW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repos_UserRepo__ = __webpack_require__("lyrB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repos_RoleRepo__ = __webpack_require__("nzVJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'users-edit',
    components: {},
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_2__repos_UserRepo__["a" /* default */](this.$auth),
            roleRepo: new __WEBPACK_IMPORTED_MODULE_3__repos_RoleRepo__["a" /* default */](this.$auth),
            loading: false,
            oldRoles: null,
            roles: [],
            user: { role: '2' }
        };
    },
    created: function created() {
        this.getRoles();
        this.getUser(this.$route.params.id);
    },

    methods: {
        getUser: function getUser(id) {
            var _this = this;

            this.repo.show(id).then(function (response) {
                var user = response.data.data;
                _this.oldRoles = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(user.roles));
                _this.user = _this.prepareUser(user);
            });
        },
        getRoles: function getRoles() {
            var _this2 = this;

            this.roleRepo.all().then(function (response) {
                _this2.roles = response.data.data;
            });
        },
        prepareUser: function prepareUser(user) {
            //user.projects = user.projects ? user.projects : [];
            var projects = [];
            var roles = [];

            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(user.roles, function (value) {
                roles.push(value.id);
            });

            user.role = roles[0];

            user.name = user.profile.name;

            user.nick = user.profile.nick;

            return user;
        },
        save: function save() {
            var _this3 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this3;
                    _this3.loading = true;

                    _this3.repo.update(_this3.user.id, _this3.user).then(function (response) {

                        if (self.oldRoles && self.oldRoles.length > 0) {
                            if (self.user.role != self.oldRoles[0].id) {
                                self.saveRole(self.user.id, self.oldRoles[0].id, self.user.role);
                            }
                        } else {
                            self.attachRole(self.user.id, self.user.role);
                        }

                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        },
        saveRole: function saveRole(id, old_role_id, new_role_id) {
            var _this4 = this;

            this.repo.attachRole(id, new_role_id).then(function (response) {
                _this4.repo.detachRole(id, old_role_id);
            });
        },
        attachRole: function attachRole(id, role_id) {
            this.repo.attachRole(id, role_id).then(function (response) {});
        }
    },
    watch: {}

});

/***/ }),

/***/ "djyL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.school.name),callback:function ($$v) {_vm.$set(_vm.school, "name", $$v)},expression:"school.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"url","rules":"","placeholder":"Url"},model:{value:(_vm.school.url),callback:function ($$v) {_vm.$set(_vm.school, "url", $$v)},expression:"school.url"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"logo","rules":"","placeholder":"Logo"},model:{value:(_vm.school.logo),callback:function ($$v) {_vm.$set(_vm.school, "logo", $$v)},expression:"school.logo"}})],1)]),_vm._v(" "),(_vm.schools && _vm.schools.length > 0)?_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.school.school_id),expression:"school.school_id"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.school, "school_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.schools),function(school){return _c('option',{domProps:{"value":school.id}},[_vm._v(_vm._s(school.name))])}),0)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-graduation-cap"}),_vm._v(" Schools")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e3uZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e7JC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("iYFX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d501322c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("zOf3");
function injectStyle (ssrContext) {
  __webpack_require__("JE3q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d501322c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d501322c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eGWK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_UserRepo__ = __webpack_require__("lyrB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table__ = __webpack_require__("euje");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'users-view',
    components: { UsersTable: __WEBPACK_IMPORTED_MODULE_2__Table__["a" /* default */] },
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_UserRepo__["a" /* default */](this.$auth),
            users: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1
        };
    },
    created: function created() {
        this.getUsers();
    },

    methods: {
        onSearch: function onSearch(q) {
            this.page = 1;
            this.q = q;
            this.getUsers();
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getUsers();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getUsers();
        },
        getUsers: function getUsers() {
            var _this = this;

            this.repo.paginate(this.page, this.q, this.orderBy).then(function (response) {
                _this.users = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "eJRy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Text:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.text))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Schools:")]),_vm._v(" "),(!_vm.item.schools)?_c('div',{staticClass:"control"},[_vm._v("All schools")]):_vm._l((_vm.item.schools),function(school){return _c('div',{staticClass:"control"},[_c('p',[_vm._v(_vm._s(school.name))])])})],2)]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Sentences")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                Back\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eU9U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_UserRepo__ = __webpack_require__("lyrB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dashboard',
    components: {},
    data: function data() {
        return {
            me: {
                profile: {}
            },
            isAffiliate: false,
            routes: [],
            adminRoutes: [{
                heading: 'News',
                icon: 'fa-bullhorn',
                to: '/dashboard/news'
            }, {
                heading: 'Tickets',
                icon: 'fa-envelope',
                to: '/dashboard/tickets'
            }, {
                heading: 'Users',
                icon: 'fa-users',
                to: '/dashboard/users'
            }, {
                heading: 'Users Export',
                icon: 'fa-file-excel-o',
                to: '/dashboard/users-export'
            },
            // {
            //     heading: 'Magic Words',
            //     icon: 'fa-magic',
            //     to: '/dashboard/magic-words'
            // },
            {
                heading: 'Categories',
                icon: 'fa-th-list',
                to: '/dashboard/categories'
            }, {
                heading: 'Premade Categories',
                icon: 'fa-list-alt',
                to: '/dashboard/premade-categories'
            }, {
                heading: 'Sentences',
                icon: 'fa-pencil',
                to: '/dashboard/sentences'
            }, {
                heading: 'Premade Sentences',
                icon: 'fa-pencil-square',
                to: '/dashboard/premade-sentences'
            }, {
                heading: 'Comments',
                icon: 'fa-coffee',
                to: '/dashboard/comments'
            }, {
                heading: 'Premade Comments',
                icon: 'fa-inbox',
                to: '/dashboard/premade-comments'
            }, {
                heading: 'Schools',
                icon: 'fa-graduation-cap',
                to: '/dashboard/schools'
            }, {
                heading: 'Students',
                icon: 'fa-user-circle',
                to: '/dashboard/students'
            }, {
                heading: 'Lessons',
                icon: 'fa-book',
                to: '/dashboard/lessons'
            }, {
                heading: 'StandBy Lessons',
                icon: 'fa-book',
                to: '/dashboard/sb-lessons'
            }, {
                heading: 'StandBy Lesson Changes',
                icon: 'fa-sticky-note-o',
                to: '/dashboard/sb-lesson-changes'
            }],
            affiliateRoutes: [{
                heading: 'Stats',
                icon: 'fa-credit-card-alt',
                to: '/dashboard/stats'
            }],
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_UserRepo__["a" /* default */](this.$auth)
        };
    },
    created: function created() {
        var _this = this;

        var md = new MobileDetect(window.navigator.userAgent);
        if (md.mobile()) {
            this.$swal({
                type: 'error',
                confirmButtonText: 'I understand <i class="fa fa-thumbs-up"></i>',
                focusConfirm: false,
                confirmButtonColor: '#f27474',
                text: 'This application is not intended for use on mobile phones!'
            });
        }

        if (this.$me.id != -1) {
            this.me = this.$me;
            this.checkAffiliate();
        } else {
            this.repo.me().then(function (response) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$me = response.data.data;
                _this.me = _this.$me;
                _this.checkAffiliate();
            });
        }
        /*      if(this.schools.length == 0){
                this.loadSchools();
                console.log('call');
              }*/
    },

    methods: {
        logout: function logout() {
            var component = this;
            this.$auth.logout().then(function () {
                component.$router.push('/');
            }).catch(function () {
                component.$router.push('/');
            }).finally(function () {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$me = {
                    price: 0,
                    user: {
                        profile: {
                            name: ''
                        },
                        news: [],
                        unseenNews: []
                    },
                    id: -1
                };
            });
        },
        routeMatch: function routeMatch(path) {
            return this.$route.path == path;
        },
        checkAffiliate: function checkAffiliate() {
            if (this.me.id && this.me.id != -1 && this.me.roles && this.me.roles.length > 0) {
                for (var i = 0; i < this.me.roles.length; i++) {
                    if (this.me.roles[i].name == 'affiliate') {
                        this.isAffiliate = true;
                        this.routes = this.affiliateRoutes;
                        this.$router.push('/dashboard/stats');
                        return;
                    }
                }
                //this.routes = this.affiliateRoutes;
                this.routes = this.adminRoutes;
            }
        }
    }
});

/***/ }),

/***/ "eiW3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VKLesson_vue__ = __webpack_require__("K3L8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf8d643_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VKLesson_vue__ = __webpack_require__("Y7Gc");
function injectStyle (ssrContext) {
  __webpack_require__("Wzr8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bf8d643"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VKLesson_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf8d643_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VKLesson_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ejOc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfUse_vue__ = __webpack_require__("VxLz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19b30749_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfUse_vue__ = __webpack_require__("QH1o");
function injectStyle (ssrContext) {
  __webpack_require__("Pz2p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19b30749"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfUse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19b30749_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfUse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ep0L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_SentenceRepo__ = __webpack_require__("5sB1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table__ = __webpack_require__("66zg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sentences-view',
    components: { SentencesTable: __WEBPACK_IMPORTED_MODULE_2__Table__["a" /* default */] },
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_SentenceRepo__["a" /* default */](this.$auth),
            sentences: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1
        };
    },
    created: function created() {
        this.getUsers();
    },

    methods: {
        onSearch: function onSearch(q) {
            this.page = 1;
            this.q = q;
            this.getUsers();
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getUsers();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getUsers();
        },
        getUsers: function getUsers() {
            var _this = this;

            this.repo.paginate(this.page, this.q, this.orderBy).then(function (response) {
                _this.sentences = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "et7B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("Q3Fm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9de40198_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("mQcb");
function injectStyle (ssrContext) {
  __webpack_require__("vUy5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9de40198"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9de40198_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "euje":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("NSY/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd93b9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("0WZG");
function injectStyle (ssrContext) {
  __webpack_require__("cwHv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fd93b9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd93b9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f4zy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Item_vue__ = __webpack_require__("pWcQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60598ef6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Item_vue__ = __webpack_require__("OO5v");
function injectStyle (ssrContext) {
  __webpack_require__("u1S3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60598ef6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fOXH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Provider Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.provider_id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Name:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.name))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Words:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.words))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("School:")]),_vm._v(" "),_c('div',{staticClass:"control"},[(_vm.item.school)?_c('span',[_vm._v(_vm._s(_vm.item.school.name))]):_vm._e()])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._l((_vm.item.additionalInfo),function(property,index){return _c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.snakeToCamelCase(index))+":")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.makeLink(property))}})])])])}),_vm._v(" "),_c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('router-link',{staticClass:"button is-block is-warning",attrs:{"to":{ name: 'sb-lesson-edit', params: { id: _vm.item.id }}}},[_vm._v("\n                Edit\n            ")])],1),_vm._v(" "),_vm._m(2)],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" StandBy Lessons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('h2',{staticClass:"title is-3"},[_vm._v("Additional info")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                Back\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fYRV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sb-lessons-show',
    components: {},
    data: function data() {
        return {
            item: { original: {} }
        };
    },
    created: function created() {
        this.getLesson(this.$route.params.lesson_id, this.$route.params.id);
    },

    methods: {
        getLesson: function getLesson(lesson_id, id) {
            var _this = this;

            this.stbyLessonRepo.showChanges(lesson_id, id).then(function (response) {
                _this.item = response.data.data;
            });
        },
        approve: function approve(item) {
            var _this2 = this;

            this.stbyLessonRepo.approveChanges(item).then(function (response) {
                _this2.$router.push('/dashboard/sb-lesson-changes');
            });
        },
        decline: function decline(item) {
            var _this3 = this;

            this.stbyLessonRepo.declineChanges(item).then(function (response) {
                _this3.$router.push('/dashboard/sb-lesson-changes');
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "fcWh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"forgot-password"}},[_c('section',{staticClass:"hero is-success is-fullheight"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('div',{staticClass:"column is-4 is-offset-4"},[_c('h3',{staticClass:"title has-text-grey"},[_vm._v("Forgot password?")]),_vm._v(" "),_c('p',{staticClass:"subtitle has-text-grey"},[_vm._v("We can help you with that...")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('figure',{staticClass:"avatar"},[_c('img',{attrs:{"src":'/static/img/logo.png'}})]),_vm._v(" "),_c('form',[_c('div',{staticClass:"title is-5 has-text-left has-text-grey-dark"},[_vm._v(" Enter your details below ")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"email","rules":"required|email","placeholder":"Your email"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-danger"},on:{"click":function($event){_vm.forgotPassword()}}},[_vm._v("Send reset link")])],1)]),_vm._v(" "),_c('p',{staticClass:"has-text-grey"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("\n                  Login\n              ")]),_vm._v("  · \n              "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("\n                  Sign up\n              ")])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fiLV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gCSv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Collapse_vue__ = __webpack_require__("IZbS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fd24bac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Collapse_vue__ = __webpack_require__("shy6");
function injectStyle (ssrContext) {
  __webpack_require__("7YfP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Collapse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fd24bac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Collapse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gSOa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'loading-button',
   props: {
      loading: { required: true },
      color: { required: false, default: 'is-info' },
      icon: { required: false, default: '' }
   },
   data: function data() {
      return {};
   },

   methods: {
      click: function click($event) {
         this.$emit('click', $event);
      }
   },
   mounted: function mounted() {},
   destroyed: function destroyed() {}
});

/***/ }),

/***/ "gcbH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gh8u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Http__ = __webpack_require__("OK7G");




/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES


// private sector
var $http = void 0;

//public sector

var SchoolRepo = function () {
    function SchoolRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SchoolRepo);

        $http = new __WEBPACK_IMPORTED_MODULE_3__services_Http__["a" /* default */]($auth);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SchoolRepo, [{
        key: 'show',
        value: function show(id) {
            return $http.get(SchoolRepo.$resource + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'store',
        value: function store(data) {
            return $http.post(SchoolRepo.$resource, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'all',
        value: function all() {
            return $http.get(SchoolRepo.$resource).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'paginate',
        value: function paginate(page, q, orderBy) {
            var query = "page=" + page;
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(SchoolRepo.$resource + "/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'update',
        value: function update(id, data) {
            return $http.put(SchoolRepo.$resource + "/" + id, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            return $http.delete(SchoolRepo.$resource + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }]);

    return SchoolRepo;
}();

SchoolRepo.$resource = 'schools';
/* harmony default export */ __webpack_exports__["a"] = (SchoolRepo);

/***/ }),

/***/ "gjd/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hObb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"email","rules":"required|email","placeholder":"Email"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"nick","rules":"required","placeholder":"Nick"},model:{value:(_vm.user.nick),callback:function ($$v) {_vm.$set(_vm.user, "nick", $$v)},expression:"user.nick"}})],1)]),_vm._v(" "),(_vm.roles && _vm.roles.length > 0)?_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Roles:")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.role),expression:"user.role"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.user, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.roles),function(role){return _c('option',{domProps:{"value":role.id}},[_vm._v(_vm._s(role.name))])}),0)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" Users")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hOh2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hTq+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table__ = __webpack_require__("tQig");

//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sb-lessons-view',
    components: { LessonsTable: __WEBPACK_IMPORTED_MODULE_1__Table__["a" /* default */] },
    data: function data() {
        return {
            lessons: [],
            total: 0,
            search: { 'query': '', school: {}, status: 'requested' },
            orderBy: 'id,asc',
            page: 1
        };
    },
    created: function created() {
        this.getLessons();
    },

    methods: {
        onSearch: function onSearch(search) {
            this.page = 1;
            this.search = search;
            this.getLessons();
        },
        approvedChanges: function approvedChanges(id) {
            this.lessons.forEach(function (lesson) {
                if (lesson.id == id) {
                    lesson.status = "approved";
                }
            });
        },
        declinedChanges: function declinedChanges(id) {
            this.lessons.forEach(function (lesson) {
                if (lesson.id == id) {
                    lesson.status = "declined";
                }
            });
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getLessons();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getLessons();
        },
        getLessons: function getLessons() {
            var _this = this;

            var searchData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.search, { page: this.page, orderBy: this.orderBy });

            this.stbyLessonRepo.paginateChanges(searchData).then(function (response) {
                console.log(response.data.data);
                _this.lessons = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "haNX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_SentenceRepo__ = __webpack_require__("5sB1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sentences-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Text',
                key: 'text'
            }, {
                name: 'Category',
                key: ''
            }, {
                name: 'Teacher',
                key: ''
            }],
            reverse: true,
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_SentenceRepo__["a" /* default */](this.$auth)
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        show: function show(id) {
            this.$router.push('/dashboard/sentences/' + id);
        },
        showDeleteModal: function showDeleteModal(event, id, index) {
            event.stopPropagation();
            var self = this;
            this.$swal({
                title: 'Are you sure?',
                text: "This will delete this sentence permanently!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3273dc',
                cancelButtonColor: '#ff3860',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    self.deleteSentence(id, index);
                }
            }).catch(function (result) {});
        },
        deleteSentence: function deleteSentence(id, index) {
            var _this = this;

            this.repo.delete(id).then(function (response) {
                _this.items.splice(index, 1);
                _this.$swal('Deleted!', 'Sentence has been deleted.', 'success');
            });
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "heRp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+" \n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{on:{"click":function($event){_vm.show(item.id)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.categories && item.categories.length > 0 && item.categories[0].name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.user && item.user.profile && item.user.profile.nick))]),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'sentence', params: { id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])]),_vm._v(" "),_c('button',{staticClass:"button is-danger tooltip",attrs:{"data-tooltip":"Delete"},on:{"click":function($event){_vm.showDeleteModal($event, item.id, index)}}},[_vm._m(1,true)])],1):_vm._e()])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hj5Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_AuthRepo__ = __webpack_require__("puMg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'forgot-password',
    components: {},
    data: function data() {
        return {
            user: {},
            loading: false,
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_AuthRepo__["a" /* default */](this.$auth)
        };
    },
    created: function created() {},

    methods: {
        forgotPassword: function forgotPassword() {
            var _this = this;

            var component = this;
            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this.loading = true;
                    _this.repo.forgotPassword(_this.user).then(function (response) {
                        _this.loading = false;
                        _this.$toast.success(response.data.message);
                    }).catch(function (response) {
                        this.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    }

});

/***/ }),

/***/ "i79/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-8"},[_c('div',{staticClass:"field"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.premadeSentence.text),expression:"premadeSentence.text"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"is-primary textarea",class:{'input': true, 'is-danger': _vm.errors.has('text') },attrs:{"name":"text","type":"text","placeholder":"Text"},domProps:{"value":(_vm.premadeSentence.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.premadeSentence, "text", $event.target.value)}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade-fast"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('text')),expression:"errors.has('text')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('text')))])]),_vm._v(" "),_c('div',{staticClass:"p5"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.magicWords),function(item,index){return _c('span',{staticClass:"help"},[_c('a',{attrs:{"href":"javascript:{}"},domProps:{"innerHTML":_vm._s(item.alias)},on:{"click":function($event){_vm.addToSentence(item.alias)}}}),_vm._v(" - "),_c('span',{domProps:{"innerHTML":_vm._s(item.description)}})])})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"field"},[_c('multiselect',{attrs:{"label":"name","track-by":"name","name":"categories","placeholder":"Choose category","options":_vm.premadeCategories,"multiple":false},model:{value:(_vm.premadeSentence.premadeCategories[0]),callback:function ($$v) {_vm.$set(_vm.premadeSentence.premadeCategories, 0, $$v)},expression:"premadeSentence.premadeCategories[0]"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('multiselect',{attrs:{"placeholder":"Choose schools","label":"name","track-by":"name","name":"schools","options":_vm.schools,"multiple":true},model:{value:(_vm.premadeSentence.schools),callback:function ($$v) {_vm.$set(_vm.premadeSentence, "schools", $$v)},expression:"premadeSentence.schools"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-offset-2 is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v(" Premade Sentence")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"help"},[_vm._v("In order to make sentences viable for any student, use magic templates like shown below "),_c('span',{staticClass:"has-text-info"},[_vm._v("(click on any of items in order to add it to sentence above)")]),_vm._v(":")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i7WV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("FS6n");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_244f648d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("ViIf");
function injectStyle (ssrContext) {
  __webpack_require__("bxs/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-244f648d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_244f648d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iYFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_LessonRepo__ = __webpack_require__("VMRg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repos_SchoolRepo__ = __webpack_require__("gh8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'lessons-edit',
    components: {},
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_LessonRepo__["a" /* default */](this.$auth),
            schoolRepo: new __WEBPACK_IMPORTED_MODULE_2__repos_SchoolRepo__["a" /* default */](this.$auth),
            loading: false,
            schools: [],
            lesson: {}
        };
    },
    created: function created() {
        this.getSchools();
        this.getLesson(this.$route.params.id);
    },

    methods: {
        getLesson: function getLesson(id) {
            var _this = this;

            this.repo.show(id).then(function (response) {
                _this.lesson = response.data.data;
                if (_this.lesson.school) {
                    _this.lesson.school_id = _this.lesson.school.id;
                }
            });
        },
        getSchools: function getSchools() {
            var _this2 = this;

            this.schoolRepo.all().then(function (response) {
                _this2.schools = response.data.data;
            });
        },
        save: function save() {
            var _this3 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this3;
                    _this3.loading = true;

                    _this3.repo.update(_this3.lesson.id, _this3.lesson).then(function (response) {

                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/lessons');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "ihfG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Http__ = __webpack_require__("OK7G");




/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES


// private sector
var $http = void 0;

//public sector

var AffiliateRepo = function () {
    function AffiliateRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AffiliateRepo);

        $http = new __WEBPACK_IMPORTED_MODULE_3__services_Http__["a" /* default */]($auth);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AffiliateRepo, [{
        key: 'myStats',
        value: function myStats() {
            return $http.get(AffiliateRepo.$resource + "/stats").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'stats',
        value: function stats(id) {
            return $http.get(AffiliateRepo.$resource + "/" + id + "/stats").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'reset',
        value: function reset(id) {
            return $http.get(AffiliateRepo.$resource + "/" + id + "/reset").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }]);

    return AffiliateRepo;
}();

AffiliateRepo.$resource = 'affiliates';
/* harmony default export */ __webpack_exports__["a"] = (AffiliateRepo);

/***/ }),

/***/ "ilwF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                        "+_vm._s(col.name)+" \n                        "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.pivot)?_c('th',[_vm._v("Schools")]):_vm._e(),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{on:{"click":function($event){_vm.show(item.id)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',{staticStyle:{"border":"3px solid black"},style:({'backgroundColor': item.color})},[_c('span',[_vm._v(_vm._s(item.color))])]),_vm._v(" "),_c('td',{staticStyle:{"border":"3px solid black"},style:({'backgroundColor': item.text_color})},[_c('span',[_vm._v(_vm._s(item.text_color))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.order))]),_vm._v(" "),(item.schools)?_c('td',[_vm._v(" "+_vm._s(Array.prototype.map.call(item.schools, function(item) { return item.name; }).join(",")))]):_c('td',[_vm._v("All schools")]),_vm._v(" "),(_vm.pivot && item.pivot && item.pivot.color)?_c('td',[_c('div',{staticClass:"color-box",style:({'backgroundColor': item.pivot.color})})]):_vm._e(),_vm._v(" "),(_vm.pivot && item.pivot && item.pivot.text_color)?_c('td',[_c('div',{staticClass:"color-box",style:({'backgroundColor': item.pivot.text_color})})]):_vm._e(),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'premade-category', params: { id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])]),_vm._v(" "),_c('router-link',{staticClass:"button is-warning tooltip",attrs:{"to":{ name: 'premade-category-edit', params: { id: item.id }},"data-tooltip":"Edit"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-edit"})])]),_vm._v(" "),_c('button',{staticClass:"button is-danger tooltip",attrs:{"data-tooltip":"Delete"},on:{"click":function($event){_vm.showDeleteModal($event, item.id, index)}}},[_vm._m(1,true)])],1):_vm._e()])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iojL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+" \n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{on:{"click":function($event){_vm.show(item.id)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),(item.user)?_c('th',[_vm._v(_vm._s(item.user.email))]):_c('th',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.category))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.content))]),_vm._v(" "),_c('td',{staticClass:"has-text-centered"},[(item.user)?_c('i',{staticClass:"fa fa-check has-text-success"}):_c('i',{staticClass:"fa fa-times has-text-danger"})]),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'ticket', params: { id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])]),_vm._v(" "),_c('button',{staticClass:"button is-danger tooltip",attrs:{"data-tooltip":"Delete"},on:{"click":function($event){_vm.showDeleteModal($event, item.id, index)}}},[_vm._m(1,true)])],1):_vm._e()])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ivyW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_TicketRepo__ = __webpack_require__("407P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table__ = __webpack_require__("BRyG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'tickets-view',
    components: { TicketsTable: __WEBPACK_IMPORTED_MODULE_2__Table__["a" /* default */] },
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_TicketRepo__["a" /* default */](this.$auth),
            tickets: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1
        };
    },
    created: function created() {
        this.getUsers();
    },

    methods: {
        onSearch: function onSearch(q) {
            this.page = 1;
            this.q = q;
            this.getUsers();
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getUsers();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getUsers();
        },
        getUsers: function getUsers() {
            var _this = this;

            this.repo.paginate(this.page, this.q, this.orderBy).then(function (response) {
                _this.tickets = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "iyH7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jTXb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("MtcF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51b4579a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("NpNI");
function injectStyle (ssrContext) {
  __webpack_require__("44hd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51b4579a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51b4579a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jlxw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('router-link',{staticClass:"button is-info is-pulled-right",attrs:{"to":{name: 'add-school' }}},[_vm._v("Add new")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('schools-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.schools,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-graduation-cap"}),_vm._v(" Schools")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jsq9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v("Provider full ID")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"provider_full_id","rules":"required","placeholder":"Provider full id"},model:{value:(_vm.lesson.additionalInfo.provider_full_id),callback:function ($$v) {_vm.$set(_vm.lesson.additionalInfo, "provider_full_id", $$v)},expression:"lesson.additionalInfo.provider_full_id"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade-fast"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v("Lesson Name")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.lesson.additionalInfo.name),callback:function ($$v) {_vm.$set(_vm.lesson.additionalInfo, "name", $$v)},expression:"lesson.additionalInfo.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v("Words (Vocabulary)")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"words","rules":"required","placeholder":"Words"},model:{value:(_vm.lesson.additionalInfo.words),callback:function ($$v) {_vm.$set(_vm.lesson.additionalInfo, "words", $$v)},expression:"lesson.additionalInfo.words"}})],1)]),_vm._v(" "),_vm._l((_vm.lesson.additionalInfo),function(property,index){return (!_vm.excludeProperties.includes(index))?_c('div',{staticClass:"column is-6"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v(_vm._s(_vm.snakeToCamelCase(index)))]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":index,"rules":"","placeholder":_vm.snakeToCamelCase(index)},model:{value:(_vm.lesson.additionalInfo[index]),callback:function ($$v) {_vm.$set(_vm.lesson.additionalInfo, index, $$v)},expression:"lesson.additionalInfo[index]"}})],1)]):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n        Back\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k++z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BulmaPagination_vue__ = __webpack_require__("AkO4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb234780_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BulmaPagination_vue__ = __webpack_require__("FJx8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BulmaPagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb234780_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BulmaPagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k12i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_CategoryRepo__ = __webpack_require__("94/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'categories-add',
    components: {},
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_CategoryRepo__["a" /* default */](this.$auth),
            loading: false,
            categories: [],
            category: {}
        };
    },
    created: function created() {},

    methods: {
        save: function save() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this;
                    _this.loading = true;
                    _this.repo.store(_this.category).then(function (response) {
                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/categories');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "kAH8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Name:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.name))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('router-link',{staticClass:"button is-block is-warning",attrs:{"to":{ name: 'category-edit', params: { id: _vm.item.id }}}},[_vm._v("\n                Edit\n            ")])],1),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v(" Categories")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                Back\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kK/n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kQfT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdditionalInfo_vue__ = __webpack_require__("vb1P");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rest-lesson',
  components: { AdditionalInfo: __WEBPACK_IMPORTED_MODULE_1__AdditionalInfo_vue__["a" /* default */] },
  props: {
    lessonForUpdate: { required: true },
    loading: { required: true, default: false }
  },
  data: function data() {
    return {
      lesson: {},
      excludeProperties: ['id', 'name', 'words', 'provider_full_id']
    };
  },
  created: function created() {
    this.lesson = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.lessonForUpdate);
    if (!this.lesson.id) {
      this.lesson.additionalInfo = this.restDefaultAdditionalInfo();
    }
  },

  methods: {
    save: function save() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.$emit('save', _this.lesson);
        }
      });
    }
  },
  watch: {

    lessonForUpdate: function lessonForUpdate(lesson) {
      this.lesson = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, lesson);
    }

  }

});

/***/ }),

/***/ "keUM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "klKr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("6Snt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba45ebc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("cw8l");
function injectStyle (ssrContext) {
  __webpack_require__("TuuF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ba45ebc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba45ebc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l/c7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EventBus_js__ = __webpack_require__("n2zA");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
				name: 'bulma-input',
				props: {
								name: { required: true },
								value: { required: true },
								type: { default: 'text' },
								rules: { required: true },
								disabled: { required: false, optional: false },
								placeholder: { required: true },
								hasError: { required: false, default: false },
								scope: { required: false, default: '' }
				},
				inject: ['$validator'],
				data: function data() {
								return {
												model: this.value,
												errorName: this.scope == '' ? this.name : this.scope + "." + this.name
								};
				},

				methods: {
								updateData: function updateData(e) {
												this.$emit('input', e.target.value);
								},
								getter: function getter() {
												return this.value;
								},
								context: function context() {
												return this;
								},
								errorMsg: function errorMsg(msg) {
												return msg !== undefined ? msg.replace(/(\_\w)/g, function (m) {
																return " " + m[1];
												}) : msg;
								}
				},
				mounted: function mounted() {
								var options = {
												scope: this.$parent,
												getter: this.value,
												context: this,
												prettyName: this.name
								};

								this.$validator.attach(this.name, this.rules, options);
				},
				destroyed: function destroyed() {
								this.$validator.detach(this.name);
				}
});

/***/ }),

/***/ "l8mi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__("yEsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__repos_Repo__ = __webpack_require__("7vHs");






/**
 * Created by ndzak on 4/23/2016.
 */



var PremadeSentenceRepo = function (_Repo) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(PremadeSentenceRepo, _Repo);

    function PremadeSentenceRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PremadeSentenceRepo);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PremadeSentenceRepo.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PremadeSentenceRepo)).call(this, $auth, 'premade-sentences'));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PremadeSentenceRepo, [{
        key: 'all',
        value: function all(q) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(PremadeSentenceRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PremadeSentenceRepo.prototype), 'all', this).call(this, q, "");
        }
    }, {
        key: 'store',
        value: function store(data) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(PremadeSentenceRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PremadeSentenceRepo.prototype), 'store', this).call(this, data, "");
        }
    }, {
        key: 'update',
        value: function update(id, data) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(PremadeSentenceRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PremadeSentenceRepo.prototype), 'update', this).call(this, id, data, "");
        }
    }, {
        key: 'get',
        value: function get(id) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(PremadeSentenceRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PremadeSentenceRepo.prototype), 'get', this).call(this, id, "");
        }
    }]);

    return PremadeSentenceRepo;
}(__WEBPACK_IMPORTED_MODULE_6__repos_Repo__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PremadeSentenceRepo);

/***/ }),

/***/ "lMa6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CategoryTag',
    components: {},
    props: ['category'],
    data: function data() {
        return {};
    },
    created: function created() {},
    mounted: function mounted() {},

    methods: {},
    watch: {}

});

/***/ }),

/***/ "lOWM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_http_mixin_vue__ = __webpack_require__("P1sU");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_http_mixin_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lVCv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column"},[_c('tickets-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.tickets,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-envelope"}),_vm._v(" Tickets")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lf52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("I0YH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb16a6d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("bhRq");
function injectStyle (ssrContext) {
  __webpack_require__("xJG8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bb16a6d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb16a6d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lyrB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Http__ = __webpack_require__("OK7G");



/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES


// private sector
var $http = void 0;

//public sector

var UserRepo = function () {
    function UserRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, UserRepo);

        $http = new __WEBPACK_IMPORTED_MODULE_3__services_Http__["a" /* default */]($auth);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(UserRepo, [{
        key: 'me',
        value: function me() {
            return $http.get(UserRepo.$resource + UserRepo.$me + "?include=profile,roles").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'show',
        value: function show(id) {
            return $http.get(UserRepo.$resource + "/" + id + "?include=profile.school,categories,roles").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'store',
        value: function store(data) {
            return $http.post(UserRepo.$resource, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'export',
        value: function _export(data) {
            return $http.post(UserRepo.$resource + "/export", data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'all',
        value: function all() {
            return $http.get(UserRepo.$resource + "?include=profile,roles").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'paginate',
        value: function paginate(page, q, orderBy) {
            var query = "page=" + page + "&include=profile,roles";
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(UserRepo.$resource + "/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'categoriesPaginate',
        value: function categoriesPaginate(id, page, q, orderBy) {
            var query = "page=" + page + "&include=";
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(UserRepo.$resource + "/" + id + "/categories/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'sentencesPaginate',
        value: function sentencesPaginate(id, page, q, orderBy) {
            var query = "page=" + page + "&include=user.profile,categories";
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(UserRepo.$resource + "/" + id + "/sentences/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'commentsPaginate',
        value: function commentsPaginate(id, page, q, orderBy) {
            var query = "page=" + page + "&include=user.profile,sentences";
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(UserRepo.$resource + "/" + id + "/comments/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'newsPaginate',
        value: function newsPaginate(id, page, q, orderBy) {
            var query = "page=" + page + "&include=";
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(UserRepo.$resource + "/" + id + "/news/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'sessionsPaginate',
        value: function sessionsPaginate(id, page, q, orderBy) {
            var query = "page=" + page + "&include=";
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(UserRepo.$resource + "/" + id + "/user-sessions/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'affiliatesPaginate',
        value: function affiliatesPaginate(id, page, q, orderBy) {
            var query = "page=" + page + "&include=";
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(UserRepo.$resource + "/" + id + "/affiliates/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'myAffiliatePaginate',
        value: function myAffiliatePaginate(page, q, orderBy) {
            var query = "page=" + page + "&include=";
            if (q != '') {
                query += "&q=" + q;
            }

            if (orderBy != '') {
                query += "&orderBy=" + orderBy;
            }

            return $http.get(UserRepo.$resource + "/affiliates/paginate?" + query).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'update',
        value: function update(id, data) {
            return $http.put(UserRepo.$resource + "/" + id, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            return $http.delete(UserRepo.$resource + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'commentsHistory',
        value: function commentsHistory() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var pagination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;

            return $http.get(UserRepo.$resource + UserRepo.$me + "/comments/history?include=sentences.categories&page=" + page + "&pagination=" + pagination).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'favComments',
        value: function favComments() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var pagination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;

            return $http.get(UserRepo.$resource + UserRepo.$me + "/comments/favorite?include=sentences.categories&page=" + page + "&pagination=" + pagination).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'attachRole',
        value: function attachRole(id, role_id) {
            return $http.post(UserRepo.$resource + "/" + id + "/roles/" + role_id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'detachRole',
        value: function detachRole(id, role_id) {
            return $http.delete(UserRepo.$resource + "/" + id + "/roles/" + role_id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }]);

    return UserRepo;
}();

UserRepo.$resource = 'users';
UserRepo.$me = '/me';
/* harmony default export */ __webpack_exports__["a"] = (UserRepo);

/***/ }),

/***/ "m4wb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("yOEb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af82372_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("kAH8");
function injectStyle (ssrContext) {
  __webpack_require__("5umN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7af82372"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af82372_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mEtE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Text:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.text))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Favorite:")]),_vm._v(" "),_c('div',{staticClass:"control"},[(_vm.item.favorite == true)?_c('i',{staticClass:"fa fa-check has-text-success"}):_c('i',{staticClass:"fa fa-times has-text-danger"})])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Score:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.score))])])])]),_vm._v(" "),(_vm.item.user && _vm.item.user.profile)?_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Teacher:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.user.profile.name))])])])]):_vm._e(),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-coffee"}),_vm._v(" Comments")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                Back\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mFYn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_StudentRepo__ = __webpack_require__("CSv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repos_SchoolRepo__ = __webpack_require__("gh8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'students-edit',
    components: {},
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_StudentRepo__["a" /* default */](this.$auth),
            schoolRepo: new __WEBPACK_IMPORTED_MODULE_2__repos_SchoolRepo__["a" /* default */](this.$auth),
            loading: false,
            schools: [],
            student: {}
        };
    },
    created: function created() {
        this.getSchools();
        this.getStudent(this.$route.params.id);
    },

    methods: {
        getStudent: function getStudent(id) {
            var _this = this;

            this.repo.show(id).then(function (response) {
                _this.student = response.data.data;
                if (_this.student.school) {
                    _this.student.school_id = _this.student.school.id;
                }
            });
        },
        getSchools: function getSchools() {
            var _this2 = this;

            this.schoolRepo.all().then(function (response) {
                _this2.schools = response.data.data;
            });
        },
        save: function save() {
            var _this3 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this3;
                    _this3.loading = true;

                    _this3.repo.update(_this3.student.id, _this3.student).then(function (response) {

                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/students');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "mIBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mJq/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag is-pulled-right",style:({'background-color' : _vm.category.color, 'color' : _vm.category.text_color})},[_vm._v(_vm._s(_vm.category.name))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mN3G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("wqn/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_543abd7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("pmim");
function injectStyle (ssrContext) {
  __webpack_require__("pAmq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-543abd7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_543abd7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mNJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lesson-additional-info',
  components: {},
  props: {
    additionalInfo: { required: true }
  },
  data: function data() {
    return {
      excludeProperties: ['id', 'name', 'words', 'provider_full_id', 'provider_id']
    };
  },
  created: function created() {
    this.stbyInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.additionalInfo);
    console.log(this.additionalInfo);
  },

  methods: {
    /*      save () {
    
            this.$validator.validateAll().then((result) => {
              if (result) {
                this.$emit('submit', result);
              }
            })
          }*/
  },
  watch: {
    'stbyInfo': function stbyInfo(value) {
      console.log(value);
    }

  }

});

/***/ }),

/***/ "mQcb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.category.name),callback:function ($$v) {_vm.$set(_vm.category, "name", $$v)},expression:"category.name"}})],1)]),_vm._v(" "),(_vm.categories && _vm.categories.length > 0)?_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.category_id),expression:"category.category_id"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(category){return _c('option',{domProps:{"value":category.id}},[_vm._v(_vm._s(category.name))])}),0)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v(" Categories")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mRqq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PremadeComment_vue__ = __webpack_require__("Svtn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4665004_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PremadeComment_vue__ = __webpack_require__("ynQQ");
function injectStyle (ssrContext) {
  __webpack_require__("JCdL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a4665004"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PremadeComment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4665004_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PremadeComment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mWgo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('router-link',{staticClass:"button is-info is-pulled-right",attrs:{"to":{name: 'add-user' }}},[_vm._v("Add new")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('users-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.users,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" Users")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mdkB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table__ = __webpack_require__("klKr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sb-lessons-view',
    components: { LessonsTable: __WEBPACK_IMPORTED_MODULE_1__Table__["a" /* default */] },
    data: function data() {
        return {
            lessons: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
            school_id: null
        };
    },
    created: function created() {
        this.getLessons();
    },

    methods: {
        onSearch: function onSearch(q) {
            this.page = 1;
            this.q = q;
            this.getLessons();
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getLessons();
        },
        onSchoolChanged: function onSchoolChanged(school_id) {
            this.school_id = school_id;
            this.getLessons();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getLessons();
        },
        getLessons: function getLessons() {
            var _this = this;

            var data = {
                page: this.page,
                query: this.q,
                orderBy: this.orderBy,
                school_id: this.school_id
            };
            this.stbyLessonRepo.search(data).then(function (response) {
                _this.lessons = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        }
    },
    watch: {
        'school': function school(value) {}
    }

});

/***/ }),

/***/ "mgMI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mlaz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("SrMG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d24e2bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("i79/");
function injectStyle (ssrContext) {
  __webpack_require__("qvit")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d24e2bf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d24e2bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "muyx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button is-block",class:[_vm.color, {'is-loading' : _vm.loading}],on:{"click":function($event){_vm.click($event)}}},[(_vm.icon != '')?_c('span',{staticClass:"icon"},[_c('i',{class:['fa', _vm.icon]})]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mvwp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+" \n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.pivot)?_c('th',[_vm._v("Seen")]):_vm._e(),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{on:{"click":function($event){_vm.show(item.id)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type))]),_vm._v(" "),(item.pivot && _vm.pivot && item.pivot.seen !== undefined)?_c('td',{staticClass:"has-text-centered"},[(item.pivot.seen == true)?_c('i',{staticClass:"fa fa-check has-text-success"}):_c('i',{staticClass:"fa fa-times has-text-danger"})]):_vm._e(),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'news', params: { id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])]),_vm._v(" "),_c('router-link',{staticClass:"button is-warning tooltip",attrs:{"to":{ name: 'news-edit', params: { id: item.id }},"data-tooltip":"Edit"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-edit"})])]),_vm._v(" "),_c('button',{staticClass:"button is-danger tooltip",attrs:{"data-tooltip":"Delete"},on:{"click":function($event){_vm.showDeleteModal($event, item.id, index)}}},[_vm._m(1,true)])],1):_vm._e()])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n2zA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({});

EventBus.$on('serverError', function (argument) {
    if (argument.error === undefined) {
        return;
    }

    var status = argument.error.status;

    if (status == 401) {
        return;
    }

    if (status == 422) {
        var errors = argument.error.data.errors;
        var isObject = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.every(errors, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject);
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(errors, function (error) {

            if (isObject) {
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(error, function (message) {
                    argument.component.$toast.error(message);
                });
            } else {
                argument.component.$toast.error(error);
            }
        });
    } else {
        argument.component.$toast.error(argument.error.data.message);
        /*        if((status == 400 || status == 401)){
        
                }*/
    }
});

/***/ }),

/***/ "nAcR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nYEN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nsFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Provider id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.provider_id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Name:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.name))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Nick:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.nick))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Gender:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.gender))])])])]),_vm._v(" "),(_vm.item.school)?_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("School:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.school.name))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('router-link',{staticClass:"button is-block is-warning",attrs:{"to":{ name: 'student-edit', params: { id: _vm.item.id }}}},[_vm._v("\n                Edit\n            ")])],1),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-user-circle"}),_vm._v(" Students")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                Back\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ntjD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("mFYn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76a636d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("NTch");
function injectStyle (ssrContext) {
  __webpack_require__("e3uZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76a636d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76a636d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nzVJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Http__ = __webpack_require__("OK7G");



/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES


// private sector
var $http = void 0;

//public sector

var RoleRepo = function () {
    function RoleRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RoleRepo);

        $http = new __WEBPACK_IMPORTED_MODULE_3__services_Http__["a" /* default */]($auth);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RoleRepo, [{
        key: 'all',
        value: function all() {
            return $http.get(RoleRepo.$resource).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }]);

    return RoleRepo;
}();

RoleRepo.$resource = 'roles';
/* harmony default export */ __webpack_exports__["a"] = (RoleRepo);

/***/ }),

/***/ "o0AB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Text:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.text))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Categories:")]),_vm._v(" "),_vm._l((_vm.item.premadeCategories),function(cat){return _c('div',{staticClass:"control"},[_c('p',[_vm._v(_vm._s(cat.name))])])})],2)]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Schools:")]),_vm._v(" "),(!_vm.item.schools)?_c('div',{staticClass:"control"},[_vm._v("All schools")]):_vm._l((_vm.item.schools),function(school){return _c('div',{staticClass:"control"},[_c('p',[_vm._v(_vm._s(school.name))])])})],2)]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Sentences")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                Back\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oCoU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Id:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.id))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Alias:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.alias))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Title:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.title))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Placeholder:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.placeholder))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Description:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.description))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Field type:")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_vm._v(_vm._s(_vm.item.type))])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Schools:")]),_vm._v(" "),(!_vm.item.schools)?_c('div',{staticClass:"control"},[_vm._v("All schools")]):_vm._l((_vm.item.schools),function(school){return _c('div',{staticClass:"control"},[_c('p',[_vm._v(_vm._s(school.name))])])})],2)]),_vm._v(" "),_c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('router-link',{staticClass:"button is-block is-warning",attrs:{"to":{ name: 'magic-word-edit', params: { id: _vm.item.id }}}},[_vm._v("\n                Edit\n            ")])],1),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v(" Categories")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                Back\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oNTC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_StudentRepo__ = __webpack_require__("CSv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'students-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Provider id',
                key: 'provider_id'
            }, {
                name: 'Name',
                key: 'name'
            }, {
                name: 'Nick',
                key: 'nick'
            }, {
                name: 'Gender',
                key: 'gender'
            }, {
                name: 'School',
                key: ''
            }],
            reverse: true,
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_StudentRepo__["a" /* default */](this.$auth)
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        show: function show(id) {
            this.$router.push('/dashboard/students/' + id);
        },
        showDeleteModal: function showDeleteModal(event, id, index) {
            event.stopPropagation();
            var self = this;
            this.$swal({
                title: 'Are you sure?',
                text: "This will delete this student permanently!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3273dc',
                cancelButtonColor: '#ff3860',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    self.deleteStudent(id, index);
                }
            }).catch(function (result) {});
        },
        deleteStudent: function deleteStudent(id, index) {
            var _this = this;

            this.repo.delete(id).then(function (response) {
                _this.items.splice(index, 1);
                _this.$swal('Deleted!', 'Student has been deleted.', 'success');
            });
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "ogM9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oh3C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p1FB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("2nGI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7276ad06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("I1GP");
function injectStyle (ssrContext) {
  __webpack_require__("1UrL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7276ad06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7276ad06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p4j0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-4"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v("Search text")]),_vm._v(" "),_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.query),expression:"search.query"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search.query)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "query", $event.target.value)}}}),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"column is-4"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v("School")]),_vm._v(" "),_c('div',{staticClass:"control has-icons-left"},[_c('multiselect',{attrs:{"label":"name","name":"schools","track-by":"id","options":_vm.schools,"placeholder":"Choose school"},model:{value:(_vm.search.school),callback:function ($$v) {_vm.$set(_vm.search, "school", $$v)},expression:"search.school"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-4"},[_c('span',{staticClass:"heading has-text-grey-dark"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"control has-icons-left"},[_c('multiselect',{attrs:{"options":_vm.statuses,"placeholder":"Status"},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}})],1)])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                        "+_vm._s(col.name)+"\n                        "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return (item.original)?_c('tr',[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"control"},[_c('b',{staticClass:"aquamarine"},[_vm._v(_vm._s(item.provider_full_id ? item.provider_full_id : item.provider_id))]),_vm._v(" /\n                            "),_c('b',{staticClass:"deeppink"},[_vm._v(_vm._s(item.original.provider_full_id ? item.original.provider_full_id : item.original.provider_id))])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"control"},[_c('b',{staticClass:"aquamarine"},[_vm._v(_vm._s(item.name))]),_vm._v(" /\n                            "),_c('b',{staticClass:"deeppink"},[_vm._v(_vm._s(item.original.name))])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"control"},[_c('b',{staticClass:"aquamarine"},[_vm._v(_vm._s(item.words))]),_vm._v(" /\n                            "),_c('b',{staticClass:"deeppink"},[_vm._v(_vm._s(item.original.words))])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.status))]),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'sb-lesson-changes-show', params: { lesson_id: item.original.lesson_id, id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])])],1):_vm._e()]):_vm._e()}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pAmq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pWcQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs__ = __webpack_require__("vH/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animejs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    selected: Boolean,
    title: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      isActived: this.selected
    };
  },
  created: function created() {
    this._isCollapseItem = true;
  },
  mounted: function mounted() {
    this.$on('open', this.$parent.openByIndex);
    if (this.isActived) {
      this.$emit('open', this.index);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.anime && this.targets) {
      __WEBPACK_IMPORTED_MODULE_0_animejs___default.a.remove(this.targets);
    }
    this.$off('open', this.$parent.openByIndex);
  },


  computed: {
    index: function index() {
      return this.$parent.$collapseItems.indexOf(this);
    }
  },

  methods: {
    toggle: function toggle() {
      if (this.isActived = !this.isActived) {
        this.$emit('open', this.index);
      }
    },
    getAnime: function getAnime(targets) {
      if (this.anime) return this.anime;
      return this.anime = __WEBPACK_IMPORTED_MODULE_0_animejs___default()({ targets: targets });
    },
    cancel: function cancel() {
      this.anime.pause();
    },
    before: function before(targets) {
      if (!this.targets) this.targets = targets;
      targets.removeAttribute('style');
    },
    enter: function enter(targets, done) {
      var height = targets.scrollHeight;
      targets.style.height = 0;
      targets.style.opacity = 0;
      this.getAnime(targets).play({
        targets: targets,
        duration: 377,
        easing: 'easeOutExpo',
        opacity: [0, 1],
        height: height,
        complete: function complete() {
          targets.removeAttribute('style');
          done();
        }
      });
    },
    leave: function leave(targets, complete) {
      this.getAnime(targets).play({
        targets: targets,
        duration: 377,
        easing: 'easeOutExpo',
        opacity: [1, 0],
        height: 0,
        complete: complete
      });
    }
  }
});

/***/ }),

/***/ "pmim":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column"},[_c('comments-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.comments,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-coffee"}),_vm._v(" Comments")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "puMg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Http__ = __webpack_require__("OK7G");



/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES


// private sector
var $http = void 0;

//public sector

var AuthRepo = function () {
    function AuthRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AuthRepo);

        $http = new __WEBPACK_IMPORTED_MODULE_3__services_Http__["a" /* default */]($auth);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AuthRepo, [{
        key: "forgotPassword",
        value: function forgotPassword(data) {
            return $http.post("forgot/password", data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: "passwordReset",
        value: function passwordReset(data) {
            return $http.post("password/reset", data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: "confirmEmail",
        value: function confirmEmail(token) {
            return $http.get("email/confirmation/" + token).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }]);

    return AuthRepo;
}();

/* harmony default export */ __webpack_exports__["a"] = (AuthRepo);

/***/ }),

/***/ "q91X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__ = __webpack_require__("/BmC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_501747d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__ = __webpack_require__("c2cV");
function injectStyle (ssrContext) {
  __webpack_require__("UjI3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-501747d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_501747d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qOY+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qPMP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("+0R2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e00c610_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("fOXH");
function injectStyle (ssrContext) {
  __webpack_require__("NOw2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e00c610"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e00c610_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qd0V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.school.name),callback:function ($$v) {_vm.$set(_vm.school, "name", $$v)},expression:"school.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"url","rules":"","placeholder":"Url"},model:{value:(_vm.school.url),callback:function ($$v) {_vm.$set(_vm.school, "url", $$v)},expression:"school.url"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"logo","rules":"","placeholder":"Logo"},model:{value:(_vm.school.logo),callback:function ($$v) {_vm.$set(_vm.school, "logo", $$v)},expression:"school.logo"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-graduation-cap"}),_vm._v(" Schools")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qj2z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_NewsRepo__ = __webpack_require__("O7DD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table__ = __webpack_require__("UztG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'news-view',
    components: { NewsTable: __WEBPACK_IMPORTED_MODULE_2__Table__["a" /* default */] },
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_NewsRepo__["a" /* default */](this.$auth),
            news: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1
        };
    },
    created: function created() {
        this.getNews();
    },

    methods: {
        onSearch: function onSearch(q) {
            this.page = 1;
            this.q = q;
            this.getNews();
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getNews();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getNews();
        },
        getNews: function getNews() {
            var _this = this;

            this.repo.paginate(this.page, this.q, this.orderBy).then(function (response) {
                _this.news = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "qvit":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rD+/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rHEA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'premade-comments-show',
  components: {},
  data: function data() {
    return {
      item: {}
    };
  },
  created: function created() {
    this.getPremadeComment(this.$route.params.id);
  },

  methods: {
    getPremadeComment: function getPremadeComment(id) {
      var _this = this;

      this.premadeCommentRepo.get(id).then(function (response) {
        _this.item = response.data.data;
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "rPOL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'premade-comments-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Caption',
                key: 'caption'
            }, {
                name: 'Text',
                key: 'text'
            }, {
                name: 'Score',
                key: 'score'
            }, {
                name: 'Schools',
                key: ''
            }],
            reverse: true
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        show: function show(id) {
            this.$router.push('/dashboard/premade-comments/' + id);
        },
        showDeleteModal: function showDeleteModal(event, id, index) {
            event.stopPropagation();
            var self = this;
            this.$swal({
                title: 'Are you sure?',
                text: "This will delete this premade comment permanently!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3273dc',
                cancelButtonColor: '#ff3860',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    self.deletePremadeComment(id, index);
                }
            }).catch(function (result) {});
        },
        deletePremadeComment: function deletePremadeComment(id, index) {
            var _this = this;

            this.premadeCommentRepo.delete(id).then(function (response) {
                _this.items.splice(index, 1);
                _this.$swal('Deleted!', 'Premade comment has been deleted.', 'success');
            });
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "rc42":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rcNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'magic-word-edit',
    components: {},
    props: {},
    data: function data() {
        return {
            loading: false,
            schools: [],
            magicWord: { schools: [] }
        };
    },
    created: function created() {
        this.loadSchools();
    },

    methods: {
        getMagicWord: function getMagicWord(id) {
            var _this = this;

            this.magicWordRepo.get(id).then(function (response) {
                _this.magicWord = response.data.data;
            });
        },
        loadSchools: function loadSchools() {
            var _this2 = this;

            this.loading = true;
            this.schoolRepo.all().then(function (response) {
                _this2.schools = response.data.data;
                _this2.loading = false;
                _this2.getMagicWord(_this2.$route.params.id);
            }).catch(function (response) {
                _this2.loading = false;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        },
        save: function save() {
            var _this3 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this3;
                    _this3.loading = true;

                    _this3.magicWordRepo.update(_this3.magicWord.id, _this3.magicWord).then(function (response) {
                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/magic-words');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "rmeB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Http__ = __webpack_require__("OK7G");



// SERVICES


// private sector
var $http = void 0;

var STBYLessonRepo = function () {
    function STBYLessonRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, STBYLessonRepo);

        $http = new __WEBPACK_IMPORTED_MODULE_3__services_Http__["a" /* default */]($auth);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(STBYLessonRepo, [{
        key: 'show',
        value: function show(id) {
            return $http.get(STBYLessonRepo.$resource + "/" + id + "?include=school").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'store',
        value: function store(data) {
            return $http.post(STBYLessonRepo.$resource, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'all',
        value: function all() {
            return $http.get(STBYLessonRepo.$resource + "?include=school").then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'paginate',
        value: function paginate(data) {
            var query = "include=school";
            return $http.post(STBYLessonRepo.$resource + "/paginate?" + query, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'update',
        value: function update(id, data) {
            return $http.put(STBYLessonRepo.$resource + "/" + id, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            return $http.delete(STBYLessonRepo.$resource + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'search',
        value: function search(data) {
            var url = STBYLessonRepo.$resource + '/search?include=school';
            return $http.post(url, data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }

        //CHANGES

    }, {
        key: 'paginateChanges',
        value: function paginateChanges(search) {

            return $http.post(STBYLessonRepo.$resource + "/changes/paginate", search).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'showChanges',
        value: function showChanges(lesson_id, id) {
            return $http.get(STBYLessonRepo.$resource + "/changes/" + lesson_id + "/" + id).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'approveChanges',
        value: function approveChanges(item, data) {
            return $http.post(STBYLessonRepo.$resource + "/approve/" + item.original.lesson_id + "/" + item.id + "?include=", data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }, {
        key: 'declineChanges',
        value: function declineChanges(item, data) {
            return $http.post(STBYLessonRepo.$resource + "/decline/" + item.original.lesson_id + "/" + item.id + "?include=", data).then(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
            }).catch(function (response) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    }]);

    return STBYLessonRepo;
}();

STBYLessonRepo.$resource = 'stbylessons';
/* harmony default export */ __webpack_exports__["a"] = (STBYLessonRepo);

/***/ }),

/***/ "rxcD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sh1o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_SchoolRepo__ = __webpack_require__("gh8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'schools-add',
    components: {},
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_1__repos_SchoolRepo__["a" /* default */](this.$auth),
            loading: false,
            schools: [],
            school: {}
        };
    },
    created: function created() {},

    methods: {
        save: function save() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var self = _this;
                    _this.loading = true;
                    _this.repo.store(_this.school).then(function (response) {
                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/schools');
                    }).catch(function (response) {
                        self.loading = false;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
                    });
                }
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "shy6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse is-fullwidth"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "so2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_SentenceRepo__ = __webpack_require__("5sB1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sessions-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Date',
                key: 'created_at'
            }, {
                name: 'Ip',
                key: 'ip_address'
            }, {
                name: 'Browser',
                key: 'browser'
            }, {
                name: 'City',
                key: 'city'
            }, {
                name: 'Country',
                key: 'country'
            }, {
                name: 'Country Code',
                key: 'country_code'
            }, {
                name: 'Zip',
                key: 'zip_code'
            }],
            reverse: true
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "soJL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('premade-comment',{attrs:{"loadedPremadeComment":_vm.premadeComment,"update":false}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t/se":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_SentenceRepo__ = __webpack_require__("5sB1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sentences-show',
  components: {},
  data: function data() {
    return {
      repo: new __WEBPACK_IMPORTED_MODULE_0__repos_SentenceRepo__["a" /* default */](this.$auth),
      item: {}
    };
  },
  created: function created() {
    this.getUser(this.$route.params.id);
  },

  methods: {
    getUser: function getUser(id) {
      var _this = this;

      this.repo.show(id).then(function (response) {
        _this.item = response.data.data;
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "t06V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("RBir");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e175f4bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("ytC3");
function injectStyle (ssrContext) {
  __webpack_require__("Uami")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e175f4bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e175f4bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t6hQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tQP6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_StudentRepo__ = __webpack_require__("CSv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'students-show',
  components: {},
  data: function data() {
    return {
      repo: new __WEBPACK_IMPORTED_MODULE_0__repos_StudentRepo__["a" /* default */](this.$auth),
      item: {}
    };
  },
  created: function created() {
    this.getStudent(this.$route.params.id);
  },

  methods: {
    getStudent: function getStudent(id) {
      var _this = this;

      this.repo.show(id).then(function (response) {
        _this.item = response.data.data;
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "tQig":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("TRxv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_930c54d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("p4j0");
function injectStyle (ssrContext) {
  __webpack_require__("fiLV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-930c54d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_930c54d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tiiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_STBYLesson_vue__ = __webpack_require__("L1Ji");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3189dd87_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_STBYLesson_vue__ = __webpack_require__("c9Cq");
function injectStyle (ssrContext) {
  __webpack_require__("7FxH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3189dd87"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_STBYLesson_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3189dd87_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_STBYLesson_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "txU0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("A3xT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_125df1c3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("EuV6");
function injectStyle (ssrContext) {
  __webpack_require__("hOh2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-125df1c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_125df1c3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u/GD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u1S3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u64L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uBJu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uPQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("ep0L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_818ffc52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("Nrdq");
function injectStyle (ssrContext) {
  __webpack_require__("Xb/0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-818ffc52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_818ffc52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uTud":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("3yEL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_037be668_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("djyL");
function injectStyle (ssrContext) {
  __webpack_require__("55ej")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-037be668"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_037be668_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uZ6n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_CommentRepo__ = __webpack_require__("V/pO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'comments-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Text',
                key: 'text'
            }, {
                name: 'Favorite',
                key: 'favorite'
            }, {
                name: 'Count',
                key: 'count'
            }, {
                name: 'Score',
                key: 'score'
            }, {
                name: 'Teacher',
                key: ''
            }],
            reverse: true,
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_CommentRepo__["a" /* default */](this.$auth)
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        show: function show(id) {
            this.$router.push('/dashboard/comments/' + id);
        },
        showDeleteModal: function showDeleteModal(event, id, index) {
            event.stopPropagation();
            var self = this;
            this.$swal({
                title: 'Are you sure?',
                text: "This will delete this comment permanently!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3273dc',
                cancelButtonColor: '#ff3860',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    self.deleteComment(id, index);
                }
            }).catch(function (result) {});
        },
        deleteComment: function deleteComment(id, index) {
            var _this = this;

            this.repo.delete(id).then(function (response) {
                _this.items.splice(index, 1);
                _this.$swal('Deleted!', 'Comment has been deleted.', 'success');
            });
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "ufQ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordReset_vue__ = __webpack_require__("LV5U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1b9ffd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordReset_vue__ = __webpack_require__("wjf3");
function injectStyle (ssrContext) {
  __webpack_require__("Alf+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f1b9ffd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordReset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1b9ffd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordReset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "utXB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_UserRepo__ = __webpack_require__("lyrB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repos_AffiliateRepo__ = __webpack_require__("ihfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__categories_Table__ = __webpack_require__("1j+s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentences_Table__ = __webpack_require__("66zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__comments_Table__ = __webpack_require__("yh4F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__news_Table__ = __webpack_require__("UztG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stats_Table__ = __webpack_require__("p1FB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sessions_Table__ = __webpack_require__("JXkA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'users-show',
  components: { CategoriesTable: __WEBPACK_IMPORTED_MODULE_2__categories_Table__["a" /* default */], SentencesTable: __WEBPACK_IMPORTED_MODULE_3__sentences_Table__["a" /* default */], CommentsTable: __WEBPACK_IMPORTED_MODULE_4__comments_Table__["a" /* default */], NewsTable: __WEBPACK_IMPORTED_MODULE_5__news_Table__["a" /* default */], SessionsTable: __WEBPACK_IMPORTED_MODULE_7__sessions_Table__["a" /* default */], AffiliateTable: __WEBPACK_IMPORTED_MODULE_6__stats_Table__["a" /* default */] },
  data: function data() {
    return {
      repo: new __WEBPACK_IMPORTED_MODULE_0__repos_UserRepo__["a" /* default */](this.$auth),
      affiliateRepo: new __WEBPACK_IMPORTED_MODULE_1__repos_AffiliateRepo__["a" /* default */](this.$auth),
      item: {},
      showSessionsTable: false,
      sessions: [],
      sessionsTotal: 0,
      sessionsQ: '',
      sessionsOrderBy: 'id,asc',
      sessionsPage: 1,
      showCatTable: false,
      categories: [],
      catTotal: 0,
      catQ: '',
      catOrderBy: 'id,asc',
      catPage: 1,
      showSentencesTable: false,
      sentences: [],
      sentencesTotal: 0,
      sentencesQ: '',
      sentencesOrderBy: 'id,asc',
      sentencesPage: 1,
      showCommTable: false,
      comments: [],
      commentsTotal: 0,
      commentsQ: '',
      commentsOrderBy: 'id,asc',
      commentsPage: 1,
      showNewsTable: false,
      news: [],
      newsTotal: 0,
      newsQ: '',
      newsOrderBy: 'id,asc',
      newsPage: 1,
      showAffiliatesTable: false,
      affiliates: [],
      affiliatesTotal: 0,
      affiliatesQ: '',
      affiliatesOrderBy: 'fee,desc',
      affiliatesPage: 1,
      affiliateStats: {
        referrals: 0,
        earned: 0.00,
        current: 0.00
      }
    };
  },
  created: function created() {
    this.getUser(this.$route.params.id);
    this.getSessions();
    this.getCategories();
    this.getSentences();
    this.getComments();
    this.getNews();
    this.getAffiliates();
    this.getAffiliateStats();
  },

  methods: {
    getUser: function getUser(id) {
      var _this = this;

      this.repo.show(id).then(function (response) {
        _this.item = response.data.data;
      });
    },
    toggleSessionsTable: function toggleSessionsTable() {
      this.showSessionsTable = !this.showNewsTable;
    },
    onSessionsSearch: function onSessionsSearch(q) {
      this.sessionsPage = 1;
      this.sessionsQ = q;
      this.getSessions();
    },
    onSessionsOrderBy: function onSessionsOrderBy(orderBy) {
      this.sessionsPage = 1;
      this.sessionsOrderBy = orderBy;
      this.getSessions();
    },
    onSessionsPageChanged: function onSessionsPageChanged(page) {
      this.sessionsPage = page;
      this.getSessions();
    },
    getSessions: function getSessions() {
      var _this2 = this;

      this.repo.sessionsPaginate(this.$route.params.id, this.sessionsPage, this.sessionsQ, this.sessionsOrderBy).then(function (response) {
        console.log(response.data.data);
        _this2.sessions = response.data.data;
        _this2.sessionsTotal = response.data.meta.pagination.total_pages;
      });
    },
    toggleCatTable: function toggleCatTable() {
      this.showCatTable = !this.showCatTable;
    },
    onCatSearch: function onCatSearch(q) {
      this.catPage = 1;
      this.catQ = q;
      this.getCategories();
    },
    onCatOrderBy: function onCatOrderBy(orderBy) {
      this.catPage = 1;
      this.catOrderBy = orderBy;
      this.getCategories();
    },
    onCatPageChanged: function onCatPageChanged(page) {
      this.catPage = page;
      this.getCategories();
    },
    getCategories: function getCategories() {
      var _this3 = this;

      this.repo.categoriesPaginate(this.$route.params.id, this.catPage, this.catQ, this.catOrderBy).then(function (response) {
        _this3.categories = response.data.data;
        _this3.catTotal = response.data.meta.pagination.total_pages;
      });
    },
    toggleSentencesTable: function toggleSentencesTable() {
      this.showSentencesTable = !this.showSentencesTable;
    },
    onSentencesSearch: function onSentencesSearch(q) {
      this.sentencesPage = 1;
      this.sentencesQ = q;
      this.getSentences();
    },
    onSentencesOrderBy: function onSentencesOrderBy(orderBy) {
      this.sentencesPage = 1;
      this.sentencesOrderBy = orderBy;
      this.getSentences();
    },
    onSentencesPageChanged: function onSentencesPageChanged(page) {
      this.sentencesPage = page;
      this.getSentences();
    },
    getSentences: function getSentences() {
      var _this4 = this;

      this.repo.sentencesPaginate(this.$route.params.id, this.sentencesPage, this.sentencesQ, this.sentencesOrderBy).then(function (response) {
        _this4.sentences = response.data.data;
        _this4.sentencesTotal = response.data.meta.pagination.total_pages;
      });
    },
    toggleCommTable: function toggleCommTable() {
      this.showCommTable = !this.showCommTable;
    },
    onCommSearch: function onCommSearch(q) {
      this.commentsPage = 1;
      this.commentsQ = q;
      this.getComments();
    },
    onCommOrderBy: function onCommOrderBy(orderBy) {
      this.commentsPage = 1;
      this.commentsOrderBy = orderBy;
      this.getComments();
    },
    onCommPageChanged: function onCommPageChanged(page) {
      this.commentsPage = page;
      this.getComments();
    },
    getComments: function getComments() {
      var _this5 = this;

      this.repo.commentsPaginate(this.$route.params.id, this.commentsPage, this.commentsQ, this.commentsOrderBy).then(function (response) {
        _this5.comments = response.data.data;
        _this5.commentsTotal = response.data.meta.pagination.total_pages;
      });
    },
    toggleNewsTable: function toggleNewsTable() {
      this.showNewsTable = !this.showNewsTable;
    },
    onNewsSearch: function onNewsSearch(q) {
      this.newsPage = 1;
      this.newsQ = q;
      this.getNews();
    },
    onNewsOrderBy: function onNewsOrderBy(orderBy) {
      this.newsPage = 1;
      this.newsOrderBy = orderBy;
      this.getNews();
    },
    onNewsPageChanged: function onNewsPageChanged(page) {
      this.newsPage = page;
      this.getNews();
    },
    getNews: function getNews() {
      var _this6 = this;

      this.repo.newsPaginate(this.$route.params.id, this.newsPage, this.newsQ, this.newsOrderBy).then(function (response) {
        _this6.news = response.data.data;
        _this6.newsTotal = response.data.meta.pagination.total_pages;
      });
    },
    toggleAffiliatesTable: function toggleAffiliatesTable() {
      this.showAffiliatesTable = !this.showAffiliatesTable;
    },
    onAffiliatesSearch: function onAffiliatesSearch(q) {
      this.affiliatesPage = 1;
      this.affiliatesQ = q;
      this.getAffiliates();
    },
    onAffiliatesOrderBy: function onAffiliatesOrderBy(orderBy) {
      this.affiliatesPage = 1;
      this.affiliatesOrderBy = orderBy;
      this.getAffiliates();
    },
    onAffiliatesPageChanged: function onAffiliatesPageChanged(page) {
      this.affiliatesPage = page;
      this.getAffiliates();
    },
    getAffiliates: function getAffiliates() {
      var _this7 = this;

      this.repo.affiliatesPaginate(this.$route.params.id, this.affiliatesPage, this.affiliatesQ, this.affiliatesOrderBy).then(function (response) {
        _this7.affiliates = response.data.data;
        _this7.affiliatesTotal = response.data.meta.pagination.total_pages;
      });
    },
    getAffiliateStats: function getAffiliateStats() {
      var _this8 = this;

      this.affiliateRepo.stats(this.$route.params.id).then(function (response) {
        _this8.affiliateStats = response.data.data;
      });
    },
    resetAffiliateBalance: function resetAffiliateBalance() {
      var _this9 = this;

      this.affiliateRepo.reset(this.$route.params.id).then(function (response) {
        _this9.affiliateStats = response.data.data;
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "vP2q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestLesson_vue__ = __webpack_require__("kQfT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc2b28d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RestLesson_vue__ = __webpack_require__("jsq9");
function injectStyle (ssrContext) {
  __webpack_require__("ceAG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fc2b28d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestLesson_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc2b28d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RestLesson_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vR+Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__ = __webpack_require__("5ObJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f0d79a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__ = __webpack_require__("o0AB");
function injectStyle (ssrContext) {
  __webpack_require__("FMUe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f0d79a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f0d79a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vUy5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vXoJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.premadeCategory.name),callback:function ($$v) {_vm.$set(_vm.premadeCategory, "name", $$v)},expression:"premadeCategory.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('multiselect',{attrs:{"label":"name","name":"test","track-by":"name","options":_vm.schools,"multiple":true,"placeholder":"Choose schools"},model:{value:(_vm.premadeCategory.schools),callback:function ($$v) {_vm.$set(_vm.premadeCategory, "schools", $$v)},expression:"premadeCategory.schools"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('span',{staticClass:"heading"},[_vm._v("Background color ")]),_vm._v(" "),_c('swatches',{attrs:{"show-border":true,"row-length":5,"popover-to":"left","show-fallback":"","colors":_vm.material},model:{value:(_vm.premadeCategory.color),callback:function ($$v) {_vm.$set(_vm.premadeCategory, "color", $$v)},expression:"premadeCategory.color"}})],1),_vm._v(" "),_c('div',{staticClass:"column is-1"},[_c('span',{staticClass:"heading"},[_vm._v("Text color ")]),_vm._v(" "),_c('swatches',{attrs:{"show-border":true,"show-fallback":"","colors":"text-basic"},model:{value:(_vm.premadeCategory.text_color),callback:function ($$v) {_vm.$set(_vm.premadeCategory, "text_color", $$v)},expression:"premadeCategory.text_color"}})],1)]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v("Premade Categories")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vb1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInfo_vue__ = __webpack_require__("mNJt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54843dd2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInfo_vue__ = __webpack_require__("an4X");
function injectStyle (ssrContext) {
  __webpack_require__("5KOb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54843dd2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54843dd2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vlJ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"provider_id","rules":"required","placeholder":"Provider id"},model:{value:(_vm.student.provider_id),callback:function ($$v) {_vm.$set(_vm.student, "provider_id", $$v)},expression:"student.provider_id"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.student.name),callback:function ($$v) {_vm.$set(_vm.student, "name", $$v)},expression:"student.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"","placeholder":"Nick"},model:{value:(_vm.student.nick),callback:function ($$v) {_vm.$set(_vm.student, "nick", $$v)},expression:"student.nick"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.student.gender),expression:"student.gender"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.student, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"male"}},[_vm._v("male")]),_vm._v(" "),_c('option',{attrs:{"value":"female"}},[_vm._v("female")])])])])]),_vm._v(" "),(_vm.schools && _vm.schools.length > 0)?_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.student.school_id),expression:"student.school_id"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.student, "school_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.schools),function(school){return _c('option',{domProps:{"value":school.id}},[_vm._v(_vm._s(school.name))])}),0)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-user-circle"}),_vm._v(" Students")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vtOW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__("SJrb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66ef8c7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__("TuvA");
function injectStyle (ssrContext) {
  __webpack_require__("ogM9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66ef8c7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66ef8c7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wFDd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_NewsRepo__ = __webpack_require__("O7DD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'news-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false },
        pivot: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Title',
                key: 'title'
            }, {
                name: 'Description',
                key: 'description'
            }, {
                name: 'Type',
                key: 'type'
            }],
            reverse: true,
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_NewsRepo__["a" /* default */](this.$auth)
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        show: function show(id) {
            this.$router.push('/dashboard/news/' + id);
        },
        showDeleteModal: function showDeleteModal(event, id, index) {
            event.stopPropagation();
            var self = this;
            this.$swal({
                title: 'Are you sure?',
                text: "This will delete this news permanently!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3273dc',
                cancelButtonColor: '#ff3860',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    self.deleteNews(id, index);
                }
            }).catch(function (result) {});
        },
        deleteNews: function deleteNews(id, index) {
            var _this = this;

            this.repo.delete(id).then(function (response) {
                _this.items.splice(index, 1);
                _this.$swal('Deleted!', 'News has been deleted.', 'success');
            });
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "wH9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-progress-bar'),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wjf3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"password-reset"}},[_c('section',{staticClass:"hero is-success is-fullheight"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('div',{staticClass:"column is-4 is-offset-4"},[_c('h3',{staticClass:"title has-text-grey"},[_vm._v("Reset your password")]),_vm._v(" "),_c('p',{staticClass:"subtitle has-text-grey"}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('figure',{staticClass:"avatar"},[_c('img',{attrs:{"src":'/static/img/logo.png'}})]),_vm._v(" "),_c('form',[_c('div',{staticClass:"title is-5 has-text-left has-text-grey-dark"},[_vm._v(" Enter your details below ")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"email","rules":"required|email","placeholder":"Your email"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"type":"password","name":"password","rules":"required|min:6","placeholder":"Your password"},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"type":"password","name":"password_confirmation","rules":"required","placeholder":"Confirm your password"},model:{value:(_vm.user.password_confirmation),callback:function ($$v) {_vm.$set(_vm.user, "password_confirmation", $$v)},expression:"user.password_confirmation"}})],1),_vm._v(" "),_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-danger"},on:{"click":function($event){_vm.passwordReset()}}},[_vm._v("Reset my password")])],1)]),_vm._v(" "),_c('p',{staticClass:"has-text-grey"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("\n                  Login\n              ")]),_vm._v("  · \n              "),_c('router-link',{attrs:{"to":"/forgot/password"}},[_vm._v("\n                  Forgot password?\n              ")])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wqn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_CommentRepo__ = __webpack_require__("V/pO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table__ = __webpack_require__("yh4F");
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'comments-view',
    components: { CommentsTable: __WEBPACK_IMPORTED_MODULE_2__Table__["a" /* default */] },
    data: function data() {
        return {
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_CommentRepo__["a" /* default */](this.$auth),
            comments: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1
        };
    },
    created: function created() {
        this.getUsers();
    },

    methods: {
        onSearch: function onSearch(q) {
            this.page = 1;
            this.q = q;
            this.getUsers();
        },
        onOrderBy: function onOrderBy(orderBy) {
            this.page = 1;
            this.orderBy = orderBy;
            this.getUsers();
        },
        onPageChanged: function onPageChanged(page) {
            this.page = page;
            this.getUsers();
        },
        getUsers: function getUsers() {
            var _this = this;

            this.repo.paginate(this.page, this.q, this.orderBy).then(function (response) {
                _this.comments = response.data.data;
                _this.total = response.data.meta.pagination.total_pages;
            });
        }
    },
    watch: {}

});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {},
  created: function created() {}
});

/***/ }),

/***/ "xJG8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xKmg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_LessonRepo__ = __webpack_require__("VMRg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'lessons-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false }
    },
    components: {},
    data: function data() {
        return {
            search: '',
            column: 'id',
            columns: [{
                name: '#',
                key: 'id'
            }, {
                name: 'Provider id',
                key: 'provider_id'
            }, {
                name: 'Name',
                key: 'name'
            }, {
                name: 'Words',
                key: 'words'
            }, {
                name: 'School',
                key: ''
            }],
            reverse: true,
            repo: new __WEBPACK_IMPORTED_MODULE_0__repos_LessonRepo__["a" /* default */](this.$auth)
        };
    },
    created: function created() {},

    methods: {
        sortBy: function sortBy(column) {

            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                this.$emit("sort", this.column + "," + direction);
            }
        },
        onPageChanged: function onPageChanged(page) {
            this.$emit("pageChanged", page);
        },
        show: function show(id) {
            this.$router.push('/dashboard/lessons/' + id);
        },
        showDeleteModal: function showDeleteModal(event, id, index) {
            event.stopPropagation();
            var self = this;
            this.$swal({
                title: 'Are you sure?',
                text: "This will delete this lesson permanently!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3273dc',
                cancelButtonColor: '#ff3860',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    self.deleteLesson(id, index);
                }
            }).catch(function (result) {});
        },
        deleteLesson: function deleteLesson(id, index) {
            var _this = this;

            this.repo.delete(id).then(function (response) {
                _this.items.splice(index, 1);
                _this.$swal('Deleted!', 'Lesson has been deleted.', 'success');
            });
        }
    },
    watch: {
        'search': _.debounce(function (value) {
            this.$emit("search", value);
        }, 800)
    },
    computed: {}
});

/***/ }),

/***/ "xwSX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y4kg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repos_UserRepo__ = __webpack_require__("lyrB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_datepicker__ = __webpack_require__("Cu96");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'users-table',
    props: {
        items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: { required: false, default: false }
    },
    components: { Datepicker: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_datepicker__["a" /* default */] },
    data: function data() {
        return {
            //search: '',
            schools: [],
            column: 'users.id',
            search: {
                start_date: null,
                end_date: null,
                ll_from: null,
                ll_to: null,
                nbt_from: null,
                nbt_to: null,
                extended: "",
                paid: "",
                logged_in: null,
                schools: "",
                sub_status: null,
                sub_plan: "",
                export: false
            },
            loading: false,
            columns: [{
                name: '#',
                key: 'users.id'
            }, {
                name: 'Email',
                key: 'users.email'
            }, {
                name: 'Name',
                key: ''
            }, {
                name: 'Next bill date',
                key: ''
                //key: 'subscriptions.next_bill_date'
            }, {
                name: 'Subscription',
                key: ''
                //key: 'subscriptions.subscription_plan_id'
            }, {
                name: 'Last login',
                key: 'users.last_login'
            }, {
                name: 'Registred at',
                key: 'users.created_at'
            }],
            reverse: true,
            repo: new __WEBPACK_IMPORTED_MODULE_2__repos_UserRepo__["a" /* default */](this.$auth)
        };
    },
    created: function created() {
        this.loadSchools();
        this.filter();
    },

    methods: {
        clearSearch: function clearSearch() {
            this.search = {
                start_date: null,
                end_date: null,
                ll_from: null,
                ll_to: null,
                nbt_from: null,
                nbt_to: null,
                extended: "",
                paid: "",
                logged_in: null,
                schools: "",
                sub_status: null,
                sub_plan: "",
                export: false
            };
            this.filter();
        },
        sortBy: function sortBy(column) {
            if (column != '') {
                if (this.column == column) {
                    this.reverse = !this.reverse;
                } else {
                    this.column = column;
                }

                var direction = this.reverse ? "asc" : "desc";

                //this.$emit("sort", this.column + "," + direction);

                var search = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.search, { 'sort': this.column, 'direction': direction });
                this.search.export = false;
                this.$emit("sort", search);
            }
        },
        onPageChanged: function onPageChanged(page) {
            var search = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.search, { 'page': page });
            this.search.export = false;
            this.$emit("pageChanged", search);
        },
        filter: function filter() {
            var exp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.search.export = exp;
            this.$emit("search", this.search);
        },
        loadSchools: function loadSchools() {
            var _this = this;

            this.loading = true;
            this.schoolRepo.all().then(function (response) {
                _this.schools = response.data.data;
                _this.loading = false;
            }).catch(function (response) {
                _this.loading = false;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
            });
        }
    },
    watch: {
        /*      'search': _.debounce(function(value){
                this.$emit("search", value);
              }, 800) */
    },
    computed: {}
});

/***/ }),

/***/ "yOEb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repos_CategoryRepo__ = __webpack_require__("94/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'categories-show',
  components: {},
  data: function data() {
    return {
      repo: new __WEBPACK_IMPORTED_MODULE_0__repos_CategoryRepo__["a" /* default */](this.$auth),
      item: {}
    };
  },
  created: function created() {
    this.getCategory(this.$route.params.id);
  },

  methods: {
    getCategory: function getCategory(id) {
      var _this = this;

      this.repo.show(id).then(function (response) {
        _this.item = response.data.data;
      });
    }
  },
  watch: {}

});

/***/ }),

/***/ "yTXi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("2eNb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7d7bb76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("Yanf");
function injectStyle (ssrContext) {
  __webpack_require__("2vfZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b7d7bb76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7d7bb76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yWbn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yh4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("uZ6n");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b60dc0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("UmuT");
function injectStyle (ssrContext) {
  __webpack_require__("BBYK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b60dc0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b60dc0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yk8T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('table',{staticClass:"table is-hoverable is-bordered is-fullwidth"},[_c('thead',[_c('tr',[_vm._l((_vm.columns),function(col){return _c('th',{staticClass:"sortable",on:{"click":function($event){_vm.sortBy(col.key)}}},[_vm._v("\n                    "+_vm._s(col.name)+" \n                    "),(_vm.column == col.key && _vm.reverse)?_c('i',{staticClass:"fa fa-sort-up is-pulled-right"}):_vm._e(),_vm._v(" "),(_vm.column == col.key && !_vm.reverse)?_c('i',{staticClass:"fa fa-sort-down  is-pulled-right"}):_vm._e()])}),_vm._v(" "),(_vm.actions)?_c('th',[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{on:{"click":function($event){_vm.show(item.id)}}},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(item.caption))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(item.score))]),_vm._v(" "),(item.schools)?_c('td',[_vm._v(" "+_vm._s(Array.prototype.map.call(item.schools, function(item) { return item.name; }).join(",")))]):_c('td',[_vm._v("All schools")]),_vm._v(" "),(_vm.actions)?_c('td',{attrs:{"width":"10%"}},[_c('router-link',{staticClass:"button tooltip",attrs:{"to":{ name: 'premade-comment', params: { id: item.id }},"data-tooltip":"View"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-eye"})])]),_vm._v(" "),_c('router-link',{staticClass:"button is-warning tooltip",attrs:{"to":{ name: 'premade-comment-edit', params: { id: item.id }},"data-tooltip":"Edit"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-edit"})])]),_vm._v(" "),_c('button',{staticClass:"button is-danger tooltip",attrs:{"data-tooltip":"Delete"},on:{"click":function($event){_vm.showDeleteModal($event, item.id, index)}}},[_vm._m(1,true)])],1):_vm._e()])}),0)]),_vm._v(" "),_c('bulma-pagination',{attrs:{"current":_vm.page,"last":_vm.total},on:{"change":_vm.onPageChanged}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ynAE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ynQQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field p5"},[_c('span',{staticClass:"heading has-text-grey-dark",attrs:{"id":"filters"}},[_vm._v("Apply filter")]),_vm._v(" "),_c('div',{staticClass:"control has-icons-left has-icons-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sentence),expression:"sentence"}],staticClass:"is-primary",class:{'input': true, 'is-danger': _vm.errors.has('sentence') },attrs:{"id":"sentence","name":"sentence","type":"text","placeholder":"Start typing sentence..."},domProps:{"value":(_vm.sentence)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sentence=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade-fast"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('sentence')),expression:"errors.has('sentence')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('sentence')))])]),_vm._v(" "),_c('span',{staticClass:"icon is-small is-left"},[(!_vm.loading)?_c('i',{staticClass:"fa fa-search"}):_c('i',{staticClass:"fa fa-spinner fa-spin"})])],1)])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('category-list',{attrs:{"categories":_vm.premadeCategories},on:{"click":_vm.togleCategoryFilter}})],1)]),_vm._v(" "),_c('div',{staticClass:"columns is-mutiline"},[_c('div',{staticClass:"column is-5"},[_c('div',{staticClass:"columns is-mutiline box minimal-horizontal-padding"},[_c('div',{staticClass:"column is-12 minimal-vertical-margin minimal-vertical-padding"},[_c('p',{staticClass:"subtitle is-5 minimal-vertical-margin"},[_vm._v("Search results:")]),_vm._v(" "),_c('draggable',{staticClass:"scroll-y minimal-horizontal-padding",attrs:{"element":"div","options":{group:{ name:'sentences',  pull:'clone', put:false }}},model:{value:(_vm.filteredSentences),callback:function ($$v) {_vm.filteredSentences=$$v},expression:"filteredSentences"}},_vm._l((_vm.filteredSentences),function(sentence,index){return _c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#filters'),expression:"'#filters'"}],staticClass:"card float-left column is-12 is-12-mobile clickable minimal-vertical-margin minimal-vertical-padding",attrs:{"data-tour-com-step":"6"},on:{"click":function($event){_vm.addSentence(sentence)}}},[_c('div',{staticClass:"card-content is-paddingless"},[_c('div',{staticClass:"columns is-desktop is-multiline minimal-vertical-margin minimal-vertical-padding"},[_c('div',{staticClass:"column is-9 is-12-mobile content minimal-vertical-padding"},[_c('p',{staticClass:"has-text-grey-dark is-size-6 multiline-text"},[_vm._v(" "+_vm._s(sentence.text)+" ")])]),_vm._v(" "),_c('div',{staticClass:"column is-3 is-12-mobile"},_vm._l((sentence.premadeCategories),function(category){return _c('span',[_c('category-tag',{attrs:{"category":category}})],1)}),0)])])])}),0)],1)])]),_vm._v(" "),_c('div',{staticClass:"column is-7"},[_c('div',{staticClass:"columns is-multiline box"},[_c('p',{staticClass:"subtitle is-5 minimal-vertical-margin"},[_vm._v("Selected sentences:")]),_vm._v(" "),_c('draggable',{staticClass:"tags conjuncts column is-12 minimal-vertical-padding minimal-vertical-margin",attrs:{"element":"div","options":{group:{ name:'sentences',  pull:'clone', put:false }}},model:{value:(_vm.helperArrays.joiners()),callback:function ($$v) {_vm.$set(_vm.helperArrays, "joiners()", $$v)},expression:"helperArrays.joiners()"}},_vm._l((_vm.helperArrays.joiners()),function(joiner){return _c('span',{staticClass:"tag float-left is-light height-min-content zero-vertical-margin sentence-font-size",on:{"click":function($event){_vm.addSentence(joiner)}}},[_vm._v(_vm._s(joiner.text))])}),0),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"message max-height-300"},[_c('div',{staticClass:"message-body content minimal-vertical-padding minimal-horizontal-padding comment-sentences"},[_c('a',{staticClass:"delete is-small is-pulled-right",on:{"click":function($event){_vm.clearChoosedSentences()}}}),_vm._v(" "),_c('draggable',{staticClass:"display-inline-block draggable max-height-300 field is-grouped is-grouped-multiline overflow-y-auto",attrs:{"element":"div","list":_vm.choosedSentences,"options":{group:{ name:'sentences'}}},on:{"change":_vm.generateComment}},_vm._l((_vm.choosedSentences),function(sentence,index){return _c('div',{key:index,staticClass:"tags float-left has-addons height-min-content minimal-horizontal-padding minimal-vertical-margin"},[_c('sentence-tag',{key:index,attrs:{"sentence":sentence,"text":sentence.text}}),_vm._v(" "),_c('a',{staticClass:"tag is-delete zero-vertical-margin",on:{"click":function($event){_vm.deleteSentence(index)}}})],1)}),0)],1)])])],1),_vm._v(" "),_c('div',{staticClass:"columns is-multiline box"},[_c('p',{staticClass:"subtitle is-5 minimal-vertical-margin"},[_vm._v("Generated text:")]),_vm._v(" "),_c('div',{staticClass:"column is-12 "},[_c('pre',{staticClass:"editor-pre"},[_c('div',{ref:"editor",staticClass:"multiline-text editor",attrs:{"contenteditable":"true"},on:{"contextmenu":function($event){$event.preventDefault();return _vm.$refs.ctxMenu.open($event)}}})]),_vm._v(" "),_c('div',{staticClass:"field",staticStyle:{"margin-top":"20px"}},[_c('multiselect',{attrs:{"placeholder":"Choose school","label":"name","track-by":"name","name":"schools","options":_vm.schools,"multiple":true},model:{value:(_vm.premadeComment.schools),callback:function ($$v) {_vm.$set(_vm.premadeComment, "schools", $$v)},expression:"premadeComment.schools"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('a',{staticClass:"button is-block is-primary",on:{"click":function($event){_vm.showSaveModal = true}}},[_vm._m(2),_vm._v(" "),_c('span',[_vm._v("Save template")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal",class:{'is-active': _vm.showSaveModal}},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Save Comment")]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.showSaveModal = false}}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"field"},[_c('span',{staticClass:"heading has-text-grey"},[_vm._v("Give caption to your comment so you can find it more easily:")]),_vm._v(" "),_c('bulma-input',{attrs:{"name":"caption","rules":"required","placeholder":"Comment caption"},model:{value:(_vm.premadeComment.caption),callback:function ($$v) {_vm.$set(_vm.premadeComment, "caption", $$v)},expression:"premadeComment.caption"}})],1),_vm._v(" "),_c('div',{staticClass:"field"},[_c('span',{staticClass:"heading has-text-grey"},[_vm._v("This comment is meant for students with what score?")]),_vm._v(" "),_c('star-rating',{attrs:{"inactive-color":"#ababab","star-size":30,"show-rating":false,"rating":_vm.premadeComment.score},on:{"rating-selected":function($event){_vm.premadeComment.score = $event}}})],1)]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot has-text-right"},[_c('loading-button',{attrs:{"loading":_vm.saveCommentLoading,"color":"is-primary"},on:{"click":function($event){_vm.saveComment()}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"button is-danger is-pulled-right",on:{"click":function($event){_vm.showSaveModal = false}}},[_vm._v("Cancel")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v(" Comments")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-6"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-star"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ytC3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"box columns is-multiline"},[_c('div',{staticClass:"column"},[_c('users-table',{attrs:{"page":_vm.page,"total":_vm.total,"items":_vm.users,"actions":true},on:{"search":_vm.onSearch,"sort":_vm.onOrderBy,"pageChanged":_vm.onPageChanged}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-file-excel-o"}),_vm._v("  Export users")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z/A4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field has-addons is-inline-block"},[(_vm.draggable)?_c('draggable',{on:{"end":_vm.end},model:{value:(_vm.newCategories),callback:function ($$v) {_vm.newCategories=$$v},expression:"newCategories"}},[_c('transition-group',_vm._l((_vm.categories),function(category,index){return _c('div',{key:category.id + '' + index + category.color + category.text_color,staticClass:"control is-pulled-left"},[_c('category-item',{attrs:{"selected":true,"category":category},on:{"click":_vm.selectCategory}})],1)}),0)],1):_vm._l((_vm.categories),function(category){return _c('div',{staticClass:"control float-left"},[_c('category-item',{attrs:{"selected":_vm.inCategoryFilters(category) != -1,"category":category},on:{"click":_vm.togleCategoryFilter}})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zBwC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zMJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("ivyW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2a1a546_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("lVCv");
function injectStyle (ssrContext) {
  __webpack_require__("D7Mm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c2a1a546"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2a1a546_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zOf3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"provider_id","rules":"required","placeholder":"Provider id"},model:{value:(_vm.lesson.provider_id),callback:function ($$v) {_vm.$set(_vm.lesson, "provider_id", $$v)},expression:"lesson.provider_id"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.lesson.name),callback:function ($$v) {_vm.$set(_vm.lesson, "name", $$v)},expression:"lesson.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Words"},model:{value:(_vm.lesson.words),callback:function ($$v) {_vm.$set(_vm.lesson, "words", $$v)},expression:"lesson.words"}})],1)]),_vm._v(" "),(_vm.schools && _vm.schools.length > 0)?_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.lesson.school_id),expression:"lesson.school_id"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.lesson, "school_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.schools),function(school){return _c('option',{domProps:{"value":school.id}},[_vm._v(_vm._s(school.name))])}),0)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" Lessons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zTKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryItem_vue__ = __webpack_require__("BSY3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09301ddb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryItem_vue__ = __webpack_require__("WK54");
function injectStyle (ssrContext) {
  __webpack_require__("CqXx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09301ddb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09301ddb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zVUp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',{staticClass:"box"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Name"},model:{value:(_vm.magicWord.name),callback:function ($$v) {_vm.$set(_vm.magicWord, "name", $$v)},expression:"magicWord.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"title","rules":"required","placeholder":"Title"},model:{value:(_vm.magicWord.title),callback:function ($$v) {_vm.$set(_vm.magicWord, "title", $$v)},expression:"magicWord.title"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"placeholder","rules":"required","placeholder":"Placeholder"},model:{value:(_vm.magicWord.placeholder),callback:function ($$v) {_vm.$set(_vm.magicWord, "placeholder", $$v)},expression:"magicWord.placeholder"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"description","rules":"required","placeholder":"Description"},model:{value:(_vm.magicWord.description),callback:function ($$v) {_vm.$set(_vm.magicWord, "description", $$v)},expression:"magicWord.description"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-4"},[_c('div',{staticClass:"field"},[_c('multiselect',{attrs:{"label":"name","name":"schools","track-by":"name","options":_vm.schools,"multiple":true,"placeholder":"Choose schools"},model:{value:(_vm.magicWord.schools),callback:function ($$v) {_vm.$set(_vm.magicWord, "schools", $$v)},expression:"magicWord.schools"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-2"},[_c('div',{staticClass:"field"},[_c('multiselect',{attrs:{"name":"types","options":['input', 'textarea'],"multiple":false,"placeholder":"Field type"},model:{value:(_vm.magicWord.type),callback:function ($$v) {_vm.$set(_vm.magicWord, "type", $$v)},expression:"magicWord.type"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-th-list"}),_vm._v("Premade Categories")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                        Back\n                    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zlxJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__("yEsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__repos_Repo__ = __webpack_require__("7vHs");






/**
 * Created by ndzak on 4/23/2016.
 */



var PremadeCommentRepo = function (_Repo) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(PremadeCommentRepo, _Repo);

    function PremadeCommentRepo($auth) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PremadeCommentRepo);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PremadeCommentRepo.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PremadeCommentRepo)).call(this, $auth, 'premade-comments'));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PremadeCommentRepo, [{
        key: 'all',
        value: function all(q) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(PremadeCommentRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PremadeCommentRepo.prototype), 'all', this).call(this, q, "");
        }
    }, {
        key: 'store',
        value: function store(data) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(PremadeCommentRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PremadeCommentRepo.prototype), 'store', this).call(this, data, "");
        }
    }, {
        key: 'update',
        value: function update(id, data) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(PremadeCommentRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PremadeCommentRepo.prototype), 'update', this).call(this, id, data, "");
        }
    }, {
        key: 'get',
        value: function get(id) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(PremadeCommentRepo.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PremadeCommentRepo.prototype), 'get', this).call(this, id, "");
        }
    }]);

    return PremadeCommentRepo;
}(__WEBPACK_IMPORTED_MODULE_6__repos_Repo__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PremadeCommentRepo);

/***/ }),

/***/ "zq20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("xKmg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adfd586c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("7uSr");
function injectStyle (ssrContext) {
  __webpack_require__("F5Ud")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-adfd586c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adfd586c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zwA8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('form',[_c('div',{staticClass:"columns box is-multiline"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('bulma-input',{attrs:{"name":"name","rules":"required","placeholder":"Title"},model:{value:(_vm.news.title),callback:function ($$v) {_vm.$set(_vm.news, "title", $$v)},expression:"news.title"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.news.type),expression:"news.type"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.news, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"update"}},[_vm._v("update")]),_vm._v(" "),_c('option',{attrs:{"value":"coupon"}},[_vm._v("coupon")]),_vm._v(" "),_c('option',{attrs:{"value":"subscription"}},[_vm._v("subscription")]),_vm._v(" "),_c('option',{attrs:{"value":"alert"}},[_vm._v("alert")])])])])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.news.description),expression:"news.description"}],staticClass:"textarea",attrs:{"name":"description","rules":"","placeholder":"Description"},domProps:{"value":(_vm.news.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.news, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"field"},[_c('editor',{attrs:{"content":_vm.content,"lang":'html',"height":'500px',"theme":'monokai',"sync":true}})],1)])]),_vm._v(" "),_c('div',{staticClass:"columns box is-multiline"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.news.text)}})])]),_vm._v(" "),_c('div',{staticClass:"columns box is-multiline"},[_c('div',{staticClass:"column is-2"},[_c('loading-button',{attrs:{"loading":_vm.loading,"color":"is-info"},on:{"click":function($event){_vm.save()}}},[_vm._v("Save")])],1),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title has-text-grey-dark",attrs:{"id":"title"}},[_c('i',{staticClass:"fa fa-bullhorn"}),_vm._v(" News")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-2 is-offset-8 is-pulled-right"},[_c('a',{staticClass:"button is-block",attrs:{"href":"javascript:history.go(-1)"}},[_vm._v("\n                    Back\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.fa8ae80528f47f70ab63.js